/* eslint-disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | undefined;
export type InputMaybe<T> = T | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: string;
};

export type Account = {
  readonly __typename?: 'Account';
  readonly access_token?: Maybe<Scalars['String']>;
  readonly expires_at?: Maybe<Scalars['Int']>;
  readonly id: Scalars['String'];
  readonly id_token?: Maybe<Scalars['String']>;
  readonly oauth_token?: Maybe<Scalars['String']>;
  readonly oauth_token_secret?: Maybe<Scalars['String']>;
  readonly provider: Scalars['String'];
  readonly providerAccountId: Scalars['String'];
  readonly refresh_token?: Maybe<Scalars['String']>;
  readonly refresh_token_expires_in?: Maybe<Scalars['Int']>;
  readonly scope?: Maybe<Scalars['String']>;
  readonly session_state?: Maybe<Scalars['String']>;
  readonly token_type?: Maybe<Scalars['String']>;
  readonly type: Scalars['String'];
  readonly user: User;
  readonly userId: Scalars['String'];
};

export type AccountAvgAggregate = {
  readonly __typename?: 'AccountAvgAggregate';
  readonly expires_at?: Maybe<Scalars['Float']>;
  readonly refresh_token_expires_in?: Maybe<Scalars['Float']>;
};

export type AccountAvgOrderByAggregateInput = {
  readonly expires_at?: InputMaybe<SortOrder>;
  readonly refresh_token_expires_in?: InputMaybe<SortOrder>;
};

export type AccountCountAggregate = {
  readonly __typename?: 'AccountCountAggregate';
  readonly _all: Scalars['Int'];
  readonly access_token: Scalars['Int'];
  readonly expires_at: Scalars['Int'];
  readonly id: Scalars['Int'];
  readonly id_token: Scalars['Int'];
  readonly oauth_token: Scalars['Int'];
  readonly oauth_token_secret: Scalars['Int'];
  readonly provider: Scalars['Int'];
  readonly providerAccountId: Scalars['Int'];
  readonly refresh_token: Scalars['Int'];
  readonly refresh_token_expires_in: Scalars['Int'];
  readonly scope: Scalars['Int'];
  readonly session_state: Scalars['Int'];
  readonly token_type: Scalars['Int'];
  readonly type: Scalars['Int'];
  readonly userId: Scalars['Int'];
};

export type AccountCountOrderByAggregateInput = {
  readonly access_token?: InputMaybe<SortOrder>;
  readonly expires_at?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly id_token?: InputMaybe<SortOrder>;
  readonly oauth_token?: InputMaybe<SortOrder>;
  readonly oauth_token_secret?: InputMaybe<SortOrder>;
  readonly provider?: InputMaybe<SortOrder>;
  readonly providerAccountId?: InputMaybe<SortOrder>;
  readonly refresh_token?: InputMaybe<SortOrder>;
  readonly refresh_token_expires_in?: InputMaybe<SortOrder>;
  readonly scope?: InputMaybe<SortOrder>;
  readonly session_state?: InputMaybe<SortOrder>;
  readonly token_type?: InputMaybe<SortOrder>;
  readonly type?: InputMaybe<SortOrder>;
  readonly userId?: InputMaybe<SortOrder>;
};

export type AccountCreateInput = {
  readonly access_token?: InputMaybe<Scalars['String']>;
  readonly expires_at?: InputMaybe<Scalars['Int']>;
  readonly id?: InputMaybe<Scalars['String']>;
  readonly id_token?: InputMaybe<Scalars['String']>;
  readonly oauth_token?: InputMaybe<Scalars['String']>;
  readonly oauth_token_secret?: InputMaybe<Scalars['String']>;
  readonly provider: Scalars['String'];
  readonly providerAccountId: Scalars['String'];
  readonly refresh_token?: InputMaybe<Scalars['String']>;
  readonly refresh_token_expires_in?: InputMaybe<Scalars['Int']>;
  readonly scope?: InputMaybe<Scalars['String']>;
  readonly session_state?: InputMaybe<Scalars['String']>;
  readonly token_type?: InputMaybe<Scalars['String']>;
  readonly type: Scalars['String'];
  readonly user: UserCreateNestedOneWithoutAccountsInput;
};

export type AccountCreateManyInput = {
  readonly access_token?: InputMaybe<Scalars['String']>;
  readonly expires_at?: InputMaybe<Scalars['Int']>;
  readonly id?: InputMaybe<Scalars['String']>;
  readonly id_token?: InputMaybe<Scalars['String']>;
  readonly oauth_token?: InputMaybe<Scalars['String']>;
  readonly oauth_token_secret?: InputMaybe<Scalars['String']>;
  readonly provider: Scalars['String'];
  readonly providerAccountId: Scalars['String'];
  readonly refresh_token?: InputMaybe<Scalars['String']>;
  readonly refresh_token_expires_in?: InputMaybe<Scalars['Int']>;
  readonly scope?: InputMaybe<Scalars['String']>;
  readonly session_state?: InputMaybe<Scalars['String']>;
  readonly token_type?: InputMaybe<Scalars['String']>;
  readonly type: Scalars['String'];
  readonly userId: Scalars['String'];
};

export type AccountCreateManyUserInput = {
  readonly access_token?: InputMaybe<Scalars['String']>;
  readonly expires_at?: InputMaybe<Scalars['Int']>;
  readonly id?: InputMaybe<Scalars['String']>;
  readonly id_token?: InputMaybe<Scalars['String']>;
  readonly oauth_token?: InputMaybe<Scalars['String']>;
  readonly oauth_token_secret?: InputMaybe<Scalars['String']>;
  readonly provider: Scalars['String'];
  readonly providerAccountId: Scalars['String'];
  readonly refresh_token?: InputMaybe<Scalars['String']>;
  readonly refresh_token_expires_in?: InputMaybe<Scalars['Int']>;
  readonly scope?: InputMaybe<Scalars['String']>;
  readonly session_state?: InputMaybe<Scalars['String']>;
  readonly token_type?: InputMaybe<Scalars['String']>;
  readonly type: Scalars['String'];
};

export type AccountCreateManyUserInputEnvelope = {
  readonly data: ReadonlyArray<AccountCreateManyUserInput>;
  readonly skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type AccountCreateNestedManyWithoutUserInput = {
  readonly connect?: InputMaybe<ReadonlyArray<AccountWhereUniqueInput>>;
  readonly connectOrCreate?: InputMaybe<ReadonlyArray<AccountCreateOrConnectWithoutUserInput>>;
  readonly create?: InputMaybe<ReadonlyArray<AccountCreateWithoutUserInput>>;
  readonly createMany?: InputMaybe<AccountCreateManyUserInputEnvelope>;
};

export type AccountCreateOrConnectWithoutUserInput = {
  readonly create: AccountCreateWithoutUserInput;
  readonly where: AccountWhereUniqueInput;
};

export type AccountCreateWithoutUserInput = {
  readonly access_token?: InputMaybe<Scalars['String']>;
  readonly expires_at?: InputMaybe<Scalars['Int']>;
  readonly id?: InputMaybe<Scalars['String']>;
  readonly id_token?: InputMaybe<Scalars['String']>;
  readonly oauth_token?: InputMaybe<Scalars['String']>;
  readonly oauth_token_secret?: InputMaybe<Scalars['String']>;
  readonly provider: Scalars['String'];
  readonly providerAccountId: Scalars['String'];
  readonly refresh_token?: InputMaybe<Scalars['String']>;
  readonly refresh_token_expires_in?: InputMaybe<Scalars['Int']>;
  readonly scope?: InputMaybe<Scalars['String']>;
  readonly session_state?: InputMaybe<Scalars['String']>;
  readonly token_type?: InputMaybe<Scalars['String']>;
  readonly type: Scalars['String'];
};

export type AccountGroupBy = {
  readonly __typename?: 'AccountGroupBy';
  readonly _avg?: Maybe<AccountAvgAggregate>;
  readonly _count?: Maybe<AccountCountAggregate>;
  readonly _max?: Maybe<AccountMaxAggregate>;
  readonly _min?: Maybe<AccountMinAggregate>;
  readonly _sum?: Maybe<AccountSumAggregate>;
  readonly access_token?: Maybe<Scalars['String']>;
  readonly expires_at?: Maybe<Scalars['Int']>;
  readonly id: Scalars['String'];
  readonly id_token?: Maybe<Scalars['String']>;
  readonly oauth_token?: Maybe<Scalars['String']>;
  readonly oauth_token_secret?: Maybe<Scalars['String']>;
  readonly provider: Scalars['String'];
  readonly providerAccountId: Scalars['String'];
  readonly refresh_token?: Maybe<Scalars['String']>;
  readonly refresh_token_expires_in?: Maybe<Scalars['Int']>;
  readonly scope?: Maybe<Scalars['String']>;
  readonly session_state?: Maybe<Scalars['String']>;
  readonly token_type?: Maybe<Scalars['String']>;
  readonly type: Scalars['String'];
  readonly userId: Scalars['String'];
};

export type AccountListRelationFilter = {
  readonly every?: InputMaybe<AccountWhereInput>;
  readonly none?: InputMaybe<AccountWhereInput>;
  readonly some?: InputMaybe<AccountWhereInput>;
};

export type AccountMaxAggregate = {
  readonly __typename?: 'AccountMaxAggregate';
  readonly access_token?: Maybe<Scalars['String']>;
  readonly expires_at?: Maybe<Scalars['Int']>;
  readonly id?: Maybe<Scalars['String']>;
  readonly id_token?: Maybe<Scalars['String']>;
  readonly oauth_token?: Maybe<Scalars['String']>;
  readonly oauth_token_secret?: Maybe<Scalars['String']>;
  readonly provider?: Maybe<Scalars['String']>;
  readonly providerAccountId?: Maybe<Scalars['String']>;
  readonly refresh_token?: Maybe<Scalars['String']>;
  readonly refresh_token_expires_in?: Maybe<Scalars['Int']>;
  readonly scope?: Maybe<Scalars['String']>;
  readonly session_state?: Maybe<Scalars['String']>;
  readonly token_type?: Maybe<Scalars['String']>;
  readonly type?: Maybe<Scalars['String']>;
  readonly userId?: Maybe<Scalars['String']>;
};

export type AccountMaxOrderByAggregateInput = {
  readonly access_token?: InputMaybe<SortOrder>;
  readonly expires_at?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly id_token?: InputMaybe<SortOrder>;
  readonly oauth_token?: InputMaybe<SortOrder>;
  readonly oauth_token_secret?: InputMaybe<SortOrder>;
  readonly provider?: InputMaybe<SortOrder>;
  readonly providerAccountId?: InputMaybe<SortOrder>;
  readonly refresh_token?: InputMaybe<SortOrder>;
  readonly refresh_token_expires_in?: InputMaybe<SortOrder>;
  readonly scope?: InputMaybe<SortOrder>;
  readonly session_state?: InputMaybe<SortOrder>;
  readonly token_type?: InputMaybe<SortOrder>;
  readonly type?: InputMaybe<SortOrder>;
  readonly userId?: InputMaybe<SortOrder>;
};

export type AccountMinAggregate = {
  readonly __typename?: 'AccountMinAggregate';
  readonly access_token?: Maybe<Scalars['String']>;
  readonly expires_at?: Maybe<Scalars['Int']>;
  readonly id?: Maybe<Scalars['String']>;
  readonly id_token?: Maybe<Scalars['String']>;
  readonly oauth_token?: Maybe<Scalars['String']>;
  readonly oauth_token_secret?: Maybe<Scalars['String']>;
  readonly provider?: Maybe<Scalars['String']>;
  readonly providerAccountId?: Maybe<Scalars['String']>;
  readonly refresh_token?: Maybe<Scalars['String']>;
  readonly refresh_token_expires_in?: Maybe<Scalars['Int']>;
  readonly scope?: Maybe<Scalars['String']>;
  readonly session_state?: Maybe<Scalars['String']>;
  readonly token_type?: Maybe<Scalars['String']>;
  readonly type?: Maybe<Scalars['String']>;
  readonly userId?: Maybe<Scalars['String']>;
};

export type AccountMinOrderByAggregateInput = {
  readonly access_token?: InputMaybe<SortOrder>;
  readonly expires_at?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly id_token?: InputMaybe<SortOrder>;
  readonly oauth_token?: InputMaybe<SortOrder>;
  readonly oauth_token_secret?: InputMaybe<SortOrder>;
  readonly provider?: InputMaybe<SortOrder>;
  readonly providerAccountId?: InputMaybe<SortOrder>;
  readonly refresh_token?: InputMaybe<SortOrder>;
  readonly refresh_token_expires_in?: InputMaybe<SortOrder>;
  readonly scope?: InputMaybe<SortOrder>;
  readonly session_state?: InputMaybe<SortOrder>;
  readonly token_type?: InputMaybe<SortOrder>;
  readonly type?: InputMaybe<SortOrder>;
  readonly userId?: InputMaybe<SortOrder>;
};

export type AccountOrderByRelationAggregateInput = {
  readonly _count?: InputMaybe<SortOrder>;
};

export type AccountOrderByWithAggregationInput = {
  readonly _avg?: InputMaybe<AccountAvgOrderByAggregateInput>;
  readonly _count?: InputMaybe<AccountCountOrderByAggregateInput>;
  readonly _max?: InputMaybe<AccountMaxOrderByAggregateInput>;
  readonly _min?: InputMaybe<AccountMinOrderByAggregateInput>;
  readonly _sum?: InputMaybe<AccountSumOrderByAggregateInput>;
  readonly access_token?: InputMaybe<SortOrder>;
  readonly expires_at?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly id_token?: InputMaybe<SortOrder>;
  readonly oauth_token?: InputMaybe<SortOrder>;
  readonly oauth_token_secret?: InputMaybe<SortOrder>;
  readonly provider?: InputMaybe<SortOrder>;
  readonly providerAccountId?: InputMaybe<SortOrder>;
  readonly refresh_token?: InputMaybe<SortOrder>;
  readonly refresh_token_expires_in?: InputMaybe<SortOrder>;
  readonly scope?: InputMaybe<SortOrder>;
  readonly session_state?: InputMaybe<SortOrder>;
  readonly token_type?: InputMaybe<SortOrder>;
  readonly type?: InputMaybe<SortOrder>;
  readonly userId?: InputMaybe<SortOrder>;
};

export type AccountOrderByWithRelationInput = {
  readonly access_token?: InputMaybe<SortOrder>;
  readonly expires_at?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly id_token?: InputMaybe<SortOrder>;
  readonly oauth_token?: InputMaybe<SortOrder>;
  readonly oauth_token_secret?: InputMaybe<SortOrder>;
  readonly provider?: InputMaybe<SortOrder>;
  readonly providerAccountId?: InputMaybe<SortOrder>;
  readonly refresh_token?: InputMaybe<SortOrder>;
  readonly refresh_token_expires_in?: InputMaybe<SortOrder>;
  readonly scope?: InputMaybe<SortOrder>;
  readonly session_state?: InputMaybe<SortOrder>;
  readonly token_type?: InputMaybe<SortOrder>;
  readonly type?: InputMaybe<SortOrder>;
  readonly user?: InputMaybe<UserOrderByWithRelationInput>;
  readonly userId?: InputMaybe<SortOrder>;
};

export type AccountProviderProviderAccountIdCompoundUniqueInput = {
  readonly provider: Scalars['String'];
  readonly providerAccountId: Scalars['String'];
};

export const AccountScalarFieldEnum = {
  AccessToken: 'access_token',
  ExpiresAt: 'expires_at',
  Id: 'id',
  IdToken: 'id_token',
  OauthToken: 'oauth_token',
  OauthTokenSecret: 'oauth_token_secret',
  Provider: 'provider',
  ProviderAccountId: 'providerAccountId',
  RefreshToken: 'refresh_token',
  RefreshTokenExpiresIn: 'refresh_token_expires_in',
  Scope: 'scope',
  SessionState: 'session_state',
  TokenType: 'token_type',
  Type: 'type',
  UserId: 'userId'
} as const;

export type AccountScalarFieldEnum = typeof AccountScalarFieldEnum[keyof typeof AccountScalarFieldEnum];
export type AccountScalarWhereInput = {
  readonly AND?: InputMaybe<ReadonlyArray<AccountScalarWhereInput>>;
  readonly NOT?: InputMaybe<ReadonlyArray<AccountScalarWhereInput>>;
  readonly OR?: InputMaybe<ReadonlyArray<AccountScalarWhereInput>>;
  readonly access_token?: InputMaybe<StringNullableFilter>;
  readonly expires_at?: InputMaybe<IntNullableFilter>;
  readonly id?: InputMaybe<StringFilter>;
  readonly id_token?: InputMaybe<StringNullableFilter>;
  readonly oauth_token?: InputMaybe<StringNullableFilter>;
  readonly oauth_token_secret?: InputMaybe<StringNullableFilter>;
  readonly provider?: InputMaybe<StringFilter>;
  readonly providerAccountId?: InputMaybe<StringFilter>;
  readonly refresh_token?: InputMaybe<StringNullableFilter>;
  readonly refresh_token_expires_in?: InputMaybe<IntNullableFilter>;
  readonly scope?: InputMaybe<StringNullableFilter>;
  readonly session_state?: InputMaybe<StringNullableFilter>;
  readonly token_type?: InputMaybe<StringNullableFilter>;
  readonly type?: InputMaybe<StringFilter>;
  readonly userId?: InputMaybe<StringFilter>;
};

export type AccountScalarWhereWithAggregatesInput = {
  readonly AND?: InputMaybe<ReadonlyArray<AccountScalarWhereWithAggregatesInput>>;
  readonly NOT?: InputMaybe<ReadonlyArray<AccountScalarWhereWithAggregatesInput>>;
  readonly OR?: InputMaybe<ReadonlyArray<AccountScalarWhereWithAggregatesInput>>;
  readonly access_token?: InputMaybe<StringNullableWithAggregatesFilter>;
  readonly expires_at?: InputMaybe<IntNullableWithAggregatesFilter>;
  readonly id?: InputMaybe<StringWithAggregatesFilter>;
  readonly id_token?: InputMaybe<StringNullableWithAggregatesFilter>;
  readonly oauth_token?: InputMaybe<StringNullableWithAggregatesFilter>;
  readonly oauth_token_secret?: InputMaybe<StringNullableWithAggregatesFilter>;
  readonly provider?: InputMaybe<StringWithAggregatesFilter>;
  readonly providerAccountId?: InputMaybe<StringWithAggregatesFilter>;
  readonly refresh_token?: InputMaybe<StringNullableWithAggregatesFilter>;
  readonly refresh_token_expires_in?: InputMaybe<IntNullableWithAggregatesFilter>;
  readonly scope?: InputMaybe<StringNullableWithAggregatesFilter>;
  readonly session_state?: InputMaybe<StringNullableWithAggregatesFilter>;
  readonly token_type?: InputMaybe<StringNullableWithAggregatesFilter>;
  readonly type?: InputMaybe<StringWithAggregatesFilter>;
  readonly userId?: InputMaybe<StringWithAggregatesFilter>;
};

export type AccountSumAggregate = {
  readonly __typename?: 'AccountSumAggregate';
  readonly expires_at?: Maybe<Scalars['Int']>;
  readonly refresh_token_expires_in?: Maybe<Scalars['Int']>;
};

export type AccountSumOrderByAggregateInput = {
  readonly expires_at?: InputMaybe<SortOrder>;
  readonly refresh_token_expires_in?: InputMaybe<SortOrder>;
};

export type AccountUpdateInput = {
  readonly access_token?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly expires_at?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  readonly id?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly id_token?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly oauth_token?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly oauth_token_secret?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly provider?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly providerAccountId?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly refresh_token?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly refresh_token_expires_in?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  readonly scope?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly session_state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly token_type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly type?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly user?: InputMaybe<UserUpdateOneRequiredWithoutAccountsNestedInput>;
};

export type AccountUpdateManyMutationInput = {
  readonly access_token?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly expires_at?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  readonly id?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly id_token?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly oauth_token?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly oauth_token_secret?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly provider?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly providerAccountId?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly refresh_token?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly refresh_token_expires_in?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  readonly scope?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly session_state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly token_type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly type?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type AccountUpdateManyWithWhereWithoutUserInput = {
  readonly data: AccountUpdateManyMutationInput;
  readonly where: AccountScalarWhereInput;
};

export type AccountUpdateManyWithoutUserNestedInput = {
  readonly connect?: InputMaybe<ReadonlyArray<AccountWhereUniqueInput>>;
  readonly connectOrCreate?: InputMaybe<ReadonlyArray<AccountCreateOrConnectWithoutUserInput>>;
  readonly create?: InputMaybe<ReadonlyArray<AccountCreateWithoutUserInput>>;
  readonly createMany?: InputMaybe<AccountCreateManyUserInputEnvelope>;
  readonly delete?: InputMaybe<ReadonlyArray<AccountWhereUniqueInput>>;
  readonly deleteMany?: InputMaybe<ReadonlyArray<AccountScalarWhereInput>>;
  readonly disconnect?: InputMaybe<ReadonlyArray<AccountWhereUniqueInput>>;
  readonly set?: InputMaybe<ReadonlyArray<AccountWhereUniqueInput>>;
  readonly update?: InputMaybe<ReadonlyArray<AccountUpdateWithWhereUniqueWithoutUserInput>>;
  readonly updateMany?: InputMaybe<ReadonlyArray<AccountUpdateManyWithWhereWithoutUserInput>>;
  readonly upsert?: InputMaybe<ReadonlyArray<AccountUpsertWithWhereUniqueWithoutUserInput>>;
};

export type AccountUpdateWithWhereUniqueWithoutUserInput = {
  readonly data: AccountUpdateWithoutUserInput;
  readonly where: AccountWhereUniqueInput;
};

export type AccountUpdateWithoutUserInput = {
  readonly access_token?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly expires_at?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  readonly id?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly id_token?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly oauth_token?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly oauth_token_secret?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly provider?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly providerAccountId?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly refresh_token?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly refresh_token_expires_in?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  readonly scope?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly session_state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly token_type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly type?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type AccountUpsertWithWhereUniqueWithoutUserInput = {
  readonly create: AccountCreateWithoutUserInput;
  readonly update: AccountUpdateWithoutUserInput;
  readonly where: AccountWhereUniqueInput;
};

export type AccountWhereInput = {
  readonly AND?: InputMaybe<ReadonlyArray<AccountWhereInput>>;
  readonly NOT?: InputMaybe<ReadonlyArray<AccountWhereInput>>;
  readonly OR?: InputMaybe<ReadonlyArray<AccountWhereInput>>;
  readonly access_token?: InputMaybe<StringNullableFilter>;
  readonly expires_at?: InputMaybe<IntNullableFilter>;
  readonly id?: InputMaybe<StringFilter>;
  readonly id_token?: InputMaybe<StringNullableFilter>;
  readonly oauth_token?: InputMaybe<StringNullableFilter>;
  readonly oauth_token_secret?: InputMaybe<StringNullableFilter>;
  readonly provider?: InputMaybe<StringFilter>;
  readonly providerAccountId?: InputMaybe<StringFilter>;
  readonly refresh_token?: InputMaybe<StringNullableFilter>;
  readonly refresh_token_expires_in?: InputMaybe<IntNullableFilter>;
  readonly scope?: InputMaybe<StringNullableFilter>;
  readonly session_state?: InputMaybe<StringNullableFilter>;
  readonly token_type?: InputMaybe<StringNullableFilter>;
  readonly type?: InputMaybe<StringFilter>;
  readonly user?: InputMaybe<UserRelationFilter>;
  readonly userId?: InputMaybe<StringFilter>;
};

export type AccountWhereUniqueInput = {
  readonly id?: InputMaybe<Scalars['String']>;
  readonly provider_providerAccountId?: InputMaybe<AccountProviderProviderAccountIdCompoundUniqueInput>;
};

export type AffectedRowsOutput = {
  readonly __typename?: 'AffectedRowsOutput';
  readonly count: Scalars['Int'];
};

export type AggregateAccount = {
  readonly __typename?: 'AggregateAccount';
  readonly _avg?: Maybe<AccountAvgAggregate>;
  readonly _count?: Maybe<AccountCountAggregate>;
  readonly _max?: Maybe<AccountMaxAggregate>;
  readonly _min?: Maybe<AccountMinAggregate>;
  readonly _sum?: Maybe<AccountSumAggregate>;
};

export type AggregateClient = {
  readonly __typename?: 'AggregateClient';
  readonly _count?: Maybe<ClientCountAggregate>;
  readonly _max?: Maybe<ClientMaxAggregate>;
  readonly _min?: Maybe<ClientMinAggregate>;
};

export type AggregateDevAllowedEmail = {
  readonly __typename?: 'AggregateDevAllowedEmail';
  readonly _count?: Maybe<DevAllowedEmailCountAggregate>;
  readonly _max?: Maybe<DevAllowedEmailMaxAggregate>;
  readonly _min?: Maybe<DevAllowedEmailMinAggregate>;
};

export type AggregateIgAccount = {
  readonly __typename?: 'AggregateIgAccount';
  readonly _count?: Maybe<IgAccountCountAggregate>;
  readonly _max?: Maybe<IgAccountMaxAggregate>;
  readonly _min?: Maybe<IgAccountMinAggregate>;
};

export type AggregateIgAsset = {
  readonly __typename?: 'AggregateIgAsset';
  readonly _count?: Maybe<IgAssetCountAggregate>;
  readonly _max?: Maybe<IgAssetMaxAggregate>;
  readonly _min?: Maybe<IgAssetMinAggregate>;
};

export type AggregateIgHandle = {
  readonly __typename?: 'AggregateIgHandle';
  readonly _avg?: Maybe<IgHandleAvgAggregate>;
  readonly _count?: Maybe<IgHandleCountAggregate>;
  readonly _max?: Maybe<IgHandleMaxAggregate>;
  readonly _min?: Maybe<IgHandleMinAggregate>;
  readonly _sum?: Maybe<IgHandleSumAggregate>;
};

export type AggregateSession = {
  readonly __typename?: 'AggregateSession';
  readonly _count?: Maybe<SessionCountAggregate>;
  readonly _max?: Maybe<SessionMaxAggregate>;
  readonly _min?: Maybe<SessionMinAggregate>;
};

export type AggregateTag = {
  readonly __typename?: 'AggregateTag';
  readonly _count?: Maybe<TagCountAggregate>;
  readonly _max?: Maybe<TagMaxAggregate>;
  readonly _min?: Maybe<TagMinAggregate>;
};

export type AggregateUser = {
  readonly __typename?: 'AggregateUser';
  readonly _count?: Maybe<UserCountAggregate>;
  readonly _max?: Maybe<UserMaxAggregate>;
  readonly _min?: Maybe<UserMinAggregate>;
};

export type AggregateVerificationToken = {
  readonly __typename?: 'AggregateVerificationToken';
  readonly _count?: Maybe<VerificationTokenCountAggregate>;
  readonly _max?: Maybe<VerificationTokenMaxAggregate>;
  readonly _min?: Maybe<VerificationTokenMinAggregate>;
};

export type BoolFieldUpdateOperationsInput = {
  readonly set?: InputMaybe<Scalars['Boolean']>;
};

export type BoolFilter = {
  readonly equals?: InputMaybe<Scalars['Boolean']>;
  readonly not?: InputMaybe<NestedBoolFilter>;
};

export type BoolWithAggregatesFilter = {
  readonly _count?: InputMaybe<NestedIntFilter>;
  readonly _max?: InputMaybe<NestedBoolFilter>;
  readonly _min?: InputMaybe<NestedBoolFilter>;
  readonly equals?: InputMaybe<Scalars['Boolean']>;
  readonly not?: InputMaybe<NestedBoolWithAggregatesFilter>;
};

export type Client = {
  readonly __typename?: 'Client';
  readonly _count?: Maybe<ClientCount>;
  readonly archived: Scalars['Boolean'];
  readonly archivedAt?: Maybe<Scalars['DateTime']>;
  readonly createdAt: Scalars['DateTime'];
  readonly id: Scalars['String'];
  readonly igHandles: ReadonlyArray<IgHandle>;
  readonly name: Scalars['String'];
  readonly tags: ReadonlyArray<Tag>;
  readonly updatedAt: Scalars['DateTime'];
};


export type ClientIgHandlesArgs = {
  cursor?: InputMaybe<IgHandleWhereUniqueInput>;
  distinct?: InputMaybe<ReadonlyArray<IgHandleScalarFieldEnum>>;
  orderBy?: InputMaybe<ReadonlyArray<IgHandleOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IgHandleWhereInput>;
};


export type ClientTagsArgs = {
  cursor?: InputMaybe<TagWhereUniqueInput>;
  distinct?: InputMaybe<ReadonlyArray<TagScalarFieldEnum>>;
  orderBy?: InputMaybe<ReadonlyArray<TagOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TagWhereInput>;
};

export type ClientCount = {
  readonly __typename?: 'ClientCount';
  readonly igHandles: Scalars['Int'];
  readonly tags: Scalars['Int'];
};

export type ClientCountAggregate = {
  readonly __typename?: 'ClientCountAggregate';
  readonly _all: Scalars['Int'];
  readonly archived: Scalars['Int'];
  readonly archivedAt: Scalars['Int'];
  readonly createdAt: Scalars['Int'];
  readonly id: Scalars['Int'];
  readonly name: Scalars['Int'];
  readonly updatedAt: Scalars['Int'];
};

export type ClientCountOrderByAggregateInput = {
  readonly archived?: InputMaybe<SortOrder>;
  readonly archivedAt?: InputMaybe<SortOrder>;
  readonly createdAt?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly name?: InputMaybe<SortOrder>;
  readonly updatedAt?: InputMaybe<SortOrder>;
};

export type ClientCreateInput = {
  readonly archived?: InputMaybe<Scalars['Boolean']>;
  readonly archivedAt?: InputMaybe<Scalars['DateTime']>;
  readonly createdAt?: InputMaybe<Scalars['DateTime']>;
  readonly id?: InputMaybe<Scalars['String']>;
  readonly igHandles?: InputMaybe<IgHandleCreateNestedManyWithoutIgClientsInput>;
  readonly name: Scalars['String'];
  readonly tags?: InputMaybe<TagCreateNestedManyWithoutClientInput>;
  readonly updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ClientCreateManyInput = {
  readonly archived?: InputMaybe<Scalars['Boolean']>;
  readonly archivedAt?: InputMaybe<Scalars['DateTime']>;
  readonly createdAt?: InputMaybe<Scalars['DateTime']>;
  readonly id?: InputMaybe<Scalars['String']>;
  readonly name: Scalars['String'];
  readonly updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ClientCreateNestedManyWithoutIgHandlesInput = {
  readonly connect?: InputMaybe<ReadonlyArray<ClientWhereUniqueInput>>;
  readonly connectOrCreate?: InputMaybe<ReadonlyArray<ClientCreateOrConnectWithoutIgHandlesInput>>;
  readonly create?: InputMaybe<ReadonlyArray<ClientCreateWithoutIgHandlesInput>>;
};

export type ClientCreateNestedOneWithoutTagsInput = {
  readonly connect?: InputMaybe<ClientWhereUniqueInput>;
  readonly connectOrCreate?: InputMaybe<ClientCreateOrConnectWithoutTagsInput>;
  readonly create?: InputMaybe<ClientCreateWithoutTagsInput>;
};

export type ClientCreateOrConnectWithoutIgHandlesInput = {
  readonly create: ClientCreateWithoutIgHandlesInput;
  readonly where: ClientWhereUniqueInput;
};

export type ClientCreateOrConnectWithoutTagsInput = {
  readonly create: ClientCreateWithoutTagsInput;
  readonly where: ClientWhereUniqueInput;
};

export type ClientCreateWithoutIgHandlesInput = {
  readonly archived?: InputMaybe<Scalars['Boolean']>;
  readonly archivedAt?: InputMaybe<Scalars['DateTime']>;
  readonly createdAt?: InputMaybe<Scalars['DateTime']>;
  readonly id?: InputMaybe<Scalars['String']>;
  readonly name: Scalars['String'];
  readonly tags?: InputMaybe<TagCreateNestedManyWithoutClientInput>;
  readonly updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ClientCreateWithoutTagsInput = {
  readonly archived?: InputMaybe<Scalars['Boolean']>;
  readonly archivedAt?: InputMaybe<Scalars['DateTime']>;
  readonly createdAt?: InputMaybe<Scalars['DateTime']>;
  readonly id?: InputMaybe<Scalars['String']>;
  readonly igHandles?: InputMaybe<IgHandleCreateNestedManyWithoutIgClientsInput>;
  readonly name: Scalars['String'];
  readonly updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ClientGroupBy = {
  readonly __typename?: 'ClientGroupBy';
  readonly _count?: Maybe<ClientCountAggregate>;
  readonly _max?: Maybe<ClientMaxAggregate>;
  readonly _min?: Maybe<ClientMinAggregate>;
  readonly archived: Scalars['Boolean'];
  readonly archivedAt?: Maybe<Scalars['DateTime']>;
  readonly createdAt: Scalars['DateTime'];
  readonly id: Scalars['String'];
  readonly name: Scalars['String'];
  readonly updatedAt: Scalars['DateTime'];
};

export type ClientListRelationFilter = {
  readonly every?: InputMaybe<ClientWhereInput>;
  readonly none?: InputMaybe<ClientWhereInput>;
  readonly some?: InputMaybe<ClientWhereInput>;
};

export type ClientMaxAggregate = {
  readonly __typename?: 'ClientMaxAggregate';
  readonly archived?: Maybe<Scalars['Boolean']>;
  readonly archivedAt?: Maybe<Scalars['DateTime']>;
  readonly createdAt?: Maybe<Scalars['DateTime']>;
  readonly id?: Maybe<Scalars['String']>;
  readonly name?: Maybe<Scalars['String']>;
  readonly updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClientMaxOrderByAggregateInput = {
  readonly archived?: InputMaybe<SortOrder>;
  readonly archivedAt?: InputMaybe<SortOrder>;
  readonly createdAt?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly name?: InputMaybe<SortOrder>;
  readonly updatedAt?: InputMaybe<SortOrder>;
};

export type ClientMinAggregate = {
  readonly __typename?: 'ClientMinAggregate';
  readonly archived?: Maybe<Scalars['Boolean']>;
  readonly archivedAt?: Maybe<Scalars['DateTime']>;
  readonly createdAt?: Maybe<Scalars['DateTime']>;
  readonly id?: Maybe<Scalars['String']>;
  readonly name?: Maybe<Scalars['String']>;
  readonly updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClientMinOrderByAggregateInput = {
  readonly archived?: InputMaybe<SortOrder>;
  readonly archivedAt?: InputMaybe<SortOrder>;
  readonly createdAt?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly name?: InputMaybe<SortOrder>;
  readonly updatedAt?: InputMaybe<SortOrder>;
};

export type ClientOrderByRelationAggregateInput = {
  readonly _count?: InputMaybe<SortOrder>;
};

export type ClientOrderByWithAggregationInput = {
  readonly _count?: InputMaybe<ClientCountOrderByAggregateInput>;
  readonly _max?: InputMaybe<ClientMaxOrderByAggregateInput>;
  readonly _min?: InputMaybe<ClientMinOrderByAggregateInput>;
  readonly archived?: InputMaybe<SortOrder>;
  readonly archivedAt?: InputMaybe<SortOrder>;
  readonly createdAt?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly name?: InputMaybe<SortOrder>;
  readonly updatedAt?: InputMaybe<SortOrder>;
};

export type ClientOrderByWithRelationInput = {
  readonly archived?: InputMaybe<SortOrder>;
  readonly archivedAt?: InputMaybe<SortOrder>;
  readonly createdAt?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly igHandles?: InputMaybe<IgHandleOrderByRelationAggregateInput>;
  readonly name?: InputMaybe<SortOrder>;
  readonly tags?: InputMaybe<TagOrderByRelationAggregateInput>;
  readonly updatedAt?: InputMaybe<SortOrder>;
};

export type ClientRelationFilter = {
  readonly is?: InputMaybe<ClientWhereInput>;
  readonly isNot?: InputMaybe<ClientWhereInput>;
};

export const ClientScalarFieldEnum = {
  Archived: 'archived',
  ArchivedAt: 'archivedAt',
  CreatedAt: 'createdAt',
  Id: 'id',
  Name: 'name',
  UpdatedAt: 'updatedAt'
} as const;

export type ClientScalarFieldEnum = typeof ClientScalarFieldEnum[keyof typeof ClientScalarFieldEnum];
export type ClientScalarWhereInput = {
  readonly AND?: InputMaybe<ReadonlyArray<ClientScalarWhereInput>>;
  readonly NOT?: InputMaybe<ReadonlyArray<ClientScalarWhereInput>>;
  readonly OR?: InputMaybe<ReadonlyArray<ClientScalarWhereInput>>;
  readonly archived?: InputMaybe<BoolFilter>;
  readonly archivedAt?: InputMaybe<DateTimeNullableFilter>;
  readonly createdAt?: InputMaybe<DateTimeFilter>;
  readonly id?: InputMaybe<StringFilter>;
  readonly name?: InputMaybe<StringFilter>;
  readonly updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ClientScalarWhereWithAggregatesInput = {
  readonly AND?: InputMaybe<ReadonlyArray<ClientScalarWhereWithAggregatesInput>>;
  readonly NOT?: InputMaybe<ReadonlyArray<ClientScalarWhereWithAggregatesInput>>;
  readonly OR?: InputMaybe<ReadonlyArray<ClientScalarWhereWithAggregatesInput>>;
  readonly archived?: InputMaybe<BoolWithAggregatesFilter>;
  readonly archivedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  readonly createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  readonly id?: InputMaybe<StringWithAggregatesFilter>;
  readonly name?: InputMaybe<StringWithAggregatesFilter>;
  readonly updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type ClientUpdateInput = {
  readonly archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  readonly archivedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  readonly createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  readonly id?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly igHandles?: InputMaybe<IgHandleUpdateManyWithoutIgClientsNestedInput>;
  readonly name?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly tags?: InputMaybe<TagUpdateManyWithoutClientNestedInput>;
  readonly updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ClientUpdateManyMutationInput = {
  readonly archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  readonly archivedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  readonly createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  readonly id?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly name?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ClientUpdateManyWithWhereWithoutIgHandlesInput = {
  readonly data: ClientUpdateManyMutationInput;
  readonly where: ClientScalarWhereInput;
};

export type ClientUpdateManyWithoutIgHandlesNestedInput = {
  readonly connect?: InputMaybe<ReadonlyArray<ClientWhereUniqueInput>>;
  readonly connectOrCreate?: InputMaybe<ReadonlyArray<ClientCreateOrConnectWithoutIgHandlesInput>>;
  readonly create?: InputMaybe<ReadonlyArray<ClientCreateWithoutIgHandlesInput>>;
  readonly delete?: InputMaybe<ReadonlyArray<ClientWhereUniqueInput>>;
  readonly deleteMany?: InputMaybe<ReadonlyArray<ClientScalarWhereInput>>;
  readonly disconnect?: InputMaybe<ReadonlyArray<ClientWhereUniqueInput>>;
  readonly set?: InputMaybe<ReadonlyArray<ClientWhereUniqueInput>>;
  readonly update?: InputMaybe<ReadonlyArray<ClientUpdateWithWhereUniqueWithoutIgHandlesInput>>;
  readonly updateMany?: InputMaybe<ReadonlyArray<ClientUpdateManyWithWhereWithoutIgHandlesInput>>;
  readonly upsert?: InputMaybe<ReadonlyArray<ClientUpsertWithWhereUniqueWithoutIgHandlesInput>>;
};

export type ClientUpdateOneRequiredWithoutTagsNestedInput = {
  readonly connect?: InputMaybe<ClientWhereUniqueInput>;
  readonly connectOrCreate?: InputMaybe<ClientCreateOrConnectWithoutTagsInput>;
  readonly create?: InputMaybe<ClientCreateWithoutTagsInput>;
  readonly update?: InputMaybe<ClientUpdateWithoutTagsInput>;
  readonly upsert?: InputMaybe<ClientUpsertWithoutTagsInput>;
};

export type ClientUpdateWithWhereUniqueWithoutIgHandlesInput = {
  readonly data: ClientUpdateWithoutIgHandlesInput;
  readonly where: ClientWhereUniqueInput;
};

export type ClientUpdateWithoutIgHandlesInput = {
  readonly archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  readonly archivedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  readonly createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  readonly id?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly name?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly tags?: InputMaybe<TagUpdateManyWithoutClientNestedInput>;
  readonly updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ClientUpdateWithoutTagsInput = {
  readonly archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  readonly archivedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  readonly createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  readonly id?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly igHandles?: InputMaybe<IgHandleUpdateManyWithoutIgClientsNestedInput>;
  readonly name?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ClientUpsertWithWhereUniqueWithoutIgHandlesInput = {
  readonly create: ClientCreateWithoutIgHandlesInput;
  readonly update: ClientUpdateWithoutIgHandlesInput;
  readonly where: ClientWhereUniqueInput;
};

export type ClientUpsertWithoutTagsInput = {
  readonly create: ClientCreateWithoutTagsInput;
  readonly update: ClientUpdateWithoutTagsInput;
};

export type ClientWhereInput = {
  readonly AND?: InputMaybe<ReadonlyArray<ClientWhereInput>>;
  readonly NOT?: InputMaybe<ReadonlyArray<ClientWhereInput>>;
  readonly OR?: InputMaybe<ReadonlyArray<ClientWhereInput>>;
  readonly archived?: InputMaybe<BoolFilter>;
  readonly archivedAt?: InputMaybe<DateTimeNullableFilter>;
  readonly createdAt?: InputMaybe<DateTimeFilter>;
  readonly id?: InputMaybe<StringFilter>;
  readonly igHandles?: InputMaybe<IgHandleListRelationFilter>;
  readonly name?: InputMaybe<StringFilter>;
  readonly tags?: InputMaybe<TagListRelationFilter>;
  readonly updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ClientWhereUniqueInput = {
  readonly id?: InputMaybe<Scalars['String']>;
  readonly name?: InputMaybe<Scalars['String']>;
};

export type DateTimeFieldUpdateOperationsInput = {
  readonly set?: InputMaybe<Scalars['DateTime']>;
};

export type DateTimeFilter = {
  readonly equals?: InputMaybe<Scalars['DateTime']>;
  readonly gt?: InputMaybe<Scalars['DateTime']>;
  readonly gte?: InputMaybe<Scalars['DateTime']>;
  readonly in?: InputMaybe<ReadonlyArray<Scalars['DateTime']>>;
  readonly lt?: InputMaybe<Scalars['DateTime']>;
  readonly lte?: InputMaybe<Scalars['DateTime']>;
  readonly not?: InputMaybe<NestedDateTimeFilter>;
  readonly notIn?: InputMaybe<ReadonlyArray<Scalars['DateTime']>>;
};

export type DateTimeNullableFilter = {
  readonly equals?: InputMaybe<Scalars['DateTime']>;
  readonly gt?: InputMaybe<Scalars['DateTime']>;
  readonly gte?: InputMaybe<Scalars['DateTime']>;
  readonly in?: InputMaybe<ReadonlyArray<Scalars['DateTime']>>;
  readonly lt?: InputMaybe<Scalars['DateTime']>;
  readonly lte?: InputMaybe<Scalars['DateTime']>;
  readonly not?: InputMaybe<NestedDateTimeNullableFilter>;
  readonly notIn?: InputMaybe<ReadonlyArray<Scalars['DateTime']>>;
};

export type DateTimeNullableWithAggregatesFilter = {
  readonly _count?: InputMaybe<NestedIntNullableFilter>;
  readonly _max?: InputMaybe<NestedDateTimeNullableFilter>;
  readonly _min?: InputMaybe<NestedDateTimeNullableFilter>;
  readonly equals?: InputMaybe<Scalars['DateTime']>;
  readonly gt?: InputMaybe<Scalars['DateTime']>;
  readonly gte?: InputMaybe<Scalars['DateTime']>;
  readonly in?: InputMaybe<ReadonlyArray<Scalars['DateTime']>>;
  readonly lt?: InputMaybe<Scalars['DateTime']>;
  readonly lte?: InputMaybe<Scalars['DateTime']>;
  readonly not?: InputMaybe<NestedDateTimeNullableWithAggregatesFilter>;
  readonly notIn?: InputMaybe<ReadonlyArray<Scalars['DateTime']>>;
};

export type DateTimeWithAggregatesFilter = {
  readonly _count?: InputMaybe<NestedIntFilter>;
  readonly _max?: InputMaybe<NestedDateTimeFilter>;
  readonly _min?: InputMaybe<NestedDateTimeFilter>;
  readonly equals?: InputMaybe<Scalars['DateTime']>;
  readonly gt?: InputMaybe<Scalars['DateTime']>;
  readonly gte?: InputMaybe<Scalars['DateTime']>;
  readonly in?: InputMaybe<ReadonlyArray<Scalars['DateTime']>>;
  readonly lt?: InputMaybe<Scalars['DateTime']>;
  readonly lte?: InputMaybe<Scalars['DateTime']>;
  readonly not?: InputMaybe<NestedDateTimeWithAggregatesFilter>;
  readonly notIn?: InputMaybe<ReadonlyArray<Scalars['DateTime']>>;
};

export type DevAllowedEmail = {
  readonly __typename?: 'DevAllowedEmail';
  readonly email: Scalars['String'];
  readonly id: Scalars['String'];
};

export type DevAllowedEmailCountAggregate = {
  readonly __typename?: 'DevAllowedEmailCountAggregate';
  readonly _all: Scalars['Int'];
  readonly email: Scalars['Int'];
  readonly id: Scalars['Int'];
};

export type DevAllowedEmailCountOrderByAggregateInput = {
  readonly email?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
};

export type DevAllowedEmailCreateInput = {
  readonly email: Scalars['String'];
  readonly id?: InputMaybe<Scalars['String']>;
};

export type DevAllowedEmailCreateManyInput = {
  readonly email: Scalars['String'];
  readonly id?: InputMaybe<Scalars['String']>;
};

export type DevAllowedEmailGroupBy = {
  readonly __typename?: 'DevAllowedEmailGroupBy';
  readonly _count?: Maybe<DevAllowedEmailCountAggregate>;
  readonly _max?: Maybe<DevAllowedEmailMaxAggregate>;
  readonly _min?: Maybe<DevAllowedEmailMinAggregate>;
  readonly email: Scalars['String'];
  readonly id: Scalars['String'];
};

export type DevAllowedEmailMaxAggregate = {
  readonly __typename?: 'DevAllowedEmailMaxAggregate';
  readonly email?: Maybe<Scalars['String']>;
  readonly id?: Maybe<Scalars['String']>;
};

export type DevAllowedEmailMaxOrderByAggregateInput = {
  readonly email?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
};

export type DevAllowedEmailMinAggregate = {
  readonly __typename?: 'DevAllowedEmailMinAggregate';
  readonly email?: Maybe<Scalars['String']>;
  readonly id?: Maybe<Scalars['String']>;
};

export type DevAllowedEmailMinOrderByAggregateInput = {
  readonly email?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
};

export type DevAllowedEmailOrderByWithAggregationInput = {
  readonly _count?: InputMaybe<DevAllowedEmailCountOrderByAggregateInput>;
  readonly _max?: InputMaybe<DevAllowedEmailMaxOrderByAggregateInput>;
  readonly _min?: InputMaybe<DevAllowedEmailMinOrderByAggregateInput>;
  readonly email?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
};

export type DevAllowedEmailOrderByWithRelationInput = {
  readonly email?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
};

export const DevAllowedEmailScalarFieldEnum = {
  Email: 'email',
  Id: 'id'
} as const;

export type DevAllowedEmailScalarFieldEnum = typeof DevAllowedEmailScalarFieldEnum[keyof typeof DevAllowedEmailScalarFieldEnum];
export type DevAllowedEmailScalarWhereWithAggregatesInput = {
  readonly AND?: InputMaybe<ReadonlyArray<DevAllowedEmailScalarWhereWithAggregatesInput>>;
  readonly NOT?: InputMaybe<ReadonlyArray<DevAllowedEmailScalarWhereWithAggregatesInput>>;
  readonly OR?: InputMaybe<ReadonlyArray<DevAllowedEmailScalarWhereWithAggregatesInput>>;
  readonly email?: InputMaybe<StringWithAggregatesFilter>;
  readonly id?: InputMaybe<StringWithAggregatesFilter>;
};

export type DevAllowedEmailUpdateInput = {
  readonly email?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type DevAllowedEmailUpdateManyMutationInput = {
  readonly email?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type DevAllowedEmailWhereInput = {
  readonly AND?: InputMaybe<ReadonlyArray<DevAllowedEmailWhereInput>>;
  readonly NOT?: InputMaybe<ReadonlyArray<DevAllowedEmailWhereInput>>;
  readonly OR?: InputMaybe<ReadonlyArray<DevAllowedEmailWhereInput>>;
  readonly email?: InputMaybe<StringFilter>;
  readonly id?: InputMaybe<StringFilter>;
};

export type DevAllowedEmailWhereUniqueInput = {
  readonly email?: InputMaybe<Scalars['String']>;
  readonly id?: InputMaybe<Scalars['String']>;
};

export type EnumStatusTypeFieldUpdateOperationsInput = {
  readonly set?: InputMaybe<StatusType>;
};

export type EnumStatusTypeFilter = {
  readonly equals?: InputMaybe<StatusType>;
  readonly in?: InputMaybe<ReadonlyArray<StatusType>>;
  readonly not?: InputMaybe<NestedEnumStatusTypeFilter>;
  readonly notIn?: InputMaybe<ReadonlyArray<StatusType>>;
};

export type EnumStatusTypeWithAggregatesFilter = {
  readonly _count?: InputMaybe<NestedIntFilter>;
  readonly _max?: InputMaybe<NestedEnumStatusTypeFilter>;
  readonly _min?: InputMaybe<NestedEnumStatusTypeFilter>;
  readonly equals?: InputMaybe<StatusType>;
  readonly in?: InputMaybe<ReadonlyArray<StatusType>>;
  readonly not?: InputMaybe<NestedEnumStatusTypeWithAggregatesFilter>;
  readonly notIn?: InputMaybe<ReadonlyArray<StatusType>>;
};

export type IgAccount = {
  readonly __typename?: 'IgAccount';
  readonly createdAt: Scalars['DateTime'];
  readonly id: Scalars['String'];
  readonly password: Scalars['String'];
  readonly updatedAt: Scalars['DateTime'];
  readonly username: Scalars['String'];
};

export type IgAccountCountAggregate = {
  readonly __typename?: 'IgAccountCountAggregate';
  readonly _all: Scalars['Int'];
  readonly createdAt: Scalars['Int'];
  readonly id: Scalars['Int'];
  readonly password: Scalars['Int'];
  readonly updatedAt: Scalars['Int'];
  readonly username: Scalars['Int'];
};

export type IgAccountCountOrderByAggregateInput = {
  readonly createdAt?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly password?: InputMaybe<SortOrder>;
  readonly updatedAt?: InputMaybe<SortOrder>;
  readonly username?: InputMaybe<SortOrder>;
};

export type IgAccountCreateInput = {
  readonly createdAt?: InputMaybe<Scalars['DateTime']>;
  readonly id?: InputMaybe<Scalars['String']>;
  readonly password: Scalars['String'];
  readonly updatedAt?: InputMaybe<Scalars['DateTime']>;
  readonly username: Scalars['String'];
};

export type IgAccountCreateManyInput = {
  readonly createdAt?: InputMaybe<Scalars['DateTime']>;
  readonly id?: InputMaybe<Scalars['String']>;
  readonly password: Scalars['String'];
  readonly updatedAt?: InputMaybe<Scalars['DateTime']>;
  readonly username: Scalars['String'];
};

export type IgAccountGroupBy = {
  readonly __typename?: 'IgAccountGroupBy';
  readonly _count?: Maybe<IgAccountCountAggregate>;
  readonly _max?: Maybe<IgAccountMaxAggregate>;
  readonly _min?: Maybe<IgAccountMinAggregate>;
  readonly createdAt: Scalars['DateTime'];
  readonly id: Scalars['String'];
  readonly password: Scalars['String'];
  readonly updatedAt: Scalars['DateTime'];
  readonly username: Scalars['String'];
};

export type IgAccountMaxAggregate = {
  readonly __typename?: 'IgAccountMaxAggregate';
  readonly createdAt?: Maybe<Scalars['DateTime']>;
  readonly id?: Maybe<Scalars['String']>;
  readonly password?: Maybe<Scalars['String']>;
  readonly updatedAt?: Maybe<Scalars['DateTime']>;
  readonly username?: Maybe<Scalars['String']>;
};

export type IgAccountMaxOrderByAggregateInput = {
  readonly createdAt?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly password?: InputMaybe<SortOrder>;
  readonly updatedAt?: InputMaybe<SortOrder>;
  readonly username?: InputMaybe<SortOrder>;
};

export type IgAccountMinAggregate = {
  readonly __typename?: 'IgAccountMinAggregate';
  readonly createdAt?: Maybe<Scalars['DateTime']>;
  readonly id?: Maybe<Scalars['String']>;
  readonly password?: Maybe<Scalars['String']>;
  readonly updatedAt?: Maybe<Scalars['DateTime']>;
  readonly username?: Maybe<Scalars['String']>;
};

export type IgAccountMinOrderByAggregateInput = {
  readonly createdAt?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly password?: InputMaybe<SortOrder>;
  readonly updatedAt?: InputMaybe<SortOrder>;
  readonly username?: InputMaybe<SortOrder>;
};

export type IgAccountOrderByWithAggregationInput = {
  readonly _count?: InputMaybe<IgAccountCountOrderByAggregateInput>;
  readonly _max?: InputMaybe<IgAccountMaxOrderByAggregateInput>;
  readonly _min?: InputMaybe<IgAccountMinOrderByAggregateInput>;
  readonly createdAt?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly password?: InputMaybe<SortOrder>;
  readonly updatedAt?: InputMaybe<SortOrder>;
  readonly username?: InputMaybe<SortOrder>;
};

export type IgAccountOrderByWithRelationInput = {
  readonly createdAt?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly password?: InputMaybe<SortOrder>;
  readonly updatedAt?: InputMaybe<SortOrder>;
  readonly username?: InputMaybe<SortOrder>;
};

export const IgAccountScalarFieldEnum = {
  CreatedAt: 'createdAt',
  Id: 'id',
  Password: 'password',
  UpdatedAt: 'updatedAt',
  Username: 'username'
} as const;

export type IgAccountScalarFieldEnum = typeof IgAccountScalarFieldEnum[keyof typeof IgAccountScalarFieldEnum];
export type IgAccountScalarWhereWithAggregatesInput = {
  readonly AND?: InputMaybe<ReadonlyArray<IgAccountScalarWhereWithAggregatesInput>>;
  readonly NOT?: InputMaybe<ReadonlyArray<IgAccountScalarWhereWithAggregatesInput>>;
  readonly OR?: InputMaybe<ReadonlyArray<IgAccountScalarWhereWithAggregatesInput>>;
  readonly createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  readonly id?: InputMaybe<StringWithAggregatesFilter>;
  readonly password?: InputMaybe<StringWithAggregatesFilter>;
  readonly updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  readonly username?: InputMaybe<StringWithAggregatesFilter>;
};

export type IgAccountUpdateInput = {
  readonly createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  readonly id?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly password?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  readonly username?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type IgAccountUpdateManyMutationInput = {
  readonly createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  readonly id?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly password?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  readonly username?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type IgAccountWhereInput = {
  readonly AND?: InputMaybe<ReadonlyArray<IgAccountWhereInput>>;
  readonly NOT?: InputMaybe<ReadonlyArray<IgAccountWhereInput>>;
  readonly OR?: InputMaybe<ReadonlyArray<IgAccountWhereInput>>;
  readonly createdAt?: InputMaybe<DateTimeFilter>;
  readonly id?: InputMaybe<StringFilter>;
  readonly password?: InputMaybe<StringFilter>;
  readonly updatedAt?: InputMaybe<DateTimeFilter>;
  readonly username?: InputMaybe<StringFilter>;
};

export type IgAccountWhereUniqueInput = {
  readonly id?: InputMaybe<Scalars['String']>;
  readonly username?: InputMaybe<Scalars['String']>;
};

export type IgAsset = {
  readonly __typename?: 'IgAsset';
  readonly _count?: Maybe<IgAssetCount>;
  readonly accountUsed: Scalars['String'];
  readonly createdAt: Scalars['DateTime'];
  readonly id: Scalars['String'];
  readonly idHandleId: Scalars['String'];
  readonly igHandle: IgHandle;
  readonly igId: Scalars['String'];
  readonly proofUrl: Scalars['String'];
  readonly screenshotUrl?: Maybe<Scalars['String']>;
  readonly status: StatusType;
  readonly tag: ReadonlyArray<Tag>;
  readonly updatedAt: Scalars['DateTime'];
  readonly videoUrl?: Maybe<Scalars['String']>;
};


export type IgAssetTagArgs = {
  cursor?: InputMaybe<TagWhereUniqueInput>;
  distinct?: InputMaybe<ReadonlyArray<TagScalarFieldEnum>>;
  orderBy?: InputMaybe<ReadonlyArray<TagOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TagWhereInput>;
};

export type IgAssetCount = {
  readonly __typename?: 'IgAssetCount';
  readonly tag: Scalars['Int'];
};

export type IgAssetCountAggregate = {
  readonly __typename?: 'IgAssetCountAggregate';
  readonly _all: Scalars['Int'];
  readonly accountUsed: Scalars['Int'];
  readonly createdAt: Scalars['Int'];
  readonly id: Scalars['Int'];
  readonly idHandleId: Scalars['Int'];
  readonly igId: Scalars['Int'];
  readonly proofUrl: Scalars['Int'];
  readonly screenshotUrl: Scalars['Int'];
  readonly status: Scalars['Int'];
  readonly updatedAt: Scalars['Int'];
  readonly videoUrl: Scalars['Int'];
};

export type IgAssetCountOrderByAggregateInput = {
  readonly accountUsed?: InputMaybe<SortOrder>;
  readonly createdAt?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly idHandleId?: InputMaybe<SortOrder>;
  readonly igId?: InputMaybe<SortOrder>;
  readonly proofUrl?: InputMaybe<SortOrder>;
  readonly screenshotUrl?: InputMaybe<SortOrder>;
  readonly status?: InputMaybe<SortOrder>;
  readonly updatedAt?: InputMaybe<SortOrder>;
  readonly videoUrl?: InputMaybe<SortOrder>;
};

export type IgAssetCreateInput = {
  readonly accountUsed: Scalars['String'];
  readonly createdAt?: InputMaybe<Scalars['DateTime']>;
  readonly id?: InputMaybe<Scalars['String']>;
  readonly igHandle: IgHandleCreateNestedOneWithoutIgAssetsInput;
  readonly igId: Scalars['String'];
  readonly proofUrl: Scalars['String'];
  readonly screenshotUrl?: InputMaybe<Scalars['String']>;
  readonly status?: InputMaybe<StatusType>;
  readonly tag?: InputMaybe<TagCreateNestedManyWithoutIgAssetsInput>;
  readonly updatedAt?: InputMaybe<Scalars['DateTime']>;
  readonly videoUrl?: InputMaybe<Scalars['String']>;
};

export type IgAssetCreateManyIgHandleInput = {
  readonly accountUsed: Scalars['String'];
  readonly createdAt?: InputMaybe<Scalars['DateTime']>;
  readonly id?: InputMaybe<Scalars['String']>;
  readonly igId: Scalars['String'];
  readonly proofUrl: Scalars['String'];
  readonly screenshotUrl?: InputMaybe<Scalars['String']>;
  readonly status?: InputMaybe<StatusType>;
  readonly updatedAt?: InputMaybe<Scalars['DateTime']>;
  readonly videoUrl?: InputMaybe<Scalars['String']>;
};

export type IgAssetCreateManyIgHandleInputEnvelope = {
  readonly data: ReadonlyArray<IgAssetCreateManyIgHandleInput>;
  readonly skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type IgAssetCreateManyInput = {
  readonly accountUsed: Scalars['String'];
  readonly createdAt?: InputMaybe<Scalars['DateTime']>;
  readonly id?: InputMaybe<Scalars['String']>;
  readonly idHandleId: Scalars['String'];
  readonly igId: Scalars['String'];
  readonly proofUrl: Scalars['String'];
  readonly screenshotUrl?: InputMaybe<Scalars['String']>;
  readonly status?: InputMaybe<StatusType>;
  readonly updatedAt?: InputMaybe<Scalars['DateTime']>;
  readonly videoUrl?: InputMaybe<Scalars['String']>;
};

export type IgAssetCreateNestedManyWithoutIgHandleInput = {
  readonly connect?: InputMaybe<ReadonlyArray<IgAssetWhereUniqueInput>>;
  readonly connectOrCreate?: InputMaybe<ReadonlyArray<IgAssetCreateOrConnectWithoutIgHandleInput>>;
  readonly create?: InputMaybe<ReadonlyArray<IgAssetCreateWithoutIgHandleInput>>;
  readonly createMany?: InputMaybe<IgAssetCreateManyIgHandleInputEnvelope>;
};

export type IgAssetCreateNestedManyWithoutTagInput = {
  readonly connect?: InputMaybe<ReadonlyArray<IgAssetWhereUniqueInput>>;
  readonly connectOrCreate?: InputMaybe<ReadonlyArray<IgAssetCreateOrConnectWithoutTagInput>>;
  readonly create?: InputMaybe<ReadonlyArray<IgAssetCreateWithoutTagInput>>;
};

export type IgAssetCreateOrConnectWithoutIgHandleInput = {
  readonly create: IgAssetCreateWithoutIgHandleInput;
  readonly where: IgAssetWhereUniqueInput;
};

export type IgAssetCreateOrConnectWithoutTagInput = {
  readonly create: IgAssetCreateWithoutTagInput;
  readonly where: IgAssetWhereUniqueInput;
};

export type IgAssetCreateWithoutIgHandleInput = {
  readonly accountUsed: Scalars['String'];
  readonly createdAt?: InputMaybe<Scalars['DateTime']>;
  readonly id?: InputMaybe<Scalars['String']>;
  readonly igId: Scalars['String'];
  readonly proofUrl: Scalars['String'];
  readonly screenshotUrl?: InputMaybe<Scalars['String']>;
  readonly status?: InputMaybe<StatusType>;
  readonly tag?: InputMaybe<TagCreateNestedManyWithoutIgAssetsInput>;
  readonly updatedAt?: InputMaybe<Scalars['DateTime']>;
  readonly videoUrl?: InputMaybe<Scalars['String']>;
};

export type IgAssetCreateWithoutTagInput = {
  readonly accountUsed: Scalars['String'];
  readonly createdAt?: InputMaybe<Scalars['DateTime']>;
  readonly id?: InputMaybe<Scalars['String']>;
  readonly igHandle: IgHandleCreateNestedOneWithoutIgAssetsInput;
  readonly igId: Scalars['String'];
  readonly proofUrl: Scalars['String'];
  readonly screenshotUrl?: InputMaybe<Scalars['String']>;
  readonly status?: InputMaybe<StatusType>;
  readonly updatedAt?: InputMaybe<Scalars['DateTime']>;
  readonly videoUrl?: InputMaybe<Scalars['String']>;
};

export type IgAssetGroupBy = {
  readonly __typename?: 'IgAssetGroupBy';
  readonly _count?: Maybe<IgAssetCountAggregate>;
  readonly _max?: Maybe<IgAssetMaxAggregate>;
  readonly _min?: Maybe<IgAssetMinAggregate>;
  readonly accountUsed: Scalars['String'];
  readonly createdAt: Scalars['DateTime'];
  readonly id: Scalars['String'];
  readonly idHandleId: Scalars['String'];
  readonly igId: Scalars['String'];
  readonly proofUrl: Scalars['String'];
  readonly screenshotUrl?: Maybe<Scalars['String']>;
  readonly status: StatusType;
  readonly updatedAt: Scalars['DateTime'];
  readonly videoUrl?: Maybe<Scalars['String']>;
};

export type IgAssetListRelationFilter = {
  readonly every?: InputMaybe<IgAssetWhereInput>;
  readonly none?: InputMaybe<IgAssetWhereInput>;
  readonly some?: InputMaybe<IgAssetWhereInput>;
};

export type IgAssetMaxAggregate = {
  readonly __typename?: 'IgAssetMaxAggregate';
  readonly accountUsed?: Maybe<Scalars['String']>;
  readonly createdAt?: Maybe<Scalars['DateTime']>;
  readonly id?: Maybe<Scalars['String']>;
  readonly idHandleId?: Maybe<Scalars['String']>;
  readonly igId?: Maybe<Scalars['String']>;
  readonly proofUrl?: Maybe<Scalars['String']>;
  readonly screenshotUrl?: Maybe<Scalars['String']>;
  readonly status?: Maybe<StatusType>;
  readonly updatedAt?: Maybe<Scalars['DateTime']>;
  readonly videoUrl?: Maybe<Scalars['String']>;
};

export type IgAssetMaxOrderByAggregateInput = {
  readonly accountUsed?: InputMaybe<SortOrder>;
  readonly createdAt?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly idHandleId?: InputMaybe<SortOrder>;
  readonly igId?: InputMaybe<SortOrder>;
  readonly proofUrl?: InputMaybe<SortOrder>;
  readonly screenshotUrl?: InputMaybe<SortOrder>;
  readonly status?: InputMaybe<SortOrder>;
  readonly updatedAt?: InputMaybe<SortOrder>;
  readonly videoUrl?: InputMaybe<SortOrder>;
};

export type IgAssetMinAggregate = {
  readonly __typename?: 'IgAssetMinAggregate';
  readonly accountUsed?: Maybe<Scalars['String']>;
  readonly createdAt?: Maybe<Scalars['DateTime']>;
  readonly id?: Maybe<Scalars['String']>;
  readonly idHandleId?: Maybe<Scalars['String']>;
  readonly igId?: Maybe<Scalars['String']>;
  readonly proofUrl?: Maybe<Scalars['String']>;
  readonly screenshotUrl?: Maybe<Scalars['String']>;
  readonly status?: Maybe<StatusType>;
  readonly updatedAt?: Maybe<Scalars['DateTime']>;
  readonly videoUrl?: Maybe<Scalars['String']>;
};

export type IgAssetMinOrderByAggregateInput = {
  readonly accountUsed?: InputMaybe<SortOrder>;
  readonly createdAt?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly idHandleId?: InputMaybe<SortOrder>;
  readonly igId?: InputMaybe<SortOrder>;
  readonly proofUrl?: InputMaybe<SortOrder>;
  readonly screenshotUrl?: InputMaybe<SortOrder>;
  readonly status?: InputMaybe<SortOrder>;
  readonly updatedAt?: InputMaybe<SortOrder>;
  readonly videoUrl?: InputMaybe<SortOrder>;
};

export type IgAssetOrderByRelationAggregateInput = {
  readonly _count?: InputMaybe<SortOrder>;
};

export type IgAssetOrderByWithAggregationInput = {
  readonly _count?: InputMaybe<IgAssetCountOrderByAggregateInput>;
  readonly _max?: InputMaybe<IgAssetMaxOrderByAggregateInput>;
  readonly _min?: InputMaybe<IgAssetMinOrderByAggregateInput>;
  readonly accountUsed?: InputMaybe<SortOrder>;
  readonly createdAt?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly idHandleId?: InputMaybe<SortOrder>;
  readonly igId?: InputMaybe<SortOrder>;
  readonly proofUrl?: InputMaybe<SortOrder>;
  readonly screenshotUrl?: InputMaybe<SortOrder>;
  readonly status?: InputMaybe<SortOrder>;
  readonly updatedAt?: InputMaybe<SortOrder>;
  readonly videoUrl?: InputMaybe<SortOrder>;
};

export type IgAssetOrderByWithRelationInput = {
  readonly accountUsed?: InputMaybe<SortOrder>;
  readonly createdAt?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly idHandleId?: InputMaybe<SortOrder>;
  readonly igHandle?: InputMaybe<IgHandleOrderByWithRelationInput>;
  readonly igId?: InputMaybe<SortOrder>;
  readonly proofUrl?: InputMaybe<SortOrder>;
  readonly screenshotUrl?: InputMaybe<SortOrder>;
  readonly status?: InputMaybe<SortOrder>;
  readonly tag?: InputMaybe<TagOrderByRelationAggregateInput>;
  readonly updatedAt?: InputMaybe<SortOrder>;
  readonly videoUrl?: InputMaybe<SortOrder>;
};

export const IgAssetScalarFieldEnum = {
  AccountUsed: 'accountUsed',
  CreatedAt: 'createdAt',
  Id: 'id',
  IdHandleId: 'idHandleId',
  IgId: 'igId',
  ProofUrl: 'proofUrl',
  ScreenshotUrl: 'screenshotUrl',
  Status: 'status',
  UpdatedAt: 'updatedAt',
  VideoUrl: 'videoUrl'
} as const;

export type IgAssetScalarFieldEnum = typeof IgAssetScalarFieldEnum[keyof typeof IgAssetScalarFieldEnum];
export type IgAssetScalarWhereInput = {
  readonly AND?: InputMaybe<ReadonlyArray<IgAssetScalarWhereInput>>;
  readonly NOT?: InputMaybe<ReadonlyArray<IgAssetScalarWhereInput>>;
  readonly OR?: InputMaybe<ReadonlyArray<IgAssetScalarWhereInput>>;
  readonly accountUsed?: InputMaybe<StringFilter>;
  readonly createdAt?: InputMaybe<DateTimeFilter>;
  readonly id?: InputMaybe<StringFilter>;
  readonly idHandleId?: InputMaybe<StringFilter>;
  readonly igId?: InputMaybe<StringFilter>;
  readonly proofUrl?: InputMaybe<StringFilter>;
  readonly screenshotUrl?: InputMaybe<StringNullableFilter>;
  readonly status?: InputMaybe<EnumStatusTypeFilter>;
  readonly updatedAt?: InputMaybe<DateTimeFilter>;
  readonly videoUrl?: InputMaybe<StringNullableFilter>;
};

export type IgAssetScalarWhereWithAggregatesInput = {
  readonly AND?: InputMaybe<ReadonlyArray<IgAssetScalarWhereWithAggregatesInput>>;
  readonly NOT?: InputMaybe<ReadonlyArray<IgAssetScalarWhereWithAggregatesInput>>;
  readonly OR?: InputMaybe<ReadonlyArray<IgAssetScalarWhereWithAggregatesInput>>;
  readonly accountUsed?: InputMaybe<StringWithAggregatesFilter>;
  readonly createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  readonly id?: InputMaybe<StringWithAggregatesFilter>;
  readonly idHandleId?: InputMaybe<StringWithAggregatesFilter>;
  readonly igId?: InputMaybe<StringWithAggregatesFilter>;
  readonly proofUrl?: InputMaybe<StringWithAggregatesFilter>;
  readonly screenshotUrl?: InputMaybe<StringNullableWithAggregatesFilter>;
  readonly status?: InputMaybe<EnumStatusTypeWithAggregatesFilter>;
  readonly updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  readonly videoUrl?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type IgAssetUpdateInput = {
  readonly accountUsed?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  readonly id?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly igHandle?: InputMaybe<IgHandleUpdateOneRequiredWithoutIgAssetsNestedInput>;
  readonly igId?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly proofUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly screenshotUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly status?: InputMaybe<EnumStatusTypeFieldUpdateOperationsInput>;
  readonly tag?: InputMaybe<TagUpdateManyWithoutIgAssetsNestedInput>;
  readonly updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  readonly videoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type IgAssetUpdateManyMutationInput = {
  readonly accountUsed?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  readonly id?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly igId?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly proofUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly screenshotUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly status?: InputMaybe<EnumStatusTypeFieldUpdateOperationsInput>;
  readonly updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  readonly videoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type IgAssetUpdateManyWithWhereWithoutIgHandleInput = {
  readonly data: IgAssetUpdateManyMutationInput;
  readonly where: IgAssetScalarWhereInput;
};

export type IgAssetUpdateManyWithWhereWithoutTagInput = {
  readonly data: IgAssetUpdateManyMutationInput;
  readonly where: IgAssetScalarWhereInput;
};

export type IgAssetUpdateManyWithoutIgHandleNestedInput = {
  readonly connect?: InputMaybe<ReadonlyArray<IgAssetWhereUniqueInput>>;
  readonly connectOrCreate?: InputMaybe<ReadonlyArray<IgAssetCreateOrConnectWithoutIgHandleInput>>;
  readonly create?: InputMaybe<ReadonlyArray<IgAssetCreateWithoutIgHandleInput>>;
  readonly createMany?: InputMaybe<IgAssetCreateManyIgHandleInputEnvelope>;
  readonly delete?: InputMaybe<ReadonlyArray<IgAssetWhereUniqueInput>>;
  readonly deleteMany?: InputMaybe<ReadonlyArray<IgAssetScalarWhereInput>>;
  readonly disconnect?: InputMaybe<ReadonlyArray<IgAssetWhereUniqueInput>>;
  readonly set?: InputMaybe<ReadonlyArray<IgAssetWhereUniqueInput>>;
  readonly update?: InputMaybe<ReadonlyArray<IgAssetUpdateWithWhereUniqueWithoutIgHandleInput>>;
  readonly updateMany?: InputMaybe<ReadonlyArray<IgAssetUpdateManyWithWhereWithoutIgHandleInput>>;
  readonly upsert?: InputMaybe<ReadonlyArray<IgAssetUpsertWithWhereUniqueWithoutIgHandleInput>>;
};

export type IgAssetUpdateManyWithoutTagNestedInput = {
  readonly connect?: InputMaybe<ReadonlyArray<IgAssetWhereUniqueInput>>;
  readonly connectOrCreate?: InputMaybe<ReadonlyArray<IgAssetCreateOrConnectWithoutTagInput>>;
  readonly create?: InputMaybe<ReadonlyArray<IgAssetCreateWithoutTagInput>>;
  readonly delete?: InputMaybe<ReadonlyArray<IgAssetWhereUniqueInput>>;
  readonly deleteMany?: InputMaybe<ReadonlyArray<IgAssetScalarWhereInput>>;
  readonly disconnect?: InputMaybe<ReadonlyArray<IgAssetWhereUniqueInput>>;
  readonly set?: InputMaybe<ReadonlyArray<IgAssetWhereUniqueInput>>;
  readonly update?: InputMaybe<ReadonlyArray<IgAssetUpdateWithWhereUniqueWithoutTagInput>>;
  readonly updateMany?: InputMaybe<ReadonlyArray<IgAssetUpdateManyWithWhereWithoutTagInput>>;
  readonly upsert?: InputMaybe<ReadonlyArray<IgAssetUpsertWithWhereUniqueWithoutTagInput>>;
};

export type IgAssetUpdateWithWhereUniqueWithoutIgHandleInput = {
  readonly data: IgAssetUpdateWithoutIgHandleInput;
  readonly where: IgAssetWhereUniqueInput;
};

export type IgAssetUpdateWithWhereUniqueWithoutTagInput = {
  readonly data: IgAssetUpdateWithoutTagInput;
  readonly where: IgAssetWhereUniqueInput;
};

export type IgAssetUpdateWithoutIgHandleInput = {
  readonly accountUsed?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  readonly id?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly igId?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly proofUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly screenshotUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly status?: InputMaybe<EnumStatusTypeFieldUpdateOperationsInput>;
  readonly tag?: InputMaybe<TagUpdateManyWithoutIgAssetsNestedInput>;
  readonly updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  readonly videoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type IgAssetUpdateWithoutTagInput = {
  readonly accountUsed?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  readonly id?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly igHandle?: InputMaybe<IgHandleUpdateOneRequiredWithoutIgAssetsNestedInput>;
  readonly igId?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly proofUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly screenshotUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly status?: InputMaybe<EnumStatusTypeFieldUpdateOperationsInput>;
  readonly updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  readonly videoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type IgAssetUpsertWithWhereUniqueWithoutIgHandleInput = {
  readonly create: IgAssetCreateWithoutIgHandleInput;
  readonly update: IgAssetUpdateWithoutIgHandleInput;
  readonly where: IgAssetWhereUniqueInput;
};

export type IgAssetUpsertWithWhereUniqueWithoutTagInput = {
  readonly create: IgAssetCreateWithoutTagInput;
  readonly update: IgAssetUpdateWithoutTagInput;
  readonly where: IgAssetWhereUniqueInput;
};

export type IgAssetWhereInput = {
  readonly AND?: InputMaybe<ReadonlyArray<IgAssetWhereInput>>;
  readonly NOT?: InputMaybe<ReadonlyArray<IgAssetWhereInput>>;
  readonly OR?: InputMaybe<ReadonlyArray<IgAssetWhereInput>>;
  readonly accountUsed?: InputMaybe<StringFilter>;
  readonly createdAt?: InputMaybe<DateTimeFilter>;
  readonly id?: InputMaybe<StringFilter>;
  readonly idHandleId?: InputMaybe<StringFilter>;
  readonly igHandle?: InputMaybe<IgHandleRelationFilter>;
  readonly igId?: InputMaybe<StringFilter>;
  readonly proofUrl?: InputMaybe<StringFilter>;
  readonly screenshotUrl?: InputMaybe<StringNullableFilter>;
  readonly status?: InputMaybe<EnumStatusTypeFilter>;
  readonly tag?: InputMaybe<TagListRelationFilter>;
  readonly updatedAt?: InputMaybe<DateTimeFilter>;
  readonly videoUrl?: InputMaybe<StringNullableFilter>;
};

export type IgAssetWhereUniqueInput = {
  readonly id?: InputMaybe<Scalars['String']>;
  readonly igId?: InputMaybe<Scalars['String']>;
};

export type IgHandle = {
  readonly __typename?: 'IgHandle';
  readonly _count?: Maybe<IgHandleCount>;
  readonly createdAt: Scalars['DateTime'];
  readonly followers: Scalars['Int'];
  readonly handle: Scalars['String'];
  readonly id: Scalars['String'];
  readonly igAssets: ReadonlyArray<IgAsset>;
  readonly igClients: ReadonlyArray<Client>;
  readonly updatedAt: Scalars['DateTime'];
};


export type IgHandleIgAssetsArgs = {
  cursor?: InputMaybe<IgAssetWhereUniqueInput>;
  distinct?: InputMaybe<ReadonlyArray<IgAssetScalarFieldEnum>>;
  orderBy?: InputMaybe<ReadonlyArray<IgAssetOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IgAssetWhereInput>;
};


export type IgHandleIgClientsArgs = {
  cursor?: InputMaybe<ClientWhereUniqueInput>;
  distinct?: InputMaybe<ReadonlyArray<ClientScalarFieldEnum>>;
  orderBy?: InputMaybe<ReadonlyArray<ClientOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ClientWhereInput>;
};

export type IgHandleAvgAggregate = {
  readonly __typename?: 'IgHandleAvgAggregate';
  readonly followers?: Maybe<Scalars['Float']>;
};

export type IgHandleAvgOrderByAggregateInput = {
  readonly followers?: InputMaybe<SortOrder>;
};

export type IgHandleCount = {
  readonly __typename?: 'IgHandleCount';
  readonly igAssets: Scalars['Int'];
  readonly igClients: Scalars['Int'];
};

export type IgHandleCountAggregate = {
  readonly __typename?: 'IgHandleCountAggregate';
  readonly _all: Scalars['Int'];
  readonly createdAt: Scalars['Int'];
  readonly followers: Scalars['Int'];
  readonly handle: Scalars['Int'];
  readonly id: Scalars['Int'];
  readonly updatedAt: Scalars['Int'];
};

export type IgHandleCountOrderByAggregateInput = {
  readonly createdAt?: InputMaybe<SortOrder>;
  readonly followers?: InputMaybe<SortOrder>;
  readonly handle?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly updatedAt?: InputMaybe<SortOrder>;
};

export type IgHandleCreateInput = {
  readonly createdAt?: InputMaybe<Scalars['DateTime']>;
  readonly followers?: InputMaybe<Scalars['Int']>;
  readonly handle: Scalars['String'];
  readonly id?: InputMaybe<Scalars['String']>;
  readonly igAssets?: InputMaybe<IgAssetCreateNestedManyWithoutIgHandleInput>;
  readonly igClients?: InputMaybe<ClientCreateNestedManyWithoutIgHandlesInput>;
  readonly updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type IgHandleCreateManyInput = {
  readonly createdAt?: InputMaybe<Scalars['DateTime']>;
  readonly followers?: InputMaybe<Scalars['Int']>;
  readonly handle: Scalars['String'];
  readonly id?: InputMaybe<Scalars['String']>;
  readonly updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type IgHandleCreateNestedManyWithoutIgClientsInput = {
  readonly connect?: InputMaybe<ReadonlyArray<IgHandleWhereUniqueInput>>;
  readonly connectOrCreate?: InputMaybe<ReadonlyArray<IgHandleCreateOrConnectWithoutIgClientsInput>>;
  readonly create?: InputMaybe<ReadonlyArray<IgHandleCreateWithoutIgClientsInput>>;
};

export type IgHandleCreateNestedOneWithoutIgAssetsInput = {
  readonly connect?: InputMaybe<IgHandleWhereUniqueInput>;
  readonly connectOrCreate?: InputMaybe<IgHandleCreateOrConnectWithoutIgAssetsInput>;
  readonly create?: InputMaybe<IgHandleCreateWithoutIgAssetsInput>;
};

export type IgHandleCreateOrConnectWithoutIgAssetsInput = {
  readonly create: IgHandleCreateWithoutIgAssetsInput;
  readonly where: IgHandleWhereUniqueInput;
};

export type IgHandleCreateOrConnectWithoutIgClientsInput = {
  readonly create: IgHandleCreateWithoutIgClientsInput;
  readonly where: IgHandleWhereUniqueInput;
};

export type IgHandleCreateWithoutIgAssetsInput = {
  readonly createdAt?: InputMaybe<Scalars['DateTime']>;
  readonly followers?: InputMaybe<Scalars['Int']>;
  readonly handle: Scalars['String'];
  readonly id?: InputMaybe<Scalars['String']>;
  readonly igClients?: InputMaybe<ClientCreateNestedManyWithoutIgHandlesInput>;
  readonly updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type IgHandleCreateWithoutIgClientsInput = {
  readonly createdAt?: InputMaybe<Scalars['DateTime']>;
  readonly followers?: InputMaybe<Scalars['Int']>;
  readonly handle: Scalars['String'];
  readonly id?: InputMaybe<Scalars['String']>;
  readonly igAssets?: InputMaybe<IgAssetCreateNestedManyWithoutIgHandleInput>;
  readonly updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type IgHandleGroupBy = {
  readonly __typename?: 'IgHandleGroupBy';
  readonly _avg?: Maybe<IgHandleAvgAggregate>;
  readonly _count?: Maybe<IgHandleCountAggregate>;
  readonly _max?: Maybe<IgHandleMaxAggregate>;
  readonly _min?: Maybe<IgHandleMinAggregate>;
  readonly _sum?: Maybe<IgHandleSumAggregate>;
  readonly createdAt: Scalars['DateTime'];
  readonly followers: Scalars['Int'];
  readonly handle: Scalars['String'];
  readonly id: Scalars['String'];
  readonly updatedAt: Scalars['DateTime'];
};

export type IgHandleListRelationFilter = {
  readonly every?: InputMaybe<IgHandleWhereInput>;
  readonly none?: InputMaybe<IgHandleWhereInput>;
  readonly some?: InputMaybe<IgHandleWhereInput>;
};

export type IgHandleMaxAggregate = {
  readonly __typename?: 'IgHandleMaxAggregate';
  readonly createdAt?: Maybe<Scalars['DateTime']>;
  readonly followers?: Maybe<Scalars['Int']>;
  readonly handle?: Maybe<Scalars['String']>;
  readonly id?: Maybe<Scalars['String']>;
  readonly updatedAt?: Maybe<Scalars['DateTime']>;
};

export type IgHandleMaxOrderByAggregateInput = {
  readonly createdAt?: InputMaybe<SortOrder>;
  readonly followers?: InputMaybe<SortOrder>;
  readonly handle?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly updatedAt?: InputMaybe<SortOrder>;
};

export type IgHandleMinAggregate = {
  readonly __typename?: 'IgHandleMinAggregate';
  readonly createdAt?: Maybe<Scalars['DateTime']>;
  readonly followers?: Maybe<Scalars['Int']>;
  readonly handle?: Maybe<Scalars['String']>;
  readonly id?: Maybe<Scalars['String']>;
  readonly updatedAt?: Maybe<Scalars['DateTime']>;
};

export type IgHandleMinOrderByAggregateInput = {
  readonly createdAt?: InputMaybe<SortOrder>;
  readonly followers?: InputMaybe<SortOrder>;
  readonly handle?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly updatedAt?: InputMaybe<SortOrder>;
};

export type IgHandleOrderByRelationAggregateInput = {
  readonly _count?: InputMaybe<SortOrder>;
};

export type IgHandleOrderByWithAggregationInput = {
  readonly _avg?: InputMaybe<IgHandleAvgOrderByAggregateInput>;
  readonly _count?: InputMaybe<IgHandleCountOrderByAggregateInput>;
  readonly _max?: InputMaybe<IgHandleMaxOrderByAggregateInput>;
  readonly _min?: InputMaybe<IgHandleMinOrderByAggregateInput>;
  readonly _sum?: InputMaybe<IgHandleSumOrderByAggregateInput>;
  readonly createdAt?: InputMaybe<SortOrder>;
  readonly followers?: InputMaybe<SortOrder>;
  readonly handle?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly updatedAt?: InputMaybe<SortOrder>;
};

export type IgHandleOrderByWithRelationInput = {
  readonly createdAt?: InputMaybe<SortOrder>;
  readonly followers?: InputMaybe<SortOrder>;
  readonly handle?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly igAssets?: InputMaybe<IgAssetOrderByRelationAggregateInput>;
  readonly igClients?: InputMaybe<ClientOrderByRelationAggregateInput>;
  readonly updatedAt?: InputMaybe<SortOrder>;
};

export type IgHandleRelationFilter = {
  readonly is?: InputMaybe<IgHandleWhereInput>;
  readonly isNot?: InputMaybe<IgHandleWhereInput>;
};

export const IgHandleScalarFieldEnum = {
  CreatedAt: 'createdAt',
  Followers: 'followers',
  Handle: 'handle',
  Id: 'id',
  UpdatedAt: 'updatedAt'
} as const;

export type IgHandleScalarFieldEnum = typeof IgHandleScalarFieldEnum[keyof typeof IgHandleScalarFieldEnum];
export type IgHandleScalarWhereInput = {
  readonly AND?: InputMaybe<ReadonlyArray<IgHandleScalarWhereInput>>;
  readonly NOT?: InputMaybe<ReadonlyArray<IgHandleScalarWhereInput>>;
  readonly OR?: InputMaybe<ReadonlyArray<IgHandleScalarWhereInput>>;
  readonly createdAt?: InputMaybe<DateTimeFilter>;
  readonly followers?: InputMaybe<IntFilter>;
  readonly handle?: InputMaybe<StringFilter>;
  readonly id?: InputMaybe<StringFilter>;
  readonly updatedAt?: InputMaybe<DateTimeFilter>;
};

export type IgHandleScalarWhereWithAggregatesInput = {
  readonly AND?: InputMaybe<ReadonlyArray<IgHandleScalarWhereWithAggregatesInput>>;
  readonly NOT?: InputMaybe<ReadonlyArray<IgHandleScalarWhereWithAggregatesInput>>;
  readonly OR?: InputMaybe<ReadonlyArray<IgHandleScalarWhereWithAggregatesInput>>;
  readonly createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  readonly followers?: InputMaybe<IntWithAggregatesFilter>;
  readonly handle?: InputMaybe<StringWithAggregatesFilter>;
  readonly id?: InputMaybe<StringWithAggregatesFilter>;
  readonly updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type IgHandleSumAggregate = {
  readonly __typename?: 'IgHandleSumAggregate';
  readonly followers?: Maybe<Scalars['Int']>;
};

export type IgHandleSumOrderByAggregateInput = {
  readonly followers?: InputMaybe<SortOrder>;
};

export type IgHandleUpdateInput = {
  readonly createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  readonly followers?: InputMaybe<IntFieldUpdateOperationsInput>;
  readonly handle?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly id?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly igAssets?: InputMaybe<IgAssetUpdateManyWithoutIgHandleNestedInput>;
  readonly igClients?: InputMaybe<ClientUpdateManyWithoutIgHandlesNestedInput>;
  readonly updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type IgHandleUpdateManyMutationInput = {
  readonly createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  readonly followers?: InputMaybe<IntFieldUpdateOperationsInput>;
  readonly handle?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly id?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type IgHandleUpdateManyWithWhereWithoutIgClientsInput = {
  readonly data: IgHandleUpdateManyMutationInput;
  readonly where: IgHandleScalarWhereInput;
};

export type IgHandleUpdateManyWithoutIgClientsNestedInput = {
  readonly connect?: InputMaybe<ReadonlyArray<IgHandleWhereUniqueInput>>;
  readonly connectOrCreate?: InputMaybe<ReadonlyArray<IgHandleCreateOrConnectWithoutIgClientsInput>>;
  readonly create?: InputMaybe<ReadonlyArray<IgHandleCreateWithoutIgClientsInput>>;
  readonly delete?: InputMaybe<ReadonlyArray<IgHandleWhereUniqueInput>>;
  readonly deleteMany?: InputMaybe<ReadonlyArray<IgHandleScalarWhereInput>>;
  readonly disconnect?: InputMaybe<ReadonlyArray<IgHandleWhereUniqueInput>>;
  readonly set?: InputMaybe<ReadonlyArray<IgHandleWhereUniqueInput>>;
  readonly update?: InputMaybe<ReadonlyArray<IgHandleUpdateWithWhereUniqueWithoutIgClientsInput>>;
  readonly updateMany?: InputMaybe<ReadonlyArray<IgHandleUpdateManyWithWhereWithoutIgClientsInput>>;
  readonly upsert?: InputMaybe<ReadonlyArray<IgHandleUpsertWithWhereUniqueWithoutIgClientsInput>>;
};

export type IgHandleUpdateOneRequiredWithoutIgAssetsNestedInput = {
  readonly connect?: InputMaybe<IgHandleWhereUniqueInput>;
  readonly connectOrCreate?: InputMaybe<IgHandleCreateOrConnectWithoutIgAssetsInput>;
  readonly create?: InputMaybe<IgHandleCreateWithoutIgAssetsInput>;
  readonly update?: InputMaybe<IgHandleUpdateWithoutIgAssetsInput>;
  readonly upsert?: InputMaybe<IgHandleUpsertWithoutIgAssetsInput>;
};

export type IgHandleUpdateWithWhereUniqueWithoutIgClientsInput = {
  readonly data: IgHandleUpdateWithoutIgClientsInput;
  readonly where: IgHandleWhereUniqueInput;
};

export type IgHandleUpdateWithoutIgAssetsInput = {
  readonly createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  readonly followers?: InputMaybe<IntFieldUpdateOperationsInput>;
  readonly handle?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly id?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly igClients?: InputMaybe<ClientUpdateManyWithoutIgHandlesNestedInput>;
  readonly updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type IgHandleUpdateWithoutIgClientsInput = {
  readonly createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  readonly followers?: InputMaybe<IntFieldUpdateOperationsInput>;
  readonly handle?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly id?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly igAssets?: InputMaybe<IgAssetUpdateManyWithoutIgHandleNestedInput>;
  readonly updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type IgHandleUpsertWithWhereUniqueWithoutIgClientsInput = {
  readonly create: IgHandleCreateWithoutIgClientsInput;
  readonly update: IgHandleUpdateWithoutIgClientsInput;
  readonly where: IgHandleWhereUniqueInput;
};

export type IgHandleUpsertWithoutIgAssetsInput = {
  readonly create: IgHandleCreateWithoutIgAssetsInput;
  readonly update: IgHandleUpdateWithoutIgAssetsInput;
};

export type IgHandleWhereInput = {
  readonly AND?: InputMaybe<ReadonlyArray<IgHandleWhereInput>>;
  readonly NOT?: InputMaybe<ReadonlyArray<IgHandleWhereInput>>;
  readonly OR?: InputMaybe<ReadonlyArray<IgHandleWhereInput>>;
  readonly createdAt?: InputMaybe<DateTimeFilter>;
  readonly followers?: InputMaybe<IntFilter>;
  readonly handle?: InputMaybe<StringFilter>;
  readonly id?: InputMaybe<StringFilter>;
  readonly igAssets?: InputMaybe<IgAssetListRelationFilter>;
  readonly igClients?: InputMaybe<ClientListRelationFilter>;
  readonly updatedAt?: InputMaybe<DateTimeFilter>;
};

export type IgHandleWhereUniqueInput = {
  readonly handle?: InputMaybe<Scalars['String']>;
  readonly id?: InputMaybe<Scalars['String']>;
};

export type IntFieldUpdateOperationsInput = {
  readonly decrement?: InputMaybe<Scalars['Int']>;
  readonly divide?: InputMaybe<Scalars['Int']>;
  readonly increment?: InputMaybe<Scalars['Int']>;
  readonly multiply?: InputMaybe<Scalars['Int']>;
  readonly set?: InputMaybe<Scalars['Int']>;
};

export type IntFilter = {
  readonly equals?: InputMaybe<Scalars['Int']>;
  readonly gt?: InputMaybe<Scalars['Int']>;
  readonly gte?: InputMaybe<Scalars['Int']>;
  readonly in?: InputMaybe<ReadonlyArray<Scalars['Int']>>;
  readonly lt?: InputMaybe<Scalars['Int']>;
  readonly lte?: InputMaybe<Scalars['Int']>;
  readonly not?: InputMaybe<NestedIntFilter>;
  readonly notIn?: InputMaybe<ReadonlyArray<Scalars['Int']>>;
};

export type IntNullableFilter = {
  readonly equals?: InputMaybe<Scalars['Int']>;
  readonly gt?: InputMaybe<Scalars['Int']>;
  readonly gte?: InputMaybe<Scalars['Int']>;
  readonly in?: InputMaybe<ReadonlyArray<Scalars['Int']>>;
  readonly lt?: InputMaybe<Scalars['Int']>;
  readonly lte?: InputMaybe<Scalars['Int']>;
  readonly not?: InputMaybe<NestedIntNullableFilter>;
  readonly notIn?: InputMaybe<ReadonlyArray<Scalars['Int']>>;
};

export type IntNullableWithAggregatesFilter = {
  readonly _avg?: InputMaybe<NestedFloatNullableFilter>;
  readonly _count?: InputMaybe<NestedIntNullableFilter>;
  readonly _max?: InputMaybe<NestedIntNullableFilter>;
  readonly _min?: InputMaybe<NestedIntNullableFilter>;
  readonly _sum?: InputMaybe<NestedIntNullableFilter>;
  readonly equals?: InputMaybe<Scalars['Int']>;
  readonly gt?: InputMaybe<Scalars['Int']>;
  readonly gte?: InputMaybe<Scalars['Int']>;
  readonly in?: InputMaybe<ReadonlyArray<Scalars['Int']>>;
  readonly lt?: InputMaybe<Scalars['Int']>;
  readonly lte?: InputMaybe<Scalars['Int']>;
  readonly not?: InputMaybe<NestedIntNullableWithAggregatesFilter>;
  readonly notIn?: InputMaybe<ReadonlyArray<Scalars['Int']>>;
};

export type IntWithAggregatesFilter = {
  readonly _avg?: InputMaybe<NestedFloatFilter>;
  readonly _count?: InputMaybe<NestedIntFilter>;
  readonly _max?: InputMaybe<NestedIntFilter>;
  readonly _min?: InputMaybe<NestedIntFilter>;
  readonly _sum?: InputMaybe<NestedIntFilter>;
  readonly equals?: InputMaybe<Scalars['Int']>;
  readonly gt?: InputMaybe<Scalars['Int']>;
  readonly gte?: InputMaybe<Scalars['Int']>;
  readonly in?: InputMaybe<ReadonlyArray<Scalars['Int']>>;
  readonly lt?: InputMaybe<Scalars['Int']>;
  readonly lte?: InputMaybe<Scalars['Int']>;
  readonly not?: InputMaybe<NestedIntWithAggregatesFilter>;
  readonly notIn?: InputMaybe<ReadonlyArray<Scalars['Int']>>;
};

export type Mutation = {
  readonly __typename?: 'Mutation';
  readonly createManyAccount: AffectedRowsOutput;
  readonly createManyClient: AffectedRowsOutput;
  readonly createManyDevAllowedEmail: AffectedRowsOutput;
  readonly createManyIgAccount: AffectedRowsOutput;
  readonly createManyIgAsset: AffectedRowsOutput;
  readonly createManyIgHandle: AffectedRowsOutput;
  readonly createManySession: AffectedRowsOutput;
  readonly createManyTag: AffectedRowsOutput;
  readonly createManyUser: AffectedRowsOutput;
  readonly createManyVerificationToken: AffectedRowsOutput;
  readonly createOneAccount: Account;
  readonly createOneClient: Client;
  readonly createOneDevAllowedEmail: DevAllowedEmail;
  readonly createOneIgAccount: IgAccount;
  readonly createOneIgAsset: IgAsset;
  readonly createOneIgHandle: IgHandle;
  readonly createOneSession: Session;
  readonly createOneTag: Tag;
  readonly createOneUser: User;
  readonly createOneVerificationToken: VerificationToken;
  readonly deleteManyAccount: AffectedRowsOutput;
  readonly deleteManyClient: AffectedRowsOutput;
  readonly deleteManyDevAllowedEmail: AffectedRowsOutput;
  readonly deleteManyIgAccount: AffectedRowsOutput;
  readonly deleteManyIgAsset: AffectedRowsOutput;
  readonly deleteManyIgHandle: AffectedRowsOutput;
  readonly deleteManySession: AffectedRowsOutput;
  readonly deleteManyTag: AffectedRowsOutput;
  readonly deleteManyUser: AffectedRowsOutput;
  readonly deleteManyVerificationToken: AffectedRowsOutput;
  readonly deleteOneAccount?: Maybe<Account>;
  readonly deleteOneClient?: Maybe<Client>;
  readonly deleteOneDevAllowedEmail?: Maybe<DevAllowedEmail>;
  readonly deleteOneIgAccount?: Maybe<IgAccount>;
  readonly deleteOneIgAsset?: Maybe<IgAsset>;
  readonly deleteOneIgHandle?: Maybe<IgHandle>;
  readonly deleteOneSession?: Maybe<Session>;
  readonly deleteOneTag?: Maybe<Tag>;
  readonly deleteOneUser?: Maybe<User>;
  readonly deleteOneVerificationToken?: Maybe<VerificationToken>;
  readonly updateManyAccount: AffectedRowsOutput;
  readonly updateManyClient: AffectedRowsOutput;
  readonly updateManyDevAllowedEmail: AffectedRowsOutput;
  readonly updateManyIgAccount: AffectedRowsOutput;
  readonly updateManyIgAsset: AffectedRowsOutput;
  readonly updateManyIgHandle: AffectedRowsOutput;
  readonly updateManySession: AffectedRowsOutput;
  readonly updateManyTag: AffectedRowsOutput;
  readonly updateManyUser: AffectedRowsOutput;
  readonly updateManyVerificationToken: AffectedRowsOutput;
  readonly updateOneAccount?: Maybe<Account>;
  readonly updateOneClient?: Maybe<Client>;
  readonly updateOneDevAllowedEmail?: Maybe<DevAllowedEmail>;
  readonly updateOneIgAccount?: Maybe<IgAccount>;
  readonly updateOneIgAsset?: Maybe<IgAsset>;
  readonly updateOneIgHandle?: Maybe<IgHandle>;
  readonly updateOneSession?: Maybe<Session>;
  readonly updateOneTag?: Maybe<Tag>;
  readonly updateOneUser?: Maybe<User>;
  readonly updateOneVerificationToken?: Maybe<VerificationToken>;
  readonly upsertOneAccount: Account;
  readonly upsertOneClient: Client;
  readonly upsertOneDevAllowedEmail: DevAllowedEmail;
  readonly upsertOneIgAccount: IgAccount;
  readonly upsertOneIgAsset: IgAsset;
  readonly upsertOneIgHandle: IgHandle;
  readonly upsertOneSession: Session;
  readonly upsertOneTag: Tag;
  readonly upsertOneUser: User;
  readonly upsertOneVerificationToken: VerificationToken;
};


export type MutationCreateManyAccountArgs = {
  data: ReadonlyArray<AccountCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateManyClientArgs = {
  data: ReadonlyArray<ClientCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateManyDevAllowedEmailArgs = {
  data: ReadonlyArray<DevAllowedEmailCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateManyIgAccountArgs = {
  data: ReadonlyArray<IgAccountCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateManyIgAssetArgs = {
  data: ReadonlyArray<IgAssetCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateManyIgHandleArgs = {
  data: ReadonlyArray<IgHandleCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateManySessionArgs = {
  data: ReadonlyArray<SessionCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateManyTagArgs = {
  data: ReadonlyArray<TagCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateManyUserArgs = {
  data: ReadonlyArray<UserCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateManyVerificationTokenArgs = {
  data: ReadonlyArray<VerificationTokenCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateOneAccountArgs = {
  data: AccountCreateInput;
};


export type MutationCreateOneClientArgs = {
  data: ClientCreateInput;
};


export type MutationCreateOneDevAllowedEmailArgs = {
  data: DevAllowedEmailCreateInput;
};


export type MutationCreateOneIgAccountArgs = {
  data: IgAccountCreateInput;
};


export type MutationCreateOneIgAssetArgs = {
  data: IgAssetCreateInput;
};


export type MutationCreateOneIgHandleArgs = {
  data: IgHandleCreateInput;
};


export type MutationCreateOneSessionArgs = {
  data: SessionCreateInput;
};


export type MutationCreateOneTagArgs = {
  data: TagCreateInput;
};


export type MutationCreateOneUserArgs = {
  data: UserCreateInput;
};


export type MutationCreateOneVerificationTokenArgs = {
  data: VerificationTokenCreateInput;
};


export type MutationDeleteManyAccountArgs = {
  where?: InputMaybe<AccountWhereInput>;
};


export type MutationDeleteManyClientArgs = {
  where?: InputMaybe<ClientWhereInput>;
};


export type MutationDeleteManyDevAllowedEmailArgs = {
  where?: InputMaybe<DevAllowedEmailWhereInput>;
};


export type MutationDeleteManyIgAccountArgs = {
  where?: InputMaybe<IgAccountWhereInput>;
};


export type MutationDeleteManyIgAssetArgs = {
  where?: InputMaybe<IgAssetWhereInput>;
};


export type MutationDeleteManyIgHandleArgs = {
  where?: InputMaybe<IgHandleWhereInput>;
};


export type MutationDeleteManySessionArgs = {
  where?: InputMaybe<SessionWhereInput>;
};


export type MutationDeleteManyTagArgs = {
  where?: InputMaybe<TagWhereInput>;
};


export type MutationDeleteManyUserArgs = {
  where?: InputMaybe<UserWhereInput>;
};


export type MutationDeleteManyVerificationTokenArgs = {
  where?: InputMaybe<VerificationTokenWhereInput>;
};


export type MutationDeleteOneAccountArgs = {
  where: AccountWhereUniqueInput;
};


export type MutationDeleteOneClientArgs = {
  where: ClientWhereUniqueInput;
};


export type MutationDeleteOneDevAllowedEmailArgs = {
  where: DevAllowedEmailWhereUniqueInput;
};


export type MutationDeleteOneIgAccountArgs = {
  where: IgAccountWhereUniqueInput;
};


export type MutationDeleteOneIgAssetArgs = {
  where: IgAssetWhereUniqueInput;
};


export type MutationDeleteOneIgHandleArgs = {
  where: IgHandleWhereUniqueInput;
};


export type MutationDeleteOneSessionArgs = {
  where: SessionWhereUniqueInput;
};


export type MutationDeleteOneTagArgs = {
  where: TagWhereUniqueInput;
};


export type MutationDeleteOneUserArgs = {
  where: UserWhereUniqueInput;
};


export type MutationDeleteOneVerificationTokenArgs = {
  where: VerificationTokenWhereUniqueInput;
};


export type MutationUpdateManyAccountArgs = {
  data: AccountUpdateManyMutationInput;
  where?: InputMaybe<AccountWhereInput>;
};


export type MutationUpdateManyClientArgs = {
  data: ClientUpdateManyMutationInput;
  where?: InputMaybe<ClientWhereInput>;
};


export type MutationUpdateManyDevAllowedEmailArgs = {
  data: DevAllowedEmailUpdateManyMutationInput;
  where?: InputMaybe<DevAllowedEmailWhereInput>;
};


export type MutationUpdateManyIgAccountArgs = {
  data: IgAccountUpdateManyMutationInput;
  where?: InputMaybe<IgAccountWhereInput>;
};


export type MutationUpdateManyIgAssetArgs = {
  data: IgAssetUpdateManyMutationInput;
  where?: InputMaybe<IgAssetWhereInput>;
};


export type MutationUpdateManyIgHandleArgs = {
  data: IgHandleUpdateManyMutationInput;
  where?: InputMaybe<IgHandleWhereInput>;
};


export type MutationUpdateManySessionArgs = {
  data: SessionUpdateManyMutationInput;
  where?: InputMaybe<SessionWhereInput>;
};


export type MutationUpdateManyTagArgs = {
  data: TagUpdateManyMutationInput;
  where?: InputMaybe<TagWhereInput>;
};


export type MutationUpdateManyUserArgs = {
  data: UserUpdateManyMutationInput;
  where?: InputMaybe<UserWhereInput>;
};


export type MutationUpdateManyVerificationTokenArgs = {
  data: VerificationTokenUpdateManyMutationInput;
  where?: InputMaybe<VerificationTokenWhereInput>;
};


export type MutationUpdateOneAccountArgs = {
  data: AccountUpdateInput;
  where: AccountWhereUniqueInput;
};


export type MutationUpdateOneClientArgs = {
  data: ClientUpdateInput;
  where: ClientWhereUniqueInput;
};


export type MutationUpdateOneDevAllowedEmailArgs = {
  data: DevAllowedEmailUpdateInput;
  where: DevAllowedEmailWhereUniqueInput;
};


export type MutationUpdateOneIgAccountArgs = {
  data: IgAccountUpdateInput;
  where: IgAccountWhereUniqueInput;
};


export type MutationUpdateOneIgAssetArgs = {
  data: IgAssetUpdateInput;
  where: IgAssetWhereUniqueInput;
};


export type MutationUpdateOneIgHandleArgs = {
  data: IgHandleUpdateInput;
  where: IgHandleWhereUniqueInput;
};


export type MutationUpdateOneSessionArgs = {
  data: SessionUpdateInput;
  where: SessionWhereUniqueInput;
};


export type MutationUpdateOneTagArgs = {
  data: TagUpdateInput;
  where: TagWhereUniqueInput;
};


export type MutationUpdateOneUserArgs = {
  data: UserUpdateInput;
  where: UserWhereUniqueInput;
};


export type MutationUpdateOneVerificationTokenArgs = {
  data: VerificationTokenUpdateInput;
  where: VerificationTokenWhereUniqueInput;
};


export type MutationUpsertOneAccountArgs = {
  create: AccountCreateInput;
  update: AccountUpdateInput;
  where: AccountWhereUniqueInput;
};


export type MutationUpsertOneClientArgs = {
  create: ClientCreateInput;
  update: ClientUpdateInput;
  where: ClientWhereUniqueInput;
};


export type MutationUpsertOneDevAllowedEmailArgs = {
  create: DevAllowedEmailCreateInput;
  update: DevAllowedEmailUpdateInput;
  where: DevAllowedEmailWhereUniqueInput;
};


export type MutationUpsertOneIgAccountArgs = {
  create: IgAccountCreateInput;
  update: IgAccountUpdateInput;
  where: IgAccountWhereUniqueInput;
};


export type MutationUpsertOneIgAssetArgs = {
  create: IgAssetCreateInput;
  update: IgAssetUpdateInput;
  where: IgAssetWhereUniqueInput;
};


export type MutationUpsertOneIgHandleArgs = {
  create: IgHandleCreateInput;
  update: IgHandleUpdateInput;
  where: IgHandleWhereUniqueInput;
};


export type MutationUpsertOneSessionArgs = {
  create: SessionCreateInput;
  update: SessionUpdateInput;
  where: SessionWhereUniqueInput;
};


export type MutationUpsertOneTagArgs = {
  create: TagCreateInput;
  update: TagUpdateInput;
  where: TagWhereUniqueInput;
};


export type MutationUpsertOneUserArgs = {
  create: UserCreateInput;
  update: UserUpdateInput;
  where: UserWhereUniqueInput;
};


export type MutationUpsertOneVerificationTokenArgs = {
  create: VerificationTokenCreateInput;
  update: VerificationTokenUpdateInput;
  where: VerificationTokenWhereUniqueInput;
};

export type NestedBoolFilter = {
  readonly equals?: InputMaybe<Scalars['Boolean']>;
  readonly not?: InputMaybe<NestedBoolFilter>;
};

export type NestedBoolWithAggregatesFilter = {
  readonly _count?: InputMaybe<NestedIntFilter>;
  readonly _max?: InputMaybe<NestedBoolFilter>;
  readonly _min?: InputMaybe<NestedBoolFilter>;
  readonly equals?: InputMaybe<Scalars['Boolean']>;
  readonly not?: InputMaybe<NestedBoolWithAggregatesFilter>;
};

export type NestedDateTimeFilter = {
  readonly equals?: InputMaybe<Scalars['DateTime']>;
  readonly gt?: InputMaybe<Scalars['DateTime']>;
  readonly gte?: InputMaybe<Scalars['DateTime']>;
  readonly in?: InputMaybe<ReadonlyArray<Scalars['DateTime']>>;
  readonly lt?: InputMaybe<Scalars['DateTime']>;
  readonly lte?: InputMaybe<Scalars['DateTime']>;
  readonly not?: InputMaybe<NestedDateTimeFilter>;
  readonly notIn?: InputMaybe<ReadonlyArray<Scalars['DateTime']>>;
};

export type NestedDateTimeNullableFilter = {
  readonly equals?: InputMaybe<Scalars['DateTime']>;
  readonly gt?: InputMaybe<Scalars['DateTime']>;
  readonly gte?: InputMaybe<Scalars['DateTime']>;
  readonly in?: InputMaybe<ReadonlyArray<Scalars['DateTime']>>;
  readonly lt?: InputMaybe<Scalars['DateTime']>;
  readonly lte?: InputMaybe<Scalars['DateTime']>;
  readonly not?: InputMaybe<NestedDateTimeNullableFilter>;
  readonly notIn?: InputMaybe<ReadonlyArray<Scalars['DateTime']>>;
};

export type NestedDateTimeNullableWithAggregatesFilter = {
  readonly _count?: InputMaybe<NestedIntNullableFilter>;
  readonly _max?: InputMaybe<NestedDateTimeNullableFilter>;
  readonly _min?: InputMaybe<NestedDateTimeNullableFilter>;
  readonly equals?: InputMaybe<Scalars['DateTime']>;
  readonly gt?: InputMaybe<Scalars['DateTime']>;
  readonly gte?: InputMaybe<Scalars['DateTime']>;
  readonly in?: InputMaybe<ReadonlyArray<Scalars['DateTime']>>;
  readonly lt?: InputMaybe<Scalars['DateTime']>;
  readonly lte?: InputMaybe<Scalars['DateTime']>;
  readonly not?: InputMaybe<NestedDateTimeNullableWithAggregatesFilter>;
  readonly notIn?: InputMaybe<ReadonlyArray<Scalars['DateTime']>>;
};

export type NestedDateTimeWithAggregatesFilter = {
  readonly _count?: InputMaybe<NestedIntFilter>;
  readonly _max?: InputMaybe<NestedDateTimeFilter>;
  readonly _min?: InputMaybe<NestedDateTimeFilter>;
  readonly equals?: InputMaybe<Scalars['DateTime']>;
  readonly gt?: InputMaybe<Scalars['DateTime']>;
  readonly gte?: InputMaybe<Scalars['DateTime']>;
  readonly in?: InputMaybe<ReadonlyArray<Scalars['DateTime']>>;
  readonly lt?: InputMaybe<Scalars['DateTime']>;
  readonly lte?: InputMaybe<Scalars['DateTime']>;
  readonly not?: InputMaybe<NestedDateTimeWithAggregatesFilter>;
  readonly notIn?: InputMaybe<ReadonlyArray<Scalars['DateTime']>>;
};

export type NestedEnumStatusTypeFilter = {
  readonly equals?: InputMaybe<StatusType>;
  readonly in?: InputMaybe<ReadonlyArray<StatusType>>;
  readonly not?: InputMaybe<NestedEnumStatusTypeFilter>;
  readonly notIn?: InputMaybe<ReadonlyArray<StatusType>>;
};

export type NestedEnumStatusTypeWithAggregatesFilter = {
  readonly _count?: InputMaybe<NestedIntFilter>;
  readonly _max?: InputMaybe<NestedEnumStatusTypeFilter>;
  readonly _min?: InputMaybe<NestedEnumStatusTypeFilter>;
  readonly equals?: InputMaybe<StatusType>;
  readonly in?: InputMaybe<ReadonlyArray<StatusType>>;
  readonly not?: InputMaybe<NestedEnumStatusTypeWithAggregatesFilter>;
  readonly notIn?: InputMaybe<ReadonlyArray<StatusType>>;
};

export type NestedFloatFilter = {
  readonly equals?: InputMaybe<Scalars['Float']>;
  readonly gt?: InputMaybe<Scalars['Float']>;
  readonly gte?: InputMaybe<Scalars['Float']>;
  readonly in?: InputMaybe<ReadonlyArray<Scalars['Float']>>;
  readonly lt?: InputMaybe<Scalars['Float']>;
  readonly lte?: InputMaybe<Scalars['Float']>;
  readonly not?: InputMaybe<NestedFloatFilter>;
  readonly notIn?: InputMaybe<ReadonlyArray<Scalars['Float']>>;
};

export type NestedFloatNullableFilter = {
  readonly equals?: InputMaybe<Scalars['Float']>;
  readonly gt?: InputMaybe<Scalars['Float']>;
  readonly gte?: InputMaybe<Scalars['Float']>;
  readonly in?: InputMaybe<ReadonlyArray<Scalars['Float']>>;
  readonly lt?: InputMaybe<Scalars['Float']>;
  readonly lte?: InputMaybe<Scalars['Float']>;
  readonly not?: InputMaybe<NestedFloatNullableFilter>;
  readonly notIn?: InputMaybe<ReadonlyArray<Scalars['Float']>>;
};

export type NestedIntFilter = {
  readonly equals?: InputMaybe<Scalars['Int']>;
  readonly gt?: InputMaybe<Scalars['Int']>;
  readonly gte?: InputMaybe<Scalars['Int']>;
  readonly in?: InputMaybe<ReadonlyArray<Scalars['Int']>>;
  readonly lt?: InputMaybe<Scalars['Int']>;
  readonly lte?: InputMaybe<Scalars['Int']>;
  readonly not?: InputMaybe<NestedIntFilter>;
  readonly notIn?: InputMaybe<ReadonlyArray<Scalars['Int']>>;
};

export type NestedIntNullableFilter = {
  readonly equals?: InputMaybe<Scalars['Int']>;
  readonly gt?: InputMaybe<Scalars['Int']>;
  readonly gte?: InputMaybe<Scalars['Int']>;
  readonly in?: InputMaybe<ReadonlyArray<Scalars['Int']>>;
  readonly lt?: InputMaybe<Scalars['Int']>;
  readonly lte?: InputMaybe<Scalars['Int']>;
  readonly not?: InputMaybe<NestedIntNullableFilter>;
  readonly notIn?: InputMaybe<ReadonlyArray<Scalars['Int']>>;
};

export type NestedIntNullableWithAggregatesFilter = {
  readonly _avg?: InputMaybe<NestedFloatNullableFilter>;
  readonly _count?: InputMaybe<NestedIntNullableFilter>;
  readonly _max?: InputMaybe<NestedIntNullableFilter>;
  readonly _min?: InputMaybe<NestedIntNullableFilter>;
  readonly _sum?: InputMaybe<NestedIntNullableFilter>;
  readonly equals?: InputMaybe<Scalars['Int']>;
  readonly gt?: InputMaybe<Scalars['Int']>;
  readonly gte?: InputMaybe<Scalars['Int']>;
  readonly in?: InputMaybe<ReadonlyArray<Scalars['Int']>>;
  readonly lt?: InputMaybe<Scalars['Int']>;
  readonly lte?: InputMaybe<Scalars['Int']>;
  readonly not?: InputMaybe<NestedIntNullableWithAggregatesFilter>;
  readonly notIn?: InputMaybe<ReadonlyArray<Scalars['Int']>>;
};

export type NestedIntWithAggregatesFilter = {
  readonly _avg?: InputMaybe<NestedFloatFilter>;
  readonly _count?: InputMaybe<NestedIntFilter>;
  readonly _max?: InputMaybe<NestedIntFilter>;
  readonly _min?: InputMaybe<NestedIntFilter>;
  readonly _sum?: InputMaybe<NestedIntFilter>;
  readonly equals?: InputMaybe<Scalars['Int']>;
  readonly gt?: InputMaybe<Scalars['Int']>;
  readonly gte?: InputMaybe<Scalars['Int']>;
  readonly in?: InputMaybe<ReadonlyArray<Scalars['Int']>>;
  readonly lt?: InputMaybe<Scalars['Int']>;
  readonly lte?: InputMaybe<Scalars['Int']>;
  readonly not?: InputMaybe<NestedIntWithAggregatesFilter>;
  readonly notIn?: InputMaybe<ReadonlyArray<Scalars['Int']>>;
};

export type NestedStringFilter = {
  readonly contains?: InputMaybe<Scalars['String']>;
  readonly endsWith?: InputMaybe<Scalars['String']>;
  readonly equals?: InputMaybe<Scalars['String']>;
  readonly gt?: InputMaybe<Scalars['String']>;
  readonly gte?: InputMaybe<Scalars['String']>;
  readonly in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly lt?: InputMaybe<Scalars['String']>;
  readonly lte?: InputMaybe<Scalars['String']>;
  readonly not?: InputMaybe<NestedStringFilter>;
  readonly notIn?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly startsWith?: InputMaybe<Scalars['String']>;
};

export type NestedStringNullableFilter = {
  readonly contains?: InputMaybe<Scalars['String']>;
  readonly endsWith?: InputMaybe<Scalars['String']>;
  readonly equals?: InputMaybe<Scalars['String']>;
  readonly gt?: InputMaybe<Scalars['String']>;
  readonly gte?: InputMaybe<Scalars['String']>;
  readonly in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly lt?: InputMaybe<Scalars['String']>;
  readonly lte?: InputMaybe<Scalars['String']>;
  readonly not?: InputMaybe<NestedStringNullableFilter>;
  readonly notIn?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly startsWith?: InputMaybe<Scalars['String']>;
};

export type NestedStringNullableWithAggregatesFilter = {
  readonly _count?: InputMaybe<NestedIntNullableFilter>;
  readonly _max?: InputMaybe<NestedStringNullableFilter>;
  readonly _min?: InputMaybe<NestedStringNullableFilter>;
  readonly contains?: InputMaybe<Scalars['String']>;
  readonly endsWith?: InputMaybe<Scalars['String']>;
  readonly equals?: InputMaybe<Scalars['String']>;
  readonly gt?: InputMaybe<Scalars['String']>;
  readonly gte?: InputMaybe<Scalars['String']>;
  readonly in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly lt?: InputMaybe<Scalars['String']>;
  readonly lte?: InputMaybe<Scalars['String']>;
  readonly not?: InputMaybe<NestedStringNullableWithAggregatesFilter>;
  readonly notIn?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly startsWith?: InputMaybe<Scalars['String']>;
};

export type NestedStringWithAggregatesFilter = {
  readonly _count?: InputMaybe<NestedIntFilter>;
  readonly _max?: InputMaybe<NestedStringFilter>;
  readonly _min?: InputMaybe<NestedStringFilter>;
  readonly contains?: InputMaybe<Scalars['String']>;
  readonly endsWith?: InputMaybe<Scalars['String']>;
  readonly equals?: InputMaybe<Scalars['String']>;
  readonly gt?: InputMaybe<Scalars['String']>;
  readonly gte?: InputMaybe<Scalars['String']>;
  readonly in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly lt?: InputMaybe<Scalars['String']>;
  readonly lte?: InputMaybe<Scalars['String']>;
  readonly not?: InputMaybe<NestedStringWithAggregatesFilter>;
  readonly notIn?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly startsWith?: InputMaybe<Scalars['String']>;
};

export type NullableDateTimeFieldUpdateOperationsInput = {
  readonly set?: InputMaybe<Scalars['DateTime']>;
};

export type NullableIntFieldUpdateOperationsInput = {
  readonly decrement?: InputMaybe<Scalars['Int']>;
  readonly divide?: InputMaybe<Scalars['Int']>;
  readonly increment?: InputMaybe<Scalars['Int']>;
  readonly multiply?: InputMaybe<Scalars['Int']>;
  readonly set?: InputMaybe<Scalars['Int']>;
};

export type NullableStringFieldUpdateOperationsInput = {
  readonly set?: InputMaybe<Scalars['String']>;
};

export type Query = {
  readonly __typename?: 'Query';
  readonly account?: Maybe<Account>;
  readonly accounts: ReadonlyArray<Account>;
  readonly aggregateAccount: AggregateAccount;
  readonly aggregateClient: AggregateClient;
  readonly aggregateDevAllowedEmail: AggregateDevAllowedEmail;
  readonly aggregateIgAccount: AggregateIgAccount;
  readonly aggregateIgAsset: AggregateIgAsset;
  readonly aggregateIgHandle: AggregateIgHandle;
  readonly aggregateSession: AggregateSession;
  readonly aggregateTag: AggregateTag;
  readonly aggregateUser: AggregateUser;
  readonly aggregateVerificationToken: AggregateVerificationToken;
  readonly client?: Maybe<Client>;
  readonly clients: ReadonlyArray<Client>;
  readonly devAllowedEmail?: Maybe<DevAllowedEmail>;
  readonly devAllowedEmails: ReadonlyArray<DevAllowedEmail>;
  readonly findFirstAccount?: Maybe<Account>;
  readonly findFirstClient?: Maybe<Client>;
  readonly findFirstDevAllowedEmail?: Maybe<DevAllowedEmail>;
  readonly findFirstIgAccount?: Maybe<IgAccount>;
  readonly findFirstIgAsset?: Maybe<IgAsset>;
  readonly findFirstIgHandle?: Maybe<IgHandle>;
  readonly findFirstSession?: Maybe<Session>;
  readonly findFirstTag?: Maybe<Tag>;
  readonly findFirstUser?: Maybe<User>;
  readonly findFirstVerificationToken?: Maybe<VerificationToken>;
  readonly groupByAccount: ReadonlyArray<AccountGroupBy>;
  readonly groupByClient: ReadonlyArray<ClientGroupBy>;
  readonly groupByDevAllowedEmail: ReadonlyArray<DevAllowedEmailGroupBy>;
  readonly groupByIgAccount: ReadonlyArray<IgAccountGroupBy>;
  readonly groupByIgAsset: ReadonlyArray<IgAssetGroupBy>;
  readonly groupByIgHandle: ReadonlyArray<IgHandleGroupBy>;
  readonly groupBySession: ReadonlyArray<SessionGroupBy>;
  readonly groupByTag: ReadonlyArray<TagGroupBy>;
  readonly groupByUser: ReadonlyArray<UserGroupBy>;
  readonly groupByVerificationToken: ReadonlyArray<VerificationTokenGroupBy>;
  readonly igAccount?: Maybe<IgAccount>;
  readonly igAccounts: ReadonlyArray<IgAccount>;
  readonly igAsset?: Maybe<IgAsset>;
  readonly igAssets: ReadonlyArray<IgAsset>;
  readonly igHandle?: Maybe<IgHandle>;
  readonly igHandles: ReadonlyArray<IgHandle>;
  readonly session?: Maybe<Session>;
  readonly sessions: ReadonlyArray<Session>;
  readonly tag?: Maybe<Tag>;
  readonly tags: ReadonlyArray<Tag>;
  readonly user?: Maybe<User>;
  readonly users: ReadonlyArray<User>;
  readonly verificationToken?: Maybe<VerificationToken>;
  readonly verificationTokens: ReadonlyArray<VerificationToken>;
};


export type QueryAccountArgs = {
  where: AccountWhereUniqueInput;
};


export type QueryAccountsArgs = {
  cursor?: InputMaybe<AccountWhereUniqueInput>;
  distinct?: InputMaybe<ReadonlyArray<AccountScalarFieldEnum>>;
  orderBy?: InputMaybe<ReadonlyArray<AccountOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccountWhereInput>;
};


export type QueryAggregateAccountArgs = {
  cursor?: InputMaybe<AccountWhereUniqueInput>;
  orderBy?: InputMaybe<ReadonlyArray<AccountOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccountWhereInput>;
};


export type QueryAggregateClientArgs = {
  cursor?: InputMaybe<ClientWhereUniqueInput>;
  orderBy?: InputMaybe<ReadonlyArray<ClientOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ClientWhereInput>;
};


export type QueryAggregateDevAllowedEmailArgs = {
  cursor?: InputMaybe<DevAllowedEmailWhereUniqueInput>;
  orderBy?: InputMaybe<ReadonlyArray<DevAllowedEmailOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DevAllowedEmailWhereInput>;
};


export type QueryAggregateIgAccountArgs = {
  cursor?: InputMaybe<IgAccountWhereUniqueInput>;
  orderBy?: InputMaybe<ReadonlyArray<IgAccountOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IgAccountWhereInput>;
};


export type QueryAggregateIgAssetArgs = {
  cursor?: InputMaybe<IgAssetWhereUniqueInput>;
  orderBy?: InputMaybe<ReadonlyArray<IgAssetOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IgAssetWhereInput>;
};


export type QueryAggregateIgHandleArgs = {
  cursor?: InputMaybe<IgHandleWhereUniqueInput>;
  orderBy?: InputMaybe<ReadonlyArray<IgHandleOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IgHandleWhereInput>;
};


export type QueryAggregateSessionArgs = {
  cursor?: InputMaybe<SessionWhereUniqueInput>;
  orderBy?: InputMaybe<ReadonlyArray<SessionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SessionWhereInput>;
};


export type QueryAggregateTagArgs = {
  cursor?: InputMaybe<TagWhereUniqueInput>;
  orderBy?: InputMaybe<ReadonlyArray<TagOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TagWhereInput>;
};


export type QueryAggregateUserArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  orderBy?: InputMaybe<ReadonlyArray<UserOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserWhereInput>;
};


export type QueryAggregateVerificationTokenArgs = {
  cursor?: InputMaybe<VerificationTokenWhereUniqueInput>;
  orderBy?: InputMaybe<ReadonlyArray<VerificationTokenOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<VerificationTokenWhereInput>;
};


export type QueryClientArgs = {
  where: ClientWhereUniqueInput;
};


export type QueryClientsArgs = {
  cursor?: InputMaybe<ClientWhereUniqueInput>;
  distinct?: InputMaybe<ReadonlyArray<ClientScalarFieldEnum>>;
  orderBy?: InputMaybe<ReadonlyArray<ClientOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ClientWhereInput>;
};


export type QueryDevAllowedEmailArgs = {
  where: DevAllowedEmailWhereUniqueInput;
};


export type QueryDevAllowedEmailsArgs = {
  cursor?: InputMaybe<DevAllowedEmailWhereUniqueInput>;
  distinct?: InputMaybe<ReadonlyArray<DevAllowedEmailScalarFieldEnum>>;
  orderBy?: InputMaybe<ReadonlyArray<DevAllowedEmailOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DevAllowedEmailWhereInput>;
};


export type QueryFindFirstAccountArgs = {
  cursor?: InputMaybe<AccountWhereUniqueInput>;
  distinct?: InputMaybe<ReadonlyArray<AccountScalarFieldEnum>>;
  orderBy?: InputMaybe<ReadonlyArray<AccountOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccountWhereInput>;
};


export type QueryFindFirstClientArgs = {
  cursor?: InputMaybe<ClientWhereUniqueInput>;
  distinct?: InputMaybe<ReadonlyArray<ClientScalarFieldEnum>>;
  orderBy?: InputMaybe<ReadonlyArray<ClientOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ClientWhereInput>;
};


export type QueryFindFirstDevAllowedEmailArgs = {
  cursor?: InputMaybe<DevAllowedEmailWhereUniqueInput>;
  distinct?: InputMaybe<ReadonlyArray<DevAllowedEmailScalarFieldEnum>>;
  orderBy?: InputMaybe<ReadonlyArray<DevAllowedEmailOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DevAllowedEmailWhereInput>;
};


export type QueryFindFirstIgAccountArgs = {
  cursor?: InputMaybe<IgAccountWhereUniqueInput>;
  distinct?: InputMaybe<ReadonlyArray<IgAccountScalarFieldEnum>>;
  orderBy?: InputMaybe<ReadonlyArray<IgAccountOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IgAccountWhereInput>;
};


export type QueryFindFirstIgAssetArgs = {
  cursor?: InputMaybe<IgAssetWhereUniqueInput>;
  distinct?: InputMaybe<ReadonlyArray<IgAssetScalarFieldEnum>>;
  orderBy?: InputMaybe<ReadonlyArray<IgAssetOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IgAssetWhereInput>;
};


export type QueryFindFirstIgHandleArgs = {
  cursor?: InputMaybe<IgHandleWhereUniqueInput>;
  distinct?: InputMaybe<ReadonlyArray<IgHandleScalarFieldEnum>>;
  orderBy?: InputMaybe<ReadonlyArray<IgHandleOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IgHandleWhereInput>;
};


export type QueryFindFirstSessionArgs = {
  cursor?: InputMaybe<SessionWhereUniqueInput>;
  distinct?: InputMaybe<ReadonlyArray<SessionScalarFieldEnum>>;
  orderBy?: InputMaybe<ReadonlyArray<SessionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SessionWhereInput>;
};


export type QueryFindFirstTagArgs = {
  cursor?: InputMaybe<TagWhereUniqueInput>;
  distinct?: InputMaybe<ReadonlyArray<TagScalarFieldEnum>>;
  orderBy?: InputMaybe<ReadonlyArray<TagOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TagWhereInput>;
};


export type QueryFindFirstUserArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  distinct?: InputMaybe<ReadonlyArray<UserScalarFieldEnum>>;
  orderBy?: InputMaybe<ReadonlyArray<UserOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserWhereInput>;
};


export type QueryFindFirstVerificationTokenArgs = {
  cursor?: InputMaybe<VerificationTokenWhereUniqueInput>;
  distinct?: InputMaybe<ReadonlyArray<VerificationTokenScalarFieldEnum>>;
  orderBy?: InputMaybe<ReadonlyArray<VerificationTokenOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<VerificationTokenWhereInput>;
};


export type QueryGroupByAccountArgs = {
  by: ReadonlyArray<AccountScalarFieldEnum>;
  having?: InputMaybe<AccountScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<ReadonlyArray<AccountOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccountWhereInput>;
};


export type QueryGroupByClientArgs = {
  by: ReadonlyArray<ClientScalarFieldEnum>;
  having?: InputMaybe<ClientScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<ReadonlyArray<ClientOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ClientWhereInput>;
};


export type QueryGroupByDevAllowedEmailArgs = {
  by: ReadonlyArray<DevAllowedEmailScalarFieldEnum>;
  having?: InputMaybe<DevAllowedEmailScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<ReadonlyArray<DevAllowedEmailOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DevAllowedEmailWhereInput>;
};


export type QueryGroupByIgAccountArgs = {
  by: ReadonlyArray<IgAccountScalarFieldEnum>;
  having?: InputMaybe<IgAccountScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<ReadonlyArray<IgAccountOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IgAccountWhereInput>;
};


export type QueryGroupByIgAssetArgs = {
  by: ReadonlyArray<IgAssetScalarFieldEnum>;
  having?: InputMaybe<IgAssetScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<ReadonlyArray<IgAssetOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IgAssetWhereInput>;
};


export type QueryGroupByIgHandleArgs = {
  by: ReadonlyArray<IgHandleScalarFieldEnum>;
  having?: InputMaybe<IgHandleScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<ReadonlyArray<IgHandleOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IgHandleWhereInput>;
};


export type QueryGroupBySessionArgs = {
  by: ReadonlyArray<SessionScalarFieldEnum>;
  having?: InputMaybe<SessionScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<ReadonlyArray<SessionOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SessionWhereInput>;
};


export type QueryGroupByTagArgs = {
  by: ReadonlyArray<TagScalarFieldEnum>;
  having?: InputMaybe<TagScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<ReadonlyArray<TagOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TagWhereInput>;
};


export type QueryGroupByUserArgs = {
  by: ReadonlyArray<UserScalarFieldEnum>;
  having?: InputMaybe<UserScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<ReadonlyArray<UserOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserWhereInput>;
};


export type QueryGroupByVerificationTokenArgs = {
  by: ReadonlyArray<VerificationTokenScalarFieldEnum>;
  having?: InputMaybe<VerificationTokenScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<ReadonlyArray<VerificationTokenOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<VerificationTokenWhereInput>;
};


export type QueryIgAccountArgs = {
  where: IgAccountWhereUniqueInput;
};


export type QueryIgAccountsArgs = {
  cursor?: InputMaybe<IgAccountWhereUniqueInput>;
  distinct?: InputMaybe<ReadonlyArray<IgAccountScalarFieldEnum>>;
  orderBy?: InputMaybe<ReadonlyArray<IgAccountOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IgAccountWhereInput>;
};


export type QueryIgAssetArgs = {
  where: IgAssetWhereUniqueInput;
};


export type QueryIgAssetsArgs = {
  cursor?: InputMaybe<IgAssetWhereUniqueInput>;
  distinct?: InputMaybe<ReadonlyArray<IgAssetScalarFieldEnum>>;
  orderBy?: InputMaybe<ReadonlyArray<IgAssetOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IgAssetWhereInput>;
};


export type QueryIgHandleArgs = {
  where: IgHandleWhereUniqueInput;
};


export type QueryIgHandlesArgs = {
  cursor?: InputMaybe<IgHandleWhereUniqueInput>;
  distinct?: InputMaybe<ReadonlyArray<IgHandleScalarFieldEnum>>;
  orderBy?: InputMaybe<ReadonlyArray<IgHandleOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IgHandleWhereInput>;
};


export type QuerySessionArgs = {
  where: SessionWhereUniqueInput;
};


export type QuerySessionsArgs = {
  cursor?: InputMaybe<SessionWhereUniqueInput>;
  distinct?: InputMaybe<ReadonlyArray<SessionScalarFieldEnum>>;
  orderBy?: InputMaybe<ReadonlyArray<SessionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SessionWhereInput>;
};


export type QueryTagArgs = {
  where: TagWhereUniqueInput;
};


export type QueryTagsArgs = {
  cursor?: InputMaybe<TagWhereUniqueInput>;
  distinct?: InputMaybe<ReadonlyArray<TagScalarFieldEnum>>;
  orderBy?: InputMaybe<ReadonlyArray<TagOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TagWhereInput>;
};


export type QueryUserArgs = {
  where: UserWhereUniqueInput;
};


export type QueryUsersArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  distinct?: InputMaybe<ReadonlyArray<UserScalarFieldEnum>>;
  orderBy?: InputMaybe<ReadonlyArray<UserOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserWhereInput>;
};


export type QueryVerificationTokenArgs = {
  where: VerificationTokenWhereUniqueInput;
};


export type QueryVerificationTokensArgs = {
  cursor?: InputMaybe<VerificationTokenWhereUniqueInput>;
  distinct?: InputMaybe<ReadonlyArray<VerificationTokenScalarFieldEnum>>;
  orderBy?: InputMaybe<ReadonlyArray<VerificationTokenOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<VerificationTokenWhereInput>;
};

export const QueryMode = {
  Default: 'default',
  Insensitive: 'insensitive'
} as const;

export type QueryMode = typeof QueryMode[keyof typeof QueryMode];
export type Session = {
  readonly __typename?: 'Session';
  readonly expires: Scalars['DateTime'];
  readonly id: Scalars['String'];
  readonly sessionToken: Scalars['String'];
  readonly user: User;
  readonly userId: Scalars['String'];
};

export type SessionCountAggregate = {
  readonly __typename?: 'SessionCountAggregate';
  readonly _all: Scalars['Int'];
  readonly expires: Scalars['Int'];
  readonly id: Scalars['Int'];
  readonly sessionToken: Scalars['Int'];
  readonly userId: Scalars['Int'];
};

export type SessionCountOrderByAggregateInput = {
  readonly expires?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly sessionToken?: InputMaybe<SortOrder>;
  readonly userId?: InputMaybe<SortOrder>;
};

export type SessionCreateInput = {
  readonly expires: Scalars['DateTime'];
  readonly id?: InputMaybe<Scalars['String']>;
  readonly sessionToken: Scalars['String'];
  readonly user: UserCreateNestedOneWithoutSessionsInput;
};

export type SessionCreateManyInput = {
  readonly expires: Scalars['DateTime'];
  readonly id?: InputMaybe<Scalars['String']>;
  readonly sessionToken: Scalars['String'];
  readonly userId: Scalars['String'];
};

export type SessionCreateManyUserInput = {
  readonly expires: Scalars['DateTime'];
  readonly id?: InputMaybe<Scalars['String']>;
  readonly sessionToken: Scalars['String'];
};

export type SessionCreateManyUserInputEnvelope = {
  readonly data: ReadonlyArray<SessionCreateManyUserInput>;
  readonly skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type SessionCreateNestedManyWithoutUserInput = {
  readonly connect?: InputMaybe<ReadonlyArray<SessionWhereUniqueInput>>;
  readonly connectOrCreate?: InputMaybe<ReadonlyArray<SessionCreateOrConnectWithoutUserInput>>;
  readonly create?: InputMaybe<ReadonlyArray<SessionCreateWithoutUserInput>>;
  readonly createMany?: InputMaybe<SessionCreateManyUserInputEnvelope>;
};

export type SessionCreateOrConnectWithoutUserInput = {
  readonly create: SessionCreateWithoutUserInput;
  readonly where: SessionWhereUniqueInput;
};

export type SessionCreateWithoutUserInput = {
  readonly expires: Scalars['DateTime'];
  readonly id?: InputMaybe<Scalars['String']>;
  readonly sessionToken: Scalars['String'];
};

export type SessionGroupBy = {
  readonly __typename?: 'SessionGroupBy';
  readonly _count?: Maybe<SessionCountAggregate>;
  readonly _max?: Maybe<SessionMaxAggregate>;
  readonly _min?: Maybe<SessionMinAggregate>;
  readonly expires: Scalars['DateTime'];
  readonly id: Scalars['String'];
  readonly sessionToken: Scalars['String'];
  readonly userId: Scalars['String'];
};

export type SessionListRelationFilter = {
  readonly every?: InputMaybe<SessionWhereInput>;
  readonly none?: InputMaybe<SessionWhereInput>;
  readonly some?: InputMaybe<SessionWhereInput>;
};

export type SessionMaxAggregate = {
  readonly __typename?: 'SessionMaxAggregate';
  readonly expires?: Maybe<Scalars['DateTime']>;
  readonly id?: Maybe<Scalars['String']>;
  readonly sessionToken?: Maybe<Scalars['String']>;
  readonly userId?: Maybe<Scalars['String']>;
};

export type SessionMaxOrderByAggregateInput = {
  readonly expires?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly sessionToken?: InputMaybe<SortOrder>;
  readonly userId?: InputMaybe<SortOrder>;
};

export type SessionMinAggregate = {
  readonly __typename?: 'SessionMinAggregate';
  readonly expires?: Maybe<Scalars['DateTime']>;
  readonly id?: Maybe<Scalars['String']>;
  readonly sessionToken?: Maybe<Scalars['String']>;
  readonly userId?: Maybe<Scalars['String']>;
};

export type SessionMinOrderByAggregateInput = {
  readonly expires?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly sessionToken?: InputMaybe<SortOrder>;
  readonly userId?: InputMaybe<SortOrder>;
};

export type SessionOrderByRelationAggregateInput = {
  readonly _count?: InputMaybe<SortOrder>;
};

export type SessionOrderByWithAggregationInput = {
  readonly _count?: InputMaybe<SessionCountOrderByAggregateInput>;
  readonly _max?: InputMaybe<SessionMaxOrderByAggregateInput>;
  readonly _min?: InputMaybe<SessionMinOrderByAggregateInput>;
  readonly expires?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly sessionToken?: InputMaybe<SortOrder>;
  readonly userId?: InputMaybe<SortOrder>;
};

export type SessionOrderByWithRelationInput = {
  readonly expires?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly sessionToken?: InputMaybe<SortOrder>;
  readonly user?: InputMaybe<UserOrderByWithRelationInput>;
  readonly userId?: InputMaybe<SortOrder>;
};

export const SessionScalarFieldEnum = {
  Expires: 'expires',
  Id: 'id',
  SessionToken: 'sessionToken',
  UserId: 'userId'
} as const;

export type SessionScalarFieldEnum = typeof SessionScalarFieldEnum[keyof typeof SessionScalarFieldEnum];
export type SessionScalarWhereInput = {
  readonly AND?: InputMaybe<ReadonlyArray<SessionScalarWhereInput>>;
  readonly NOT?: InputMaybe<ReadonlyArray<SessionScalarWhereInput>>;
  readonly OR?: InputMaybe<ReadonlyArray<SessionScalarWhereInput>>;
  readonly expires?: InputMaybe<DateTimeFilter>;
  readonly id?: InputMaybe<StringFilter>;
  readonly sessionToken?: InputMaybe<StringFilter>;
  readonly userId?: InputMaybe<StringFilter>;
};

export type SessionScalarWhereWithAggregatesInput = {
  readonly AND?: InputMaybe<ReadonlyArray<SessionScalarWhereWithAggregatesInput>>;
  readonly NOT?: InputMaybe<ReadonlyArray<SessionScalarWhereWithAggregatesInput>>;
  readonly OR?: InputMaybe<ReadonlyArray<SessionScalarWhereWithAggregatesInput>>;
  readonly expires?: InputMaybe<DateTimeWithAggregatesFilter>;
  readonly id?: InputMaybe<StringWithAggregatesFilter>;
  readonly sessionToken?: InputMaybe<StringWithAggregatesFilter>;
  readonly userId?: InputMaybe<StringWithAggregatesFilter>;
};

export type SessionUpdateInput = {
  readonly expires?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  readonly id?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly sessionToken?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly user?: InputMaybe<UserUpdateOneRequiredWithoutSessionsNestedInput>;
};

export type SessionUpdateManyMutationInput = {
  readonly expires?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  readonly id?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly sessionToken?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type SessionUpdateManyWithWhereWithoutUserInput = {
  readonly data: SessionUpdateManyMutationInput;
  readonly where: SessionScalarWhereInput;
};

export type SessionUpdateManyWithoutUserNestedInput = {
  readonly connect?: InputMaybe<ReadonlyArray<SessionWhereUniqueInput>>;
  readonly connectOrCreate?: InputMaybe<ReadonlyArray<SessionCreateOrConnectWithoutUserInput>>;
  readonly create?: InputMaybe<ReadonlyArray<SessionCreateWithoutUserInput>>;
  readonly createMany?: InputMaybe<SessionCreateManyUserInputEnvelope>;
  readonly delete?: InputMaybe<ReadonlyArray<SessionWhereUniqueInput>>;
  readonly deleteMany?: InputMaybe<ReadonlyArray<SessionScalarWhereInput>>;
  readonly disconnect?: InputMaybe<ReadonlyArray<SessionWhereUniqueInput>>;
  readonly set?: InputMaybe<ReadonlyArray<SessionWhereUniqueInput>>;
  readonly update?: InputMaybe<ReadonlyArray<SessionUpdateWithWhereUniqueWithoutUserInput>>;
  readonly updateMany?: InputMaybe<ReadonlyArray<SessionUpdateManyWithWhereWithoutUserInput>>;
  readonly upsert?: InputMaybe<ReadonlyArray<SessionUpsertWithWhereUniqueWithoutUserInput>>;
};

export type SessionUpdateWithWhereUniqueWithoutUserInput = {
  readonly data: SessionUpdateWithoutUserInput;
  readonly where: SessionWhereUniqueInput;
};

export type SessionUpdateWithoutUserInput = {
  readonly expires?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  readonly id?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly sessionToken?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type SessionUpsertWithWhereUniqueWithoutUserInput = {
  readonly create: SessionCreateWithoutUserInput;
  readonly update: SessionUpdateWithoutUserInput;
  readonly where: SessionWhereUniqueInput;
};

export type SessionWhereInput = {
  readonly AND?: InputMaybe<ReadonlyArray<SessionWhereInput>>;
  readonly NOT?: InputMaybe<ReadonlyArray<SessionWhereInput>>;
  readonly OR?: InputMaybe<ReadonlyArray<SessionWhereInput>>;
  readonly expires?: InputMaybe<DateTimeFilter>;
  readonly id?: InputMaybe<StringFilter>;
  readonly sessionToken?: InputMaybe<StringFilter>;
  readonly user?: InputMaybe<UserRelationFilter>;
  readonly userId?: InputMaybe<StringFilter>;
};

export type SessionWhereUniqueInput = {
  readonly id?: InputMaybe<Scalars['String']>;
  readonly sessionToken?: InputMaybe<Scalars['String']>;
};

export const SortOrder = {
  Asc: 'asc',
  Desc: 'desc'
} as const;

export type SortOrder = typeof SortOrder[keyof typeof SortOrder];
export const StatusType = {
  Approved: 'APPROVED',
  Rejected: 'REJECTED',
  Unset: 'UNSET'
} as const;

export type StatusType = typeof StatusType[keyof typeof StatusType];
export type StringFieldUpdateOperationsInput = {
  readonly set?: InputMaybe<Scalars['String']>;
};

export type StringFilter = {
  readonly contains?: InputMaybe<Scalars['String']>;
  readonly endsWith?: InputMaybe<Scalars['String']>;
  readonly equals?: InputMaybe<Scalars['String']>;
  readonly gt?: InputMaybe<Scalars['String']>;
  readonly gte?: InputMaybe<Scalars['String']>;
  readonly in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly lt?: InputMaybe<Scalars['String']>;
  readonly lte?: InputMaybe<Scalars['String']>;
  readonly mode?: InputMaybe<QueryMode>;
  readonly not?: InputMaybe<NestedStringFilter>;
  readonly notIn?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly startsWith?: InputMaybe<Scalars['String']>;
};

export type StringNullableFilter = {
  readonly contains?: InputMaybe<Scalars['String']>;
  readonly endsWith?: InputMaybe<Scalars['String']>;
  readonly equals?: InputMaybe<Scalars['String']>;
  readonly gt?: InputMaybe<Scalars['String']>;
  readonly gte?: InputMaybe<Scalars['String']>;
  readonly in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly lt?: InputMaybe<Scalars['String']>;
  readonly lte?: InputMaybe<Scalars['String']>;
  readonly mode?: InputMaybe<QueryMode>;
  readonly not?: InputMaybe<NestedStringNullableFilter>;
  readonly notIn?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly startsWith?: InputMaybe<Scalars['String']>;
};

export type StringNullableWithAggregatesFilter = {
  readonly _count?: InputMaybe<NestedIntNullableFilter>;
  readonly _max?: InputMaybe<NestedStringNullableFilter>;
  readonly _min?: InputMaybe<NestedStringNullableFilter>;
  readonly contains?: InputMaybe<Scalars['String']>;
  readonly endsWith?: InputMaybe<Scalars['String']>;
  readonly equals?: InputMaybe<Scalars['String']>;
  readonly gt?: InputMaybe<Scalars['String']>;
  readonly gte?: InputMaybe<Scalars['String']>;
  readonly in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly lt?: InputMaybe<Scalars['String']>;
  readonly lte?: InputMaybe<Scalars['String']>;
  readonly mode?: InputMaybe<QueryMode>;
  readonly not?: InputMaybe<NestedStringNullableWithAggregatesFilter>;
  readonly notIn?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly startsWith?: InputMaybe<Scalars['String']>;
};

export type StringWithAggregatesFilter = {
  readonly _count?: InputMaybe<NestedIntFilter>;
  readonly _max?: InputMaybe<NestedStringFilter>;
  readonly _min?: InputMaybe<NestedStringFilter>;
  readonly contains?: InputMaybe<Scalars['String']>;
  readonly endsWith?: InputMaybe<Scalars['String']>;
  readonly equals?: InputMaybe<Scalars['String']>;
  readonly gt?: InputMaybe<Scalars['String']>;
  readonly gte?: InputMaybe<Scalars['String']>;
  readonly in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly lt?: InputMaybe<Scalars['String']>;
  readonly lte?: InputMaybe<Scalars['String']>;
  readonly mode?: InputMaybe<QueryMode>;
  readonly not?: InputMaybe<NestedStringWithAggregatesFilter>;
  readonly notIn?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly startsWith?: InputMaybe<Scalars['String']>;
};

export type Tag = {
  readonly __typename?: 'Tag';
  readonly _count?: Maybe<TagCount>;
  readonly archived: Scalars['Boolean'];
  readonly archivedAt?: Maybe<Scalars['DateTime']>;
  readonly client: Client;
  readonly clientId: Scalars['String'];
  readonly createdAt: Scalars['DateTime'];
  readonly id: Scalars['String'];
  readonly igAssets: ReadonlyArray<IgAsset>;
  readonly name: Scalars['String'];
  readonly updatedAt: Scalars['DateTime'];
};


export type TagIgAssetsArgs = {
  cursor?: InputMaybe<IgAssetWhereUniqueInput>;
  distinct?: InputMaybe<ReadonlyArray<IgAssetScalarFieldEnum>>;
  orderBy?: InputMaybe<ReadonlyArray<IgAssetOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IgAssetWhereInput>;
};

export type TagCount = {
  readonly __typename?: 'TagCount';
  readonly igAssets: Scalars['Int'];
};

export type TagCountAggregate = {
  readonly __typename?: 'TagCountAggregate';
  readonly _all: Scalars['Int'];
  readonly archived: Scalars['Int'];
  readonly archivedAt: Scalars['Int'];
  readonly clientId: Scalars['Int'];
  readonly createdAt: Scalars['Int'];
  readonly id: Scalars['Int'];
  readonly name: Scalars['Int'];
  readonly updatedAt: Scalars['Int'];
};

export type TagCountOrderByAggregateInput = {
  readonly archived?: InputMaybe<SortOrder>;
  readonly archivedAt?: InputMaybe<SortOrder>;
  readonly clientId?: InputMaybe<SortOrder>;
  readonly createdAt?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly name?: InputMaybe<SortOrder>;
  readonly updatedAt?: InputMaybe<SortOrder>;
};

export type TagCreateInput = {
  readonly archived?: InputMaybe<Scalars['Boolean']>;
  readonly archivedAt?: InputMaybe<Scalars['DateTime']>;
  readonly client: ClientCreateNestedOneWithoutTagsInput;
  readonly createdAt?: InputMaybe<Scalars['DateTime']>;
  readonly id?: InputMaybe<Scalars['String']>;
  readonly igAssets?: InputMaybe<IgAssetCreateNestedManyWithoutTagInput>;
  readonly name: Scalars['String'];
  readonly updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type TagCreateManyClientInput = {
  readonly archived?: InputMaybe<Scalars['Boolean']>;
  readonly archivedAt?: InputMaybe<Scalars['DateTime']>;
  readonly createdAt?: InputMaybe<Scalars['DateTime']>;
  readonly id?: InputMaybe<Scalars['String']>;
  readonly name: Scalars['String'];
  readonly updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type TagCreateManyClientInputEnvelope = {
  readonly data: ReadonlyArray<TagCreateManyClientInput>;
  readonly skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type TagCreateManyInput = {
  readonly archived?: InputMaybe<Scalars['Boolean']>;
  readonly archivedAt?: InputMaybe<Scalars['DateTime']>;
  readonly clientId: Scalars['String'];
  readonly createdAt?: InputMaybe<Scalars['DateTime']>;
  readonly id?: InputMaybe<Scalars['String']>;
  readonly name: Scalars['String'];
  readonly updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type TagCreateNestedManyWithoutClientInput = {
  readonly connect?: InputMaybe<ReadonlyArray<TagWhereUniqueInput>>;
  readonly connectOrCreate?: InputMaybe<ReadonlyArray<TagCreateOrConnectWithoutClientInput>>;
  readonly create?: InputMaybe<ReadonlyArray<TagCreateWithoutClientInput>>;
  readonly createMany?: InputMaybe<TagCreateManyClientInputEnvelope>;
};

export type TagCreateNestedManyWithoutIgAssetsInput = {
  readonly connect?: InputMaybe<ReadonlyArray<TagWhereUniqueInput>>;
  readonly connectOrCreate?: InputMaybe<ReadonlyArray<TagCreateOrConnectWithoutIgAssetsInput>>;
  readonly create?: InputMaybe<ReadonlyArray<TagCreateWithoutIgAssetsInput>>;
};

export type TagCreateOrConnectWithoutClientInput = {
  readonly create: TagCreateWithoutClientInput;
  readonly where: TagWhereUniqueInput;
};

export type TagCreateOrConnectWithoutIgAssetsInput = {
  readonly create: TagCreateWithoutIgAssetsInput;
  readonly where: TagWhereUniqueInput;
};

export type TagCreateWithoutClientInput = {
  readonly archived?: InputMaybe<Scalars['Boolean']>;
  readonly archivedAt?: InputMaybe<Scalars['DateTime']>;
  readonly createdAt?: InputMaybe<Scalars['DateTime']>;
  readonly id?: InputMaybe<Scalars['String']>;
  readonly igAssets?: InputMaybe<IgAssetCreateNestedManyWithoutTagInput>;
  readonly name: Scalars['String'];
  readonly updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type TagCreateWithoutIgAssetsInput = {
  readonly archived?: InputMaybe<Scalars['Boolean']>;
  readonly archivedAt?: InputMaybe<Scalars['DateTime']>;
  readonly client: ClientCreateNestedOneWithoutTagsInput;
  readonly createdAt?: InputMaybe<Scalars['DateTime']>;
  readonly id?: InputMaybe<Scalars['String']>;
  readonly name: Scalars['String'];
  readonly updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type TagGroupBy = {
  readonly __typename?: 'TagGroupBy';
  readonly _count?: Maybe<TagCountAggregate>;
  readonly _max?: Maybe<TagMaxAggregate>;
  readonly _min?: Maybe<TagMinAggregate>;
  readonly archived: Scalars['Boolean'];
  readonly archivedAt?: Maybe<Scalars['DateTime']>;
  readonly clientId: Scalars['String'];
  readonly createdAt: Scalars['DateTime'];
  readonly id: Scalars['String'];
  readonly name: Scalars['String'];
  readonly updatedAt: Scalars['DateTime'];
};

export type TagListRelationFilter = {
  readonly every?: InputMaybe<TagWhereInput>;
  readonly none?: InputMaybe<TagWhereInput>;
  readonly some?: InputMaybe<TagWhereInput>;
};

export type TagMaxAggregate = {
  readonly __typename?: 'TagMaxAggregate';
  readonly archived?: Maybe<Scalars['Boolean']>;
  readonly archivedAt?: Maybe<Scalars['DateTime']>;
  readonly clientId?: Maybe<Scalars['String']>;
  readonly createdAt?: Maybe<Scalars['DateTime']>;
  readonly id?: Maybe<Scalars['String']>;
  readonly name?: Maybe<Scalars['String']>;
  readonly updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TagMaxOrderByAggregateInput = {
  readonly archived?: InputMaybe<SortOrder>;
  readonly archivedAt?: InputMaybe<SortOrder>;
  readonly clientId?: InputMaybe<SortOrder>;
  readonly createdAt?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly name?: InputMaybe<SortOrder>;
  readonly updatedAt?: InputMaybe<SortOrder>;
};

export type TagMinAggregate = {
  readonly __typename?: 'TagMinAggregate';
  readonly archived?: Maybe<Scalars['Boolean']>;
  readonly archivedAt?: Maybe<Scalars['DateTime']>;
  readonly clientId?: Maybe<Scalars['String']>;
  readonly createdAt?: Maybe<Scalars['DateTime']>;
  readonly id?: Maybe<Scalars['String']>;
  readonly name?: Maybe<Scalars['String']>;
  readonly updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TagMinOrderByAggregateInput = {
  readonly archived?: InputMaybe<SortOrder>;
  readonly archivedAt?: InputMaybe<SortOrder>;
  readonly clientId?: InputMaybe<SortOrder>;
  readonly createdAt?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly name?: InputMaybe<SortOrder>;
  readonly updatedAt?: InputMaybe<SortOrder>;
};

export type TagOrderByRelationAggregateInput = {
  readonly _count?: InputMaybe<SortOrder>;
};

export type TagOrderByWithAggregationInput = {
  readonly _count?: InputMaybe<TagCountOrderByAggregateInput>;
  readonly _max?: InputMaybe<TagMaxOrderByAggregateInput>;
  readonly _min?: InputMaybe<TagMinOrderByAggregateInput>;
  readonly archived?: InputMaybe<SortOrder>;
  readonly archivedAt?: InputMaybe<SortOrder>;
  readonly clientId?: InputMaybe<SortOrder>;
  readonly createdAt?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly name?: InputMaybe<SortOrder>;
  readonly updatedAt?: InputMaybe<SortOrder>;
};

export type TagOrderByWithRelationInput = {
  readonly archived?: InputMaybe<SortOrder>;
  readonly archivedAt?: InputMaybe<SortOrder>;
  readonly client?: InputMaybe<ClientOrderByWithRelationInput>;
  readonly clientId?: InputMaybe<SortOrder>;
  readonly createdAt?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly igAssets?: InputMaybe<IgAssetOrderByRelationAggregateInput>;
  readonly name?: InputMaybe<SortOrder>;
  readonly updatedAt?: InputMaybe<SortOrder>;
};

export const TagScalarFieldEnum = {
  Archived: 'archived',
  ArchivedAt: 'archivedAt',
  ClientId: 'clientId',
  CreatedAt: 'createdAt',
  Id: 'id',
  Name: 'name',
  UpdatedAt: 'updatedAt'
} as const;

export type TagScalarFieldEnum = typeof TagScalarFieldEnum[keyof typeof TagScalarFieldEnum];
export type TagScalarWhereInput = {
  readonly AND?: InputMaybe<ReadonlyArray<TagScalarWhereInput>>;
  readonly NOT?: InputMaybe<ReadonlyArray<TagScalarWhereInput>>;
  readonly OR?: InputMaybe<ReadonlyArray<TagScalarWhereInput>>;
  readonly archived?: InputMaybe<BoolFilter>;
  readonly archivedAt?: InputMaybe<DateTimeNullableFilter>;
  readonly clientId?: InputMaybe<StringFilter>;
  readonly createdAt?: InputMaybe<DateTimeFilter>;
  readonly id?: InputMaybe<StringFilter>;
  readonly name?: InputMaybe<StringFilter>;
  readonly updatedAt?: InputMaybe<DateTimeFilter>;
};

export type TagScalarWhereWithAggregatesInput = {
  readonly AND?: InputMaybe<ReadonlyArray<TagScalarWhereWithAggregatesInput>>;
  readonly NOT?: InputMaybe<ReadonlyArray<TagScalarWhereWithAggregatesInput>>;
  readonly OR?: InputMaybe<ReadonlyArray<TagScalarWhereWithAggregatesInput>>;
  readonly archived?: InputMaybe<BoolWithAggregatesFilter>;
  readonly archivedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  readonly clientId?: InputMaybe<StringWithAggregatesFilter>;
  readonly createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  readonly id?: InputMaybe<StringWithAggregatesFilter>;
  readonly name?: InputMaybe<StringWithAggregatesFilter>;
  readonly updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type TagUpdateInput = {
  readonly archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  readonly archivedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  readonly client?: InputMaybe<ClientUpdateOneRequiredWithoutTagsNestedInput>;
  readonly createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  readonly id?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly igAssets?: InputMaybe<IgAssetUpdateManyWithoutTagNestedInput>;
  readonly name?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type TagUpdateManyMutationInput = {
  readonly archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  readonly archivedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  readonly createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  readonly id?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly name?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type TagUpdateManyWithWhereWithoutClientInput = {
  readonly data: TagUpdateManyMutationInput;
  readonly where: TagScalarWhereInput;
};

export type TagUpdateManyWithWhereWithoutIgAssetsInput = {
  readonly data: TagUpdateManyMutationInput;
  readonly where: TagScalarWhereInput;
};

export type TagUpdateManyWithoutClientNestedInput = {
  readonly connect?: InputMaybe<ReadonlyArray<TagWhereUniqueInput>>;
  readonly connectOrCreate?: InputMaybe<ReadonlyArray<TagCreateOrConnectWithoutClientInput>>;
  readonly create?: InputMaybe<ReadonlyArray<TagCreateWithoutClientInput>>;
  readonly createMany?: InputMaybe<TagCreateManyClientInputEnvelope>;
  readonly delete?: InputMaybe<ReadonlyArray<TagWhereUniqueInput>>;
  readonly deleteMany?: InputMaybe<ReadonlyArray<TagScalarWhereInput>>;
  readonly disconnect?: InputMaybe<ReadonlyArray<TagWhereUniqueInput>>;
  readonly set?: InputMaybe<ReadonlyArray<TagWhereUniqueInput>>;
  readonly update?: InputMaybe<ReadonlyArray<TagUpdateWithWhereUniqueWithoutClientInput>>;
  readonly updateMany?: InputMaybe<ReadonlyArray<TagUpdateManyWithWhereWithoutClientInput>>;
  readonly upsert?: InputMaybe<ReadonlyArray<TagUpsertWithWhereUniqueWithoutClientInput>>;
};

export type TagUpdateManyWithoutIgAssetsNestedInput = {
  readonly connect?: InputMaybe<ReadonlyArray<TagWhereUniqueInput>>;
  readonly connectOrCreate?: InputMaybe<ReadonlyArray<TagCreateOrConnectWithoutIgAssetsInput>>;
  readonly create?: InputMaybe<ReadonlyArray<TagCreateWithoutIgAssetsInput>>;
  readonly delete?: InputMaybe<ReadonlyArray<TagWhereUniqueInput>>;
  readonly deleteMany?: InputMaybe<ReadonlyArray<TagScalarWhereInput>>;
  readonly disconnect?: InputMaybe<ReadonlyArray<TagWhereUniqueInput>>;
  readonly set?: InputMaybe<ReadonlyArray<TagWhereUniqueInput>>;
  readonly update?: InputMaybe<ReadonlyArray<TagUpdateWithWhereUniqueWithoutIgAssetsInput>>;
  readonly updateMany?: InputMaybe<ReadonlyArray<TagUpdateManyWithWhereWithoutIgAssetsInput>>;
  readonly upsert?: InputMaybe<ReadonlyArray<TagUpsertWithWhereUniqueWithoutIgAssetsInput>>;
};

export type TagUpdateWithWhereUniqueWithoutClientInput = {
  readonly data: TagUpdateWithoutClientInput;
  readonly where: TagWhereUniqueInput;
};

export type TagUpdateWithWhereUniqueWithoutIgAssetsInput = {
  readonly data: TagUpdateWithoutIgAssetsInput;
  readonly where: TagWhereUniqueInput;
};

export type TagUpdateWithoutClientInput = {
  readonly archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  readonly archivedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  readonly createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  readonly id?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly igAssets?: InputMaybe<IgAssetUpdateManyWithoutTagNestedInput>;
  readonly name?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type TagUpdateWithoutIgAssetsInput = {
  readonly archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  readonly archivedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  readonly client?: InputMaybe<ClientUpdateOneRequiredWithoutTagsNestedInput>;
  readonly createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  readonly id?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly name?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type TagUpsertWithWhereUniqueWithoutClientInput = {
  readonly create: TagCreateWithoutClientInput;
  readonly update: TagUpdateWithoutClientInput;
  readonly where: TagWhereUniqueInput;
};

export type TagUpsertWithWhereUniqueWithoutIgAssetsInput = {
  readonly create: TagCreateWithoutIgAssetsInput;
  readonly update: TagUpdateWithoutIgAssetsInput;
  readonly where: TagWhereUniqueInput;
};

export type TagWhereInput = {
  readonly AND?: InputMaybe<ReadonlyArray<TagWhereInput>>;
  readonly NOT?: InputMaybe<ReadonlyArray<TagWhereInput>>;
  readonly OR?: InputMaybe<ReadonlyArray<TagWhereInput>>;
  readonly archived?: InputMaybe<BoolFilter>;
  readonly archivedAt?: InputMaybe<DateTimeNullableFilter>;
  readonly client?: InputMaybe<ClientRelationFilter>;
  readonly clientId?: InputMaybe<StringFilter>;
  readonly createdAt?: InputMaybe<DateTimeFilter>;
  readonly id?: InputMaybe<StringFilter>;
  readonly igAssets?: InputMaybe<IgAssetListRelationFilter>;
  readonly name?: InputMaybe<StringFilter>;
  readonly updatedAt?: InputMaybe<DateTimeFilter>;
};

export type TagWhereUniqueInput = {
  readonly id?: InputMaybe<Scalars['String']>;
  readonly name?: InputMaybe<Scalars['String']>;
};

export type User = {
  readonly __typename?: 'User';
  readonly _count?: Maybe<UserCount>;
  readonly accounts: ReadonlyArray<Account>;
  readonly description?: Maybe<Scalars['String']>;
  readonly email?: Maybe<Scalars['String']>;
  readonly emailVerified?: Maybe<Scalars['DateTime']>;
  readonly id: Scalars['String'];
  readonly image?: Maybe<Scalars['String']>;
  readonly name?: Maybe<Scalars['String']>;
  readonly sessions: ReadonlyArray<Session>;
};


export type UserAccountsArgs = {
  cursor?: InputMaybe<AccountWhereUniqueInput>;
  distinct?: InputMaybe<ReadonlyArray<AccountScalarFieldEnum>>;
  orderBy?: InputMaybe<ReadonlyArray<AccountOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccountWhereInput>;
};


export type UserSessionsArgs = {
  cursor?: InputMaybe<SessionWhereUniqueInput>;
  distinct?: InputMaybe<ReadonlyArray<SessionScalarFieldEnum>>;
  orderBy?: InputMaybe<ReadonlyArray<SessionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SessionWhereInput>;
};

export type UserCount = {
  readonly __typename?: 'UserCount';
  readonly accounts: Scalars['Int'];
  readonly sessions: Scalars['Int'];
};

export type UserCountAggregate = {
  readonly __typename?: 'UserCountAggregate';
  readonly _all: Scalars['Int'];
  readonly description: Scalars['Int'];
  readonly email: Scalars['Int'];
  readonly emailVerified: Scalars['Int'];
  readonly id: Scalars['Int'];
  readonly image: Scalars['Int'];
  readonly name: Scalars['Int'];
};

export type UserCountOrderByAggregateInput = {
  readonly description?: InputMaybe<SortOrder>;
  readonly email?: InputMaybe<SortOrder>;
  readonly emailVerified?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly image?: InputMaybe<SortOrder>;
  readonly name?: InputMaybe<SortOrder>;
};

export type UserCreateInput = {
  readonly accounts?: InputMaybe<AccountCreateNestedManyWithoutUserInput>;
  readonly description?: InputMaybe<Scalars['String']>;
  readonly email?: InputMaybe<Scalars['String']>;
  readonly emailVerified?: InputMaybe<Scalars['DateTime']>;
  readonly id?: InputMaybe<Scalars['String']>;
  readonly image?: InputMaybe<Scalars['String']>;
  readonly name?: InputMaybe<Scalars['String']>;
  readonly sessions?: InputMaybe<SessionCreateNestedManyWithoutUserInput>;
};

export type UserCreateManyInput = {
  readonly description?: InputMaybe<Scalars['String']>;
  readonly email?: InputMaybe<Scalars['String']>;
  readonly emailVerified?: InputMaybe<Scalars['DateTime']>;
  readonly id?: InputMaybe<Scalars['String']>;
  readonly image?: InputMaybe<Scalars['String']>;
  readonly name?: InputMaybe<Scalars['String']>;
};

export type UserCreateNestedOneWithoutAccountsInput = {
  readonly connect?: InputMaybe<UserWhereUniqueInput>;
  readonly connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutAccountsInput>;
  readonly create?: InputMaybe<UserCreateWithoutAccountsInput>;
};

export type UserCreateNestedOneWithoutSessionsInput = {
  readonly connect?: InputMaybe<UserWhereUniqueInput>;
  readonly connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutSessionsInput>;
  readonly create?: InputMaybe<UserCreateWithoutSessionsInput>;
};

export type UserCreateOrConnectWithoutAccountsInput = {
  readonly create: UserCreateWithoutAccountsInput;
  readonly where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutSessionsInput = {
  readonly create: UserCreateWithoutSessionsInput;
  readonly where: UserWhereUniqueInput;
};

export type UserCreateWithoutAccountsInput = {
  readonly description?: InputMaybe<Scalars['String']>;
  readonly email?: InputMaybe<Scalars['String']>;
  readonly emailVerified?: InputMaybe<Scalars['DateTime']>;
  readonly id?: InputMaybe<Scalars['String']>;
  readonly image?: InputMaybe<Scalars['String']>;
  readonly name?: InputMaybe<Scalars['String']>;
  readonly sessions?: InputMaybe<SessionCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutSessionsInput = {
  readonly accounts?: InputMaybe<AccountCreateNestedManyWithoutUserInput>;
  readonly description?: InputMaybe<Scalars['String']>;
  readonly email?: InputMaybe<Scalars['String']>;
  readonly emailVerified?: InputMaybe<Scalars['DateTime']>;
  readonly id?: InputMaybe<Scalars['String']>;
  readonly image?: InputMaybe<Scalars['String']>;
  readonly name?: InputMaybe<Scalars['String']>;
};

export type UserGroupBy = {
  readonly __typename?: 'UserGroupBy';
  readonly _count?: Maybe<UserCountAggregate>;
  readonly _max?: Maybe<UserMaxAggregate>;
  readonly _min?: Maybe<UserMinAggregate>;
  readonly description?: Maybe<Scalars['String']>;
  readonly email?: Maybe<Scalars['String']>;
  readonly emailVerified?: Maybe<Scalars['DateTime']>;
  readonly id: Scalars['String'];
  readonly image?: Maybe<Scalars['String']>;
  readonly name?: Maybe<Scalars['String']>;
};

export type UserMaxAggregate = {
  readonly __typename?: 'UserMaxAggregate';
  readonly description?: Maybe<Scalars['String']>;
  readonly email?: Maybe<Scalars['String']>;
  readonly emailVerified?: Maybe<Scalars['DateTime']>;
  readonly id?: Maybe<Scalars['String']>;
  readonly image?: Maybe<Scalars['String']>;
  readonly name?: Maybe<Scalars['String']>;
};

export type UserMaxOrderByAggregateInput = {
  readonly description?: InputMaybe<SortOrder>;
  readonly email?: InputMaybe<SortOrder>;
  readonly emailVerified?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly image?: InputMaybe<SortOrder>;
  readonly name?: InputMaybe<SortOrder>;
};

export type UserMinAggregate = {
  readonly __typename?: 'UserMinAggregate';
  readonly description?: Maybe<Scalars['String']>;
  readonly email?: Maybe<Scalars['String']>;
  readonly emailVerified?: Maybe<Scalars['DateTime']>;
  readonly id?: Maybe<Scalars['String']>;
  readonly image?: Maybe<Scalars['String']>;
  readonly name?: Maybe<Scalars['String']>;
};

export type UserMinOrderByAggregateInput = {
  readonly description?: InputMaybe<SortOrder>;
  readonly email?: InputMaybe<SortOrder>;
  readonly emailVerified?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly image?: InputMaybe<SortOrder>;
  readonly name?: InputMaybe<SortOrder>;
};

export type UserOrderByWithAggregationInput = {
  readonly _count?: InputMaybe<UserCountOrderByAggregateInput>;
  readonly _max?: InputMaybe<UserMaxOrderByAggregateInput>;
  readonly _min?: InputMaybe<UserMinOrderByAggregateInput>;
  readonly description?: InputMaybe<SortOrder>;
  readonly email?: InputMaybe<SortOrder>;
  readonly emailVerified?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly image?: InputMaybe<SortOrder>;
  readonly name?: InputMaybe<SortOrder>;
};

export type UserOrderByWithRelationInput = {
  readonly accounts?: InputMaybe<AccountOrderByRelationAggregateInput>;
  readonly description?: InputMaybe<SortOrder>;
  readonly email?: InputMaybe<SortOrder>;
  readonly emailVerified?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly image?: InputMaybe<SortOrder>;
  readonly name?: InputMaybe<SortOrder>;
  readonly sessions?: InputMaybe<SessionOrderByRelationAggregateInput>;
};

export type UserRelationFilter = {
  readonly is?: InputMaybe<UserWhereInput>;
  readonly isNot?: InputMaybe<UserWhereInput>;
};

export const UserScalarFieldEnum = {
  Description: 'description',
  Email: 'email',
  EmailVerified: 'emailVerified',
  Id: 'id',
  Image: 'image',
  Name: 'name'
} as const;

export type UserScalarFieldEnum = typeof UserScalarFieldEnum[keyof typeof UserScalarFieldEnum];
export type UserScalarWhereWithAggregatesInput = {
  readonly AND?: InputMaybe<ReadonlyArray<UserScalarWhereWithAggregatesInput>>;
  readonly NOT?: InputMaybe<ReadonlyArray<UserScalarWhereWithAggregatesInput>>;
  readonly OR?: InputMaybe<ReadonlyArray<UserScalarWhereWithAggregatesInput>>;
  readonly description?: InputMaybe<StringNullableWithAggregatesFilter>;
  readonly email?: InputMaybe<StringNullableWithAggregatesFilter>;
  readonly emailVerified?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  readonly id?: InputMaybe<StringWithAggregatesFilter>;
  readonly image?: InputMaybe<StringNullableWithAggregatesFilter>;
  readonly name?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type UserUpdateInput = {
  readonly accounts?: InputMaybe<AccountUpdateManyWithoutUserNestedInput>;
  readonly description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  readonly id?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly sessions?: InputMaybe<SessionUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateManyMutationInput = {
  readonly description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  readonly id?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserUpdateOneRequiredWithoutAccountsNestedInput = {
  readonly connect?: InputMaybe<UserWhereUniqueInput>;
  readonly connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutAccountsInput>;
  readonly create?: InputMaybe<UserCreateWithoutAccountsInput>;
  readonly update?: InputMaybe<UserUpdateWithoutAccountsInput>;
  readonly upsert?: InputMaybe<UserUpsertWithoutAccountsInput>;
};

export type UserUpdateOneRequiredWithoutSessionsNestedInput = {
  readonly connect?: InputMaybe<UserWhereUniqueInput>;
  readonly connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutSessionsInput>;
  readonly create?: InputMaybe<UserCreateWithoutSessionsInput>;
  readonly update?: InputMaybe<UserUpdateWithoutSessionsInput>;
  readonly upsert?: InputMaybe<UserUpsertWithoutSessionsInput>;
};

export type UserUpdateWithoutAccountsInput = {
  readonly description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  readonly id?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly sessions?: InputMaybe<SessionUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutSessionsInput = {
  readonly accounts?: InputMaybe<AccountUpdateManyWithoutUserNestedInput>;
  readonly description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  readonly id?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserUpsertWithoutAccountsInput = {
  readonly create: UserCreateWithoutAccountsInput;
  readonly update: UserUpdateWithoutAccountsInput;
};

export type UserUpsertWithoutSessionsInput = {
  readonly create: UserCreateWithoutSessionsInput;
  readonly update: UserUpdateWithoutSessionsInput;
};

export type UserWhereInput = {
  readonly AND?: InputMaybe<ReadonlyArray<UserWhereInput>>;
  readonly NOT?: InputMaybe<ReadonlyArray<UserWhereInput>>;
  readonly OR?: InputMaybe<ReadonlyArray<UserWhereInput>>;
  readonly accounts?: InputMaybe<AccountListRelationFilter>;
  readonly description?: InputMaybe<StringNullableFilter>;
  readonly email?: InputMaybe<StringNullableFilter>;
  readonly emailVerified?: InputMaybe<DateTimeNullableFilter>;
  readonly id?: InputMaybe<StringFilter>;
  readonly image?: InputMaybe<StringNullableFilter>;
  readonly name?: InputMaybe<StringNullableFilter>;
  readonly sessions?: InputMaybe<SessionListRelationFilter>;
};

export type UserWhereUniqueInput = {
  readonly email?: InputMaybe<Scalars['String']>;
  readonly id?: InputMaybe<Scalars['String']>;
};

export type VerificationToken = {
  readonly __typename?: 'VerificationToken';
  readonly expires: Scalars['DateTime'];
  readonly identifier: Scalars['String'];
  readonly token: Scalars['String'];
};

export type VerificationTokenCountAggregate = {
  readonly __typename?: 'VerificationTokenCountAggregate';
  readonly _all: Scalars['Int'];
  readonly expires: Scalars['Int'];
  readonly identifier: Scalars['Int'];
  readonly token: Scalars['Int'];
};

export type VerificationTokenCountOrderByAggregateInput = {
  readonly expires?: InputMaybe<SortOrder>;
  readonly identifier?: InputMaybe<SortOrder>;
  readonly token?: InputMaybe<SortOrder>;
};

export type VerificationTokenCreateInput = {
  readonly expires: Scalars['DateTime'];
  readonly identifier: Scalars['String'];
  readonly token: Scalars['String'];
};

export type VerificationTokenCreateManyInput = {
  readonly expires: Scalars['DateTime'];
  readonly identifier: Scalars['String'];
  readonly token: Scalars['String'];
};

export type VerificationTokenGroupBy = {
  readonly __typename?: 'VerificationTokenGroupBy';
  readonly _count?: Maybe<VerificationTokenCountAggregate>;
  readonly _max?: Maybe<VerificationTokenMaxAggregate>;
  readonly _min?: Maybe<VerificationTokenMinAggregate>;
  readonly expires: Scalars['DateTime'];
  readonly identifier: Scalars['String'];
  readonly token: Scalars['String'];
};

export type VerificationTokenIdentifierTokenCompoundUniqueInput = {
  readonly identifier: Scalars['String'];
  readonly token: Scalars['String'];
};

export type VerificationTokenMaxAggregate = {
  readonly __typename?: 'VerificationTokenMaxAggregate';
  readonly expires?: Maybe<Scalars['DateTime']>;
  readonly identifier?: Maybe<Scalars['String']>;
  readonly token?: Maybe<Scalars['String']>;
};

export type VerificationTokenMaxOrderByAggregateInput = {
  readonly expires?: InputMaybe<SortOrder>;
  readonly identifier?: InputMaybe<SortOrder>;
  readonly token?: InputMaybe<SortOrder>;
};

export type VerificationTokenMinAggregate = {
  readonly __typename?: 'VerificationTokenMinAggregate';
  readonly expires?: Maybe<Scalars['DateTime']>;
  readonly identifier?: Maybe<Scalars['String']>;
  readonly token?: Maybe<Scalars['String']>;
};

export type VerificationTokenMinOrderByAggregateInput = {
  readonly expires?: InputMaybe<SortOrder>;
  readonly identifier?: InputMaybe<SortOrder>;
  readonly token?: InputMaybe<SortOrder>;
};

export type VerificationTokenOrderByWithAggregationInput = {
  readonly _count?: InputMaybe<VerificationTokenCountOrderByAggregateInput>;
  readonly _max?: InputMaybe<VerificationTokenMaxOrderByAggregateInput>;
  readonly _min?: InputMaybe<VerificationTokenMinOrderByAggregateInput>;
  readonly expires?: InputMaybe<SortOrder>;
  readonly identifier?: InputMaybe<SortOrder>;
  readonly token?: InputMaybe<SortOrder>;
};

export type VerificationTokenOrderByWithRelationInput = {
  readonly expires?: InputMaybe<SortOrder>;
  readonly identifier?: InputMaybe<SortOrder>;
  readonly token?: InputMaybe<SortOrder>;
};

export const VerificationTokenScalarFieldEnum = {
  Expires: 'expires',
  Identifier: 'identifier',
  Token: 'token'
} as const;

export type VerificationTokenScalarFieldEnum = typeof VerificationTokenScalarFieldEnum[keyof typeof VerificationTokenScalarFieldEnum];
export type VerificationTokenScalarWhereWithAggregatesInput = {
  readonly AND?: InputMaybe<ReadonlyArray<VerificationTokenScalarWhereWithAggregatesInput>>;
  readonly NOT?: InputMaybe<ReadonlyArray<VerificationTokenScalarWhereWithAggregatesInput>>;
  readonly OR?: InputMaybe<ReadonlyArray<VerificationTokenScalarWhereWithAggregatesInput>>;
  readonly expires?: InputMaybe<DateTimeWithAggregatesFilter>;
  readonly identifier?: InputMaybe<StringWithAggregatesFilter>;
  readonly token?: InputMaybe<StringWithAggregatesFilter>;
};

export type VerificationTokenUpdateInput = {
  readonly expires?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  readonly identifier?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly token?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type VerificationTokenUpdateManyMutationInput = {
  readonly expires?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  readonly identifier?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly token?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type VerificationTokenWhereInput = {
  readonly AND?: InputMaybe<ReadonlyArray<VerificationTokenWhereInput>>;
  readonly NOT?: InputMaybe<ReadonlyArray<VerificationTokenWhereInput>>;
  readonly OR?: InputMaybe<ReadonlyArray<VerificationTokenWhereInput>>;
  readonly expires?: InputMaybe<DateTimeFilter>;
  readonly identifier?: InputMaybe<StringFilter>;
  readonly token?: InputMaybe<StringFilter>;
};

export type VerificationTokenWhereUniqueInput = {
  readonly identifier_token?: InputMaybe<VerificationTokenIdentifierTokenCompoundUniqueInput>;
  readonly token?: InputMaybe<Scalars['String']>;
};

export type GetUserQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type GetUserQuery = { readonly __typename?: 'Query', readonly user?: { readonly __typename?: 'User', readonly email?: string | undefined, readonly image?: string | undefined, readonly id: string } | undefined };

export type GetUserByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetUserByIdQuery = { readonly __typename?: 'Query', readonly user?: { readonly __typename?: 'User', readonly email?: string | undefined, readonly image?: string | undefined, readonly id: string, readonly description?: string | undefined, readonly name?: string | undefined } | undefined };

export type GetUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUsersQuery = { readonly __typename?: 'Query', readonly users: ReadonlyArray<{ readonly __typename?: 'User', readonly id: string }> };

export type AddClientMutationVariables = Exact<{
  name: Scalars['String'];
}>;


export type AddClientMutation = { readonly __typename?: 'Mutation', readonly createOneClient: { readonly __typename?: 'Client', readonly id: string, readonly name: string } };

export type DeleteClientMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteClientMutation = { readonly __typename?: 'Mutation', readonly deleteOneClient?: { readonly __typename?: 'Client', readonly id: string, readonly name: string } | undefined };

export type DisconnectInstagramHandleFromClientMutationVariables = Exact<{
  handleId: Scalars['String'];
  clientId: Scalars['String'];
}>;


export type DisconnectInstagramHandleFromClientMutation = { readonly __typename?: 'Mutation', readonly updateOneIgHandle?: { readonly __typename?: 'IgHandle', readonly id: string, readonly handle: string, readonly igClients: ReadonlyArray<{ readonly __typename?: 'Client', readonly id: string, readonly name: string }> } | undefined };

export type GetClientQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetClientQuery = { readonly __typename?: 'Query', readonly client?: { readonly __typename?: 'Client', readonly id: string, readonly archived: boolean, readonly archivedAt?: string | undefined, readonly name: string, readonly tags: ReadonlyArray<{ readonly __typename?: 'Tag', readonly id: string, readonly name: string, readonly archived: boolean, readonly archivedAt?: string | undefined }>, readonly igHandles: ReadonlyArray<{ readonly __typename?: 'IgHandle', readonly id: string, readonly handle: string }> } | undefined };

export type GetClientUnsetStoriesQueryVariables = Exact<{
  handleIds: ReadonlyArray<Scalars['String']> | Scalars['String'];
}>;


export type GetClientUnsetStoriesQuery = { readonly __typename?: 'Query', readonly igAssets: ReadonlyArray<{ readonly __typename?: 'IgAsset', readonly id: string }> };

export type GetClientsQueryVariables = Exact<{
  showArchived: Scalars['Boolean'];
}>;


export type GetClientsQuery = { readonly __typename?: 'Query', readonly clients: ReadonlyArray<{ readonly __typename?: 'Client', readonly id: string, readonly name: string, readonly igHandles: ReadonlyArray<{ readonly __typename?: 'IgHandle', readonly id: string }> }> };

export type GetInstagramHandlesForClientQueryVariables = Exact<{
  clientId: Scalars['String'];
}>;


export type GetInstagramHandlesForClientQuery = { readonly __typename?: 'Query', readonly igHandles: ReadonlyArray<{ readonly __typename?: 'IgHandle', readonly id: string, readonly handle: string }> };

export type StillFollowingHandlesQueryVariables = Exact<{ [key: string]: never; }>;


export type StillFollowingHandlesQuery = { readonly __typename?: 'Query', readonly igHandles: ReadonlyArray<{ readonly __typename?: 'IgHandle', readonly id: string, readonly handle: string, readonly followers: number, readonly igClients: ReadonlyArray<{ readonly __typename?: 'Client', readonly id: string, readonly name: string }> }> };

export type UnassignedHandlesQueryVariables = Exact<{ [key: string]: never; }>;


export type UnassignedHandlesQuery = { readonly __typename?: 'Query', readonly igHandles: ReadonlyArray<{ readonly __typename?: 'IgHandle', readonly id: string, readonly handle: string, readonly followers: number }> };

export type UpdateClientArchivedMutationVariables = Exact<{
  clientId: Scalars['String'];
  isArchived: Scalars['Boolean'];
  archivedAt: Scalars['DateTime'];
}>;


export type UpdateClientArchivedMutation = { readonly __typename?: 'Mutation', readonly updateOneClient?: { readonly __typename?: 'Client', readonly id: string, readonly archivedAt?: string | undefined, readonly archived: boolean } | undefined };

export type UpdateClientNameMutationVariables = Exact<{
  id: Scalars['String'];
  name: Scalars['String'];
}>;


export type UpdateClientNameMutation = { readonly __typename?: 'Mutation', readonly updateOneClient?: { readonly __typename?: 'Client', readonly id: string } | undefined };

export type UpsertInstagramHandleMutationVariables = Exact<{
  name: Scalars['String'];
  clientId: Scalars['String'];
}>;


export type UpsertInstagramHandleMutation = { readonly __typename?: 'Mutation', readonly upsertOneIgHandle: { readonly __typename?: 'IgHandle', readonly id: string, readonly handle: string } };

export type GetAllClientsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllClientsQuery = { readonly __typename?: 'Query', readonly clients: ReadonlyArray<{ readonly __typename?: 'Client', readonly id: string, readonly name: string }> };

export type GetAllHandlesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllHandlesQuery = { readonly __typename?: 'Query', readonly igHandles: ReadonlyArray<{ readonly __typename?: 'IgHandle', readonly id: string, readonly handle: string }> };

export type GetAllTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllTagsQuery = { readonly __typename?: 'Query', readonly tags: ReadonlyArray<{ readonly __typename?: 'Tag', readonly id: string, readonly name: string }> };

export type GetAssetsQueryVariables = Exact<{
  where: IgAssetWhereInput;
  take: Scalars['Int'];
  skip: Scalars['Int'];
}>;


export type GetAssetsQuery = { readonly __typename?: 'Query', readonly igAssets: ReadonlyArray<{ readonly __typename?: 'IgAsset', readonly id: string, readonly createdAt: string, readonly screenshotUrl?: string | undefined, readonly proofUrl: string, readonly videoUrl?: string | undefined, readonly igId: string, readonly accountUsed: string, readonly status: StatusType, readonly igHandle: { readonly __typename?: 'IgHandle', readonly handle: string, readonly followers: number }, readonly tag: ReadonlyArray<{ readonly __typename?: 'Tag', readonly id: string, readonly name: string }> }> };

export type GetAssetsCountQueryVariables = Exact<{
  where: IgAssetWhereInput;
}>;


export type GetAssetsCountQuery = { readonly __typename?: 'Query', readonly igAssets: ReadonlyArray<{ readonly __typename?: 'IgAsset', readonly id: string }> };

export type GetHandlesForClientsQueryVariables = Exact<{
  clientNames: ReadonlyArray<Scalars['String']> | Scalars['String'];
}>;


export type GetHandlesForClientsQuery = { readonly __typename?: 'Query', readonly clients: ReadonlyArray<{ readonly __typename?: 'Client', readonly igHandles: ReadonlyArray<{ readonly __typename?: 'IgHandle', readonly id: string }> }> };

export type SetAssetApprovedMutationVariables = Exact<{
  id: Scalars['String'];
  tags: ReadonlyArray<TagWhereUniqueInput> | TagWhereUniqueInput;
}>;


export type SetAssetApprovedMutation = { readonly __typename?: 'Mutation', readonly updateOneIgAsset?: { readonly __typename?: 'IgAsset', readonly id: string, readonly igId: string, readonly status: StatusType, readonly tag: ReadonlyArray<{ readonly __typename?: 'Tag', readonly id: string, readonly name: string }> } | undefined };

export type SetAssetStatusMutationVariables = Exact<{
  status: StatusType;
  id: Scalars['String'];
}>;


export type SetAssetStatusMutation = { readonly __typename?: 'Mutation', readonly updateOneIgAsset?: { readonly __typename?: 'IgAsset', readonly id: string, readonly igId: string, readonly status: StatusType } | undefined };

export type SetAssetTagsMutationVariables = Exact<{
  id: Scalars['String'];
  tags: ReadonlyArray<TagWhereUniqueInput> | TagWhereUniqueInput;
}>;


export type SetAssetTagsMutation = { readonly __typename?: 'Mutation', readonly updateOneIgAsset?: { readonly __typename?: 'IgAsset', readonly id: string, readonly igId: string, readonly status: StatusType, readonly tag: ReadonlyArray<{ readonly __typename?: 'Tag', readonly id: string, readonly name: string }> } | undefined };

export type AddTagMutationVariables = Exact<{
  name: Scalars['String'];
  clientId: Scalars['String'];
}>;


export type AddTagMutation = { readonly __typename?: 'Mutation', readonly createOneTag: { readonly __typename?: 'Tag', readonly id: string, readonly name: string, readonly clientId: string } };

export type GetApprovedAssetsForTagQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetApprovedAssetsForTagQuery = { readonly __typename?: 'Query', readonly igAssets: ReadonlyArray<{ readonly __typename?: 'IgAsset', readonly id: string }> };

export type GetTagQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetTagQuery = { readonly __typename?: 'Query', readonly tag?: { readonly __typename?: 'Tag', readonly id: string, readonly name: string, readonly archived: boolean, readonly archivedAt?: string | undefined } | undefined };

export type GetTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTagsQuery = { readonly __typename?: 'Query', readonly tags: ReadonlyArray<{ readonly __typename?: 'Tag', readonly id: string, readonly name: string }> };

export type RemoveTagMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveTagMutation = { readonly __typename?: 'Mutation', readonly deleteOneTag?: { readonly __typename?: 'Tag', readonly id: string } | undefined };

export type UpdateTagMutationVariables = Exact<{
  id: Scalars['String'];
  name: Scalars['String'];
}>;


export type UpdateTagMutation = { readonly __typename?: 'Mutation', readonly updateOneTag?: { readonly __typename?: 'Tag', readonly id: string } | undefined };

export type UpdateTagArchivedMutationVariables = Exact<{
  tagId: Scalars['String'];
  isArchived: Scalars['Boolean'];
  archivedAt: Scalars['DateTime'];
}>;


export type UpdateTagArchivedMutation = { readonly __typename?: 'Mutation', readonly updateOneTag?: { readonly __typename?: 'Tag', readonly id: string, readonly archivedAt?: string | undefined, readonly archived: boolean } | undefined };

export type AddAllowedEmailMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type AddAllowedEmailMutation = { readonly __typename?: 'Mutation', readonly createOneDevAllowedEmail: { readonly __typename?: 'DevAllowedEmail', readonly id: string, readonly email: string } };

export type GetAllowedEmailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllowedEmailsQuery = { readonly __typename?: 'Query', readonly devAllowedEmails: ReadonlyArray<{ readonly __typename?: 'DevAllowedEmail', readonly id: string, readonly email: string }> };

export type RemoveAllowedEmailMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type RemoveAllowedEmailMutation = { readonly __typename?: 'Mutation', readonly deleteOneDevAllowedEmail?: { readonly __typename?: 'DevAllowedEmail', readonly id: string } | undefined };


export const GetUserDocument = gql`
    query getUser($email: String!) {
  user(where: {email: $email}) {
    email
    image
    id
  }
}
    `;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useGetUserQuery(baseOptions: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const GetUserByIdDocument = gql`
    query getUserById($id: String!) {
  user(where: {id: $id}) {
    email
    image
    id
    description
    name
  }
}
    `;

/**
 * __useGetUserByIdQuery__
 *
 * To run a query within a React component, call `useGetUserByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserByIdQuery(baseOptions: Apollo.QueryHookOptions<GetUserByIdQuery, GetUserByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserByIdQuery, GetUserByIdQueryVariables>(GetUserByIdDocument, options);
      }
export function useGetUserByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserByIdQuery, GetUserByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserByIdQuery, GetUserByIdQueryVariables>(GetUserByIdDocument, options);
        }
export type GetUserByIdQueryHookResult = ReturnType<typeof useGetUserByIdQuery>;
export type GetUserByIdLazyQueryHookResult = ReturnType<typeof useGetUserByIdLazyQuery>;
export type GetUserByIdQueryResult = Apollo.QueryResult<GetUserByIdQuery, GetUserByIdQueryVariables>;
export const GetUsersDocument = gql`
    query getUsers {
  users {
    id
  }
}
    `;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
      }
export function useGetUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersQueryResult = Apollo.QueryResult<GetUsersQuery, GetUsersQueryVariables>;
export const AddClientDocument = gql`
    mutation addClient($name: String!) {
  createOneClient(data: {name: $name}) {
    id
    name
  }
}
    `;
export type AddClientMutationFn = Apollo.MutationFunction<AddClientMutation, AddClientMutationVariables>;

/**
 * __useAddClientMutation__
 *
 * To run a mutation, you first call `useAddClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addClientMutation, { data, loading, error }] = useAddClientMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useAddClientMutation(baseOptions?: Apollo.MutationHookOptions<AddClientMutation, AddClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddClientMutation, AddClientMutationVariables>(AddClientDocument, options);
      }
export type AddClientMutationHookResult = ReturnType<typeof useAddClientMutation>;
export type AddClientMutationResult = Apollo.MutationResult<AddClientMutation>;
export type AddClientMutationOptions = Apollo.BaseMutationOptions<AddClientMutation, AddClientMutationVariables>;
export const DeleteClientDocument = gql`
    mutation deleteClient($id: String!) {
  deleteOneClient(where: {id: $id}) {
    id
    name
  }
}
    `;
export type DeleteClientMutationFn = Apollo.MutationFunction<DeleteClientMutation, DeleteClientMutationVariables>;

/**
 * __useDeleteClientMutation__
 *
 * To run a mutation, you first call `useDeleteClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClientMutation, { data, loading, error }] = useDeleteClientMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteClientMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClientMutation, DeleteClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteClientMutation, DeleteClientMutationVariables>(DeleteClientDocument, options);
      }
export type DeleteClientMutationHookResult = ReturnType<typeof useDeleteClientMutation>;
export type DeleteClientMutationResult = Apollo.MutationResult<DeleteClientMutation>;
export type DeleteClientMutationOptions = Apollo.BaseMutationOptions<DeleteClientMutation, DeleteClientMutationVariables>;
export const DisconnectInstagramHandleFromClientDocument = gql`
    mutation disconnectInstagramHandleFromClient($handleId: String!, $clientId: String!) {
  updateOneIgHandle(
    data: {igClients: {disconnect: {id: $clientId}}}
    where: {id: $handleId}
  ) {
    id
    igClients {
      id
      name
    }
    handle
  }
}
    `;
export type DisconnectInstagramHandleFromClientMutationFn = Apollo.MutationFunction<DisconnectInstagramHandleFromClientMutation, DisconnectInstagramHandleFromClientMutationVariables>;

/**
 * __useDisconnectInstagramHandleFromClientMutation__
 *
 * To run a mutation, you first call `useDisconnectInstagramHandleFromClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectInstagramHandleFromClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectInstagramHandleFromClientMutation, { data, loading, error }] = useDisconnectInstagramHandleFromClientMutation({
 *   variables: {
 *      handleId: // value for 'handleId'
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useDisconnectInstagramHandleFromClientMutation(baseOptions?: Apollo.MutationHookOptions<DisconnectInstagramHandleFromClientMutation, DisconnectInstagramHandleFromClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisconnectInstagramHandleFromClientMutation, DisconnectInstagramHandleFromClientMutationVariables>(DisconnectInstagramHandleFromClientDocument, options);
      }
export type DisconnectInstagramHandleFromClientMutationHookResult = ReturnType<typeof useDisconnectInstagramHandleFromClientMutation>;
export type DisconnectInstagramHandleFromClientMutationResult = Apollo.MutationResult<DisconnectInstagramHandleFromClientMutation>;
export type DisconnectInstagramHandleFromClientMutationOptions = Apollo.BaseMutationOptions<DisconnectInstagramHandleFromClientMutation, DisconnectInstagramHandleFromClientMutationVariables>;
export const GetClientDocument = gql`
    query getClient($id: String!) {
  client(where: {id: $id}) {
    id
    archived
    archivedAt
    name
    tags {
      id
      name
      archived
      archivedAt
    }
    igHandles(orderBy: {handle: asc}) {
      id
      handle
    }
  }
}
    `;

/**
 * __useGetClientQuery__
 *
 * To run a query within a React component, call `useGetClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetClientQuery(baseOptions: Apollo.QueryHookOptions<GetClientQuery, GetClientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientQuery, GetClientQueryVariables>(GetClientDocument, options);
      }
export function useGetClientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientQuery, GetClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientQuery, GetClientQueryVariables>(GetClientDocument, options);
        }
export type GetClientQueryHookResult = ReturnType<typeof useGetClientQuery>;
export type GetClientLazyQueryHookResult = ReturnType<typeof useGetClientLazyQuery>;
export type GetClientQueryResult = Apollo.QueryResult<GetClientQuery, GetClientQueryVariables>;
export const GetClientUnsetStoriesDocument = gql`
    query getClientUnsetStories($handleIds: [String!]!) {
  igAssets(
    where: {AND: [{igHandle: {is: {id: {in: $handleIds}}}}, {status: {equals: UNSET}}]}
  ) {
    id
  }
}
    `;

/**
 * __useGetClientUnsetStoriesQuery__
 *
 * To run a query within a React component, call `useGetClientUnsetStoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientUnsetStoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientUnsetStoriesQuery({
 *   variables: {
 *      handleIds: // value for 'handleIds'
 *   },
 * });
 */
export function useGetClientUnsetStoriesQuery(baseOptions: Apollo.QueryHookOptions<GetClientUnsetStoriesQuery, GetClientUnsetStoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientUnsetStoriesQuery, GetClientUnsetStoriesQueryVariables>(GetClientUnsetStoriesDocument, options);
      }
export function useGetClientUnsetStoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientUnsetStoriesQuery, GetClientUnsetStoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientUnsetStoriesQuery, GetClientUnsetStoriesQueryVariables>(GetClientUnsetStoriesDocument, options);
        }
export type GetClientUnsetStoriesQueryHookResult = ReturnType<typeof useGetClientUnsetStoriesQuery>;
export type GetClientUnsetStoriesLazyQueryHookResult = ReturnType<typeof useGetClientUnsetStoriesLazyQuery>;
export type GetClientUnsetStoriesQueryResult = Apollo.QueryResult<GetClientUnsetStoriesQuery, GetClientUnsetStoriesQueryVariables>;
export const GetClientsDocument = gql`
    query getClients($showArchived: Boolean!) {
  clients(where: {archived: {equals: $showArchived}}, orderBy: {updatedAt: desc}) {
    id
    name
    igHandles {
      id
    }
  }
}
    `;

/**
 * __useGetClientsQuery__
 *
 * To run a query within a React component, call `useGetClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientsQuery({
 *   variables: {
 *      showArchived: // value for 'showArchived'
 *   },
 * });
 */
export function useGetClientsQuery(baseOptions: Apollo.QueryHookOptions<GetClientsQuery, GetClientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientsQuery, GetClientsQueryVariables>(GetClientsDocument, options);
      }
export function useGetClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientsQuery, GetClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientsQuery, GetClientsQueryVariables>(GetClientsDocument, options);
        }
export type GetClientsQueryHookResult = ReturnType<typeof useGetClientsQuery>;
export type GetClientsLazyQueryHookResult = ReturnType<typeof useGetClientsLazyQuery>;
export type GetClientsQueryResult = Apollo.QueryResult<GetClientsQuery, GetClientsQueryVariables>;
export const GetInstagramHandlesForClientDocument = gql`
    query getInstagramHandlesForClient($clientId: String!) {
  igHandles(where: {igClients: {some: {id: {equals: $clientId}}}}) {
    id
    handle
  }
}
    `;

/**
 * __useGetInstagramHandlesForClientQuery__
 *
 * To run a query within a React component, call `useGetInstagramHandlesForClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstagramHandlesForClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstagramHandlesForClientQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useGetInstagramHandlesForClientQuery(baseOptions: Apollo.QueryHookOptions<GetInstagramHandlesForClientQuery, GetInstagramHandlesForClientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstagramHandlesForClientQuery, GetInstagramHandlesForClientQueryVariables>(GetInstagramHandlesForClientDocument, options);
      }
export function useGetInstagramHandlesForClientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInstagramHandlesForClientQuery, GetInstagramHandlesForClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstagramHandlesForClientQuery, GetInstagramHandlesForClientQueryVariables>(GetInstagramHandlesForClientDocument, options);
        }
export type GetInstagramHandlesForClientQueryHookResult = ReturnType<typeof useGetInstagramHandlesForClientQuery>;
export type GetInstagramHandlesForClientLazyQueryHookResult = ReturnType<typeof useGetInstagramHandlesForClientLazyQuery>;
export type GetInstagramHandlesForClientQueryResult = Apollo.QueryResult<GetInstagramHandlesForClientQuery, GetInstagramHandlesForClientQueryVariables>;
export const StillFollowingHandlesDocument = gql`
    query stillFollowingHandles {
  igHandles(
    where: {AND: [{igAssets: {some: {}}}, {igClients: {some: {}}}, {igClients: {every: {archived: {equals: true}}}}]}
  ) {
    id
    handle
    followers
    igClients {
      id
      name
    }
  }
}
    `;

/**
 * __useStillFollowingHandlesQuery__
 *
 * To run a query within a React component, call `useStillFollowingHandlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStillFollowingHandlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStillFollowingHandlesQuery({
 *   variables: {
 *   },
 * });
 */
export function useStillFollowingHandlesQuery(baseOptions?: Apollo.QueryHookOptions<StillFollowingHandlesQuery, StillFollowingHandlesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StillFollowingHandlesQuery, StillFollowingHandlesQueryVariables>(StillFollowingHandlesDocument, options);
      }
export function useStillFollowingHandlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StillFollowingHandlesQuery, StillFollowingHandlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StillFollowingHandlesQuery, StillFollowingHandlesQueryVariables>(StillFollowingHandlesDocument, options);
        }
export type StillFollowingHandlesQueryHookResult = ReturnType<typeof useStillFollowingHandlesQuery>;
export type StillFollowingHandlesLazyQueryHookResult = ReturnType<typeof useStillFollowingHandlesLazyQuery>;
export type StillFollowingHandlesQueryResult = Apollo.QueryResult<StillFollowingHandlesQuery, StillFollowingHandlesQueryVariables>;
export const UnassignedHandlesDocument = gql`
    query unassignedHandles {
  igHandles(where: {AND: [{igClients: {none: {}}}, {igAssets: {some: {}}}]}) {
    id
    handle
    followers
  }
}
    `;

/**
 * __useUnassignedHandlesQuery__
 *
 * To run a query within a React component, call `useUnassignedHandlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnassignedHandlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnassignedHandlesQuery({
 *   variables: {
 *   },
 * });
 */
export function useUnassignedHandlesQuery(baseOptions?: Apollo.QueryHookOptions<UnassignedHandlesQuery, UnassignedHandlesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UnassignedHandlesQuery, UnassignedHandlesQueryVariables>(UnassignedHandlesDocument, options);
      }
export function useUnassignedHandlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UnassignedHandlesQuery, UnassignedHandlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UnassignedHandlesQuery, UnassignedHandlesQueryVariables>(UnassignedHandlesDocument, options);
        }
export type UnassignedHandlesQueryHookResult = ReturnType<typeof useUnassignedHandlesQuery>;
export type UnassignedHandlesLazyQueryHookResult = ReturnType<typeof useUnassignedHandlesLazyQuery>;
export type UnassignedHandlesQueryResult = Apollo.QueryResult<UnassignedHandlesQuery, UnassignedHandlesQueryVariables>;
export const UpdateClientArchivedDocument = gql`
    mutation updateClientArchived($clientId: String!, $isArchived: Boolean!, $archivedAt: DateTime!) {
  updateOneClient(
    data: {archived: {set: $isArchived}, archivedAt: {set: $archivedAt}}
    where: {id: $clientId}
  ) {
    id
    archivedAt
    archived
  }
}
    `;
export type UpdateClientArchivedMutationFn = Apollo.MutationFunction<UpdateClientArchivedMutation, UpdateClientArchivedMutationVariables>;

/**
 * __useUpdateClientArchivedMutation__
 *
 * To run a mutation, you first call `useUpdateClientArchivedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientArchivedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientArchivedMutation, { data, loading, error }] = useUpdateClientArchivedMutation({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      isArchived: // value for 'isArchived'
 *      archivedAt: // value for 'archivedAt'
 *   },
 * });
 */
export function useUpdateClientArchivedMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientArchivedMutation, UpdateClientArchivedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientArchivedMutation, UpdateClientArchivedMutationVariables>(UpdateClientArchivedDocument, options);
      }
export type UpdateClientArchivedMutationHookResult = ReturnType<typeof useUpdateClientArchivedMutation>;
export type UpdateClientArchivedMutationResult = Apollo.MutationResult<UpdateClientArchivedMutation>;
export type UpdateClientArchivedMutationOptions = Apollo.BaseMutationOptions<UpdateClientArchivedMutation, UpdateClientArchivedMutationVariables>;
export const UpdateClientNameDocument = gql`
    mutation updateClientName($id: String!, $name: String!) {
  updateOneClient(data: {name: {set: $name}}, where: {id: $id}) {
    id
  }
}
    `;
export type UpdateClientNameMutationFn = Apollo.MutationFunction<UpdateClientNameMutation, UpdateClientNameMutationVariables>;

/**
 * __useUpdateClientNameMutation__
 *
 * To run a mutation, you first call `useUpdateClientNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientNameMutation, { data, loading, error }] = useUpdateClientNameMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateClientNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientNameMutation, UpdateClientNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientNameMutation, UpdateClientNameMutationVariables>(UpdateClientNameDocument, options);
      }
export type UpdateClientNameMutationHookResult = ReturnType<typeof useUpdateClientNameMutation>;
export type UpdateClientNameMutationResult = Apollo.MutationResult<UpdateClientNameMutation>;
export type UpdateClientNameMutationOptions = Apollo.BaseMutationOptions<UpdateClientNameMutation, UpdateClientNameMutationVariables>;
export const UpsertInstagramHandleDocument = gql`
    mutation upsertInstagramHandle($name: String!, $clientId: String!) {
  upsertOneIgHandle(
    create: {handle: $name, igClients: {connect: {id: $clientId}}}
    update: {igClients: {connect: {id: $clientId}}}
    where: {handle: $name}
  ) {
    id
    handle
  }
}
    `;
export type UpsertInstagramHandleMutationFn = Apollo.MutationFunction<UpsertInstagramHandleMutation, UpsertInstagramHandleMutationVariables>;

/**
 * __useUpsertInstagramHandleMutation__
 *
 * To run a mutation, you first call `useUpsertInstagramHandleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertInstagramHandleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertInstagramHandleMutation, { data, loading, error }] = useUpsertInstagramHandleMutation({
 *   variables: {
 *      name: // value for 'name'
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useUpsertInstagramHandleMutation(baseOptions?: Apollo.MutationHookOptions<UpsertInstagramHandleMutation, UpsertInstagramHandleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertInstagramHandleMutation, UpsertInstagramHandleMutationVariables>(UpsertInstagramHandleDocument, options);
      }
export type UpsertInstagramHandleMutationHookResult = ReturnType<typeof useUpsertInstagramHandleMutation>;
export type UpsertInstagramHandleMutationResult = Apollo.MutationResult<UpsertInstagramHandleMutation>;
export type UpsertInstagramHandleMutationOptions = Apollo.BaseMutationOptions<UpsertInstagramHandleMutation, UpsertInstagramHandleMutationVariables>;
export const GetAllClientsDocument = gql`
    query getAllClients {
  clients {
    id
    name
  }
}
    `;

/**
 * __useGetAllClientsQuery__
 *
 * To run a query within a React component, call `useGetAllClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllClientsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllClientsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllClientsQuery, GetAllClientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllClientsQuery, GetAllClientsQueryVariables>(GetAllClientsDocument, options);
      }
export function useGetAllClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllClientsQuery, GetAllClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllClientsQuery, GetAllClientsQueryVariables>(GetAllClientsDocument, options);
        }
export type GetAllClientsQueryHookResult = ReturnType<typeof useGetAllClientsQuery>;
export type GetAllClientsLazyQueryHookResult = ReturnType<typeof useGetAllClientsLazyQuery>;
export type GetAllClientsQueryResult = Apollo.QueryResult<GetAllClientsQuery, GetAllClientsQueryVariables>;
export const GetAllHandlesDocument = gql`
    query getAllHandles {
  igHandles {
    id
    handle
  }
}
    `;

/**
 * __useGetAllHandlesQuery__
 *
 * To run a query within a React component, call `useGetAllHandlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllHandlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllHandlesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllHandlesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllHandlesQuery, GetAllHandlesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllHandlesQuery, GetAllHandlesQueryVariables>(GetAllHandlesDocument, options);
      }
export function useGetAllHandlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllHandlesQuery, GetAllHandlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllHandlesQuery, GetAllHandlesQueryVariables>(GetAllHandlesDocument, options);
        }
export type GetAllHandlesQueryHookResult = ReturnType<typeof useGetAllHandlesQuery>;
export type GetAllHandlesLazyQueryHookResult = ReturnType<typeof useGetAllHandlesLazyQuery>;
export type GetAllHandlesQueryResult = Apollo.QueryResult<GetAllHandlesQuery, GetAllHandlesQueryVariables>;
export const GetAllTagsDocument = gql`
    query getAllTags {
  tags(
    where: {AND: {client: {is: {archived: {not: {equals: true}}}}, archived: {not: {equals: true}}}}
  ) {
    id
    name
  }
}
    `;

/**
 * __useGetAllTagsQuery__
 *
 * To run a query within a React component, call `useGetAllTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllTagsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllTagsQuery, GetAllTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllTagsQuery, GetAllTagsQueryVariables>(GetAllTagsDocument, options);
      }
export function useGetAllTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllTagsQuery, GetAllTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllTagsQuery, GetAllTagsQueryVariables>(GetAllTagsDocument, options);
        }
export type GetAllTagsQueryHookResult = ReturnType<typeof useGetAllTagsQuery>;
export type GetAllTagsLazyQueryHookResult = ReturnType<typeof useGetAllTagsLazyQuery>;
export type GetAllTagsQueryResult = Apollo.QueryResult<GetAllTagsQuery, GetAllTagsQueryVariables>;
export const GetAssetsDocument = gql`
    query getAssets($where: IgAssetWhereInput!, $take: Int!, $skip: Int!) {
  igAssets(where: $where, orderBy: {createdAt: desc}, take: $take, skip: $skip) {
    id
    createdAt
    screenshotUrl
    proofUrl
    videoUrl
    igId
    accountUsed
    status
    igHandle {
      handle
      followers
    }
    tag {
      id
      name
    }
  }
}
    `;

/**
 * __useGetAssetsQuery__
 *
 * To run a query within a React component, call `useGetAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssetsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useGetAssetsQuery(baseOptions: Apollo.QueryHookOptions<GetAssetsQuery, GetAssetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssetsQuery, GetAssetsQueryVariables>(GetAssetsDocument, options);
      }
export function useGetAssetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssetsQuery, GetAssetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssetsQuery, GetAssetsQueryVariables>(GetAssetsDocument, options);
        }
export type GetAssetsQueryHookResult = ReturnType<typeof useGetAssetsQuery>;
export type GetAssetsLazyQueryHookResult = ReturnType<typeof useGetAssetsLazyQuery>;
export type GetAssetsQueryResult = Apollo.QueryResult<GetAssetsQuery, GetAssetsQueryVariables>;
export const GetAssetsCountDocument = gql`
    query getAssetsCount($where: IgAssetWhereInput!) {
  igAssets(where: $where) {
    id
  }
}
    `;

/**
 * __useGetAssetsCountQuery__
 *
 * To run a query within a React component, call `useGetAssetsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssetsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssetsCountQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetAssetsCountQuery(baseOptions: Apollo.QueryHookOptions<GetAssetsCountQuery, GetAssetsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssetsCountQuery, GetAssetsCountQueryVariables>(GetAssetsCountDocument, options);
      }
export function useGetAssetsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssetsCountQuery, GetAssetsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssetsCountQuery, GetAssetsCountQueryVariables>(GetAssetsCountDocument, options);
        }
export type GetAssetsCountQueryHookResult = ReturnType<typeof useGetAssetsCountQuery>;
export type GetAssetsCountLazyQueryHookResult = ReturnType<typeof useGetAssetsCountLazyQuery>;
export type GetAssetsCountQueryResult = Apollo.QueryResult<GetAssetsCountQuery, GetAssetsCountQueryVariables>;
export const GetHandlesForClientsDocument = gql`
    query getHandlesForClients($clientNames: [String!]!) {
  clients(where: {name: {in: $clientNames}}) {
    igHandles {
      id
    }
  }
}
    `;

/**
 * __useGetHandlesForClientsQuery__
 *
 * To run a query within a React component, call `useGetHandlesForClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHandlesForClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHandlesForClientsQuery({
 *   variables: {
 *      clientNames: // value for 'clientNames'
 *   },
 * });
 */
export function useGetHandlesForClientsQuery(baseOptions: Apollo.QueryHookOptions<GetHandlesForClientsQuery, GetHandlesForClientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHandlesForClientsQuery, GetHandlesForClientsQueryVariables>(GetHandlesForClientsDocument, options);
      }
export function useGetHandlesForClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHandlesForClientsQuery, GetHandlesForClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHandlesForClientsQuery, GetHandlesForClientsQueryVariables>(GetHandlesForClientsDocument, options);
        }
export type GetHandlesForClientsQueryHookResult = ReturnType<typeof useGetHandlesForClientsQuery>;
export type GetHandlesForClientsLazyQueryHookResult = ReturnType<typeof useGetHandlesForClientsLazyQuery>;
export type GetHandlesForClientsQueryResult = Apollo.QueryResult<GetHandlesForClientsQuery, GetHandlesForClientsQueryVariables>;
export const SetAssetApprovedDocument = gql`
    mutation setAssetApproved($id: String!, $tags: [TagWhereUniqueInput!]!) {
  updateOneIgAsset(
    data: {tag: {set: $tags}, status: {set: APPROVED}}
    where: {id: $id}
  ) {
    id
    igId
    status
    tag {
      id
      name
    }
  }
}
    `;
export type SetAssetApprovedMutationFn = Apollo.MutationFunction<SetAssetApprovedMutation, SetAssetApprovedMutationVariables>;

/**
 * __useSetAssetApprovedMutation__
 *
 * To run a mutation, you first call `useSetAssetApprovedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAssetApprovedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAssetApprovedMutation, { data, loading, error }] = useSetAssetApprovedMutation({
 *   variables: {
 *      id: // value for 'id'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useSetAssetApprovedMutation(baseOptions?: Apollo.MutationHookOptions<SetAssetApprovedMutation, SetAssetApprovedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetAssetApprovedMutation, SetAssetApprovedMutationVariables>(SetAssetApprovedDocument, options);
      }
export type SetAssetApprovedMutationHookResult = ReturnType<typeof useSetAssetApprovedMutation>;
export type SetAssetApprovedMutationResult = Apollo.MutationResult<SetAssetApprovedMutation>;
export type SetAssetApprovedMutationOptions = Apollo.BaseMutationOptions<SetAssetApprovedMutation, SetAssetApprovedMutationVariables>;
export const SetAssetStatusDocument = gql`
    mutation setAssetStatus($status: StatusType!, $id: String!) {
  updateOneIgAsset(data: {status: {set: $status}}, where: {id: $id}) {
    id
    igId
    status
  }
}
    `;
export type SetAssetStatusMutationFn = Apollo.MutationFunction<SetAssetStatusMutation, SetAssetStatusMutationVariables>;

/**
 * __useSetAssetStatusMutation__
 *
 * To run a mutation, you first call `useSetAssetStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAssetStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAssetStatusMutation, { data, loading, error }] = useSetAssetStatusMutation({
 *   variables: {
 *      status: // value for 'status'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetAssetStatusMutation(baseOptions?: Apollo.MutationHookOptions<SetAssetStatusMutation, SetAssetStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetAssetStatusMutation, SetAssetStatusMutationVariables>(SetAssetStatusDocument, options);
      }
export type SetAssetStatusMutationHookResult = ReturnType<typeof useSetAssetStatusMutation>;
export type SetAssetStatusMutationResult = Apollo.MutationResult<SetAssetStatusMutation>;
export type SetAssetStatusMutationOptions = Apollo.BaseMutationOptions<SetAssetStatusMutation, SetAssetStatusMutationVariables>;
export const SetAssetTagsDocument = gql`
    mutation setAssetTags($id: String!, $tags: [TagWhereUniqueInput!]!) {
  updateOneIgAsset(data: {tag: {set: $tags}}, where: {id: $id}) {
    id
    igId
    status
    tag {
      id
      name
    }
  }
}
    `;
export type SetAssetTagsMutationFn = Apollo.MutationFunction<SetAssetTagsMutation, SetAssetTagsMutationVariables>;

/**
 * __useSetAssetTagsMutation__
 *
 * To run a mutation, you first call `useSetAssetTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAssetTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAssetTagsMutation, { data, loading, error }] = useSetAssetTagsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useSetAssetTagsMutation(baseOptions?: Apollo.MutationHookOptions<SetAssetTagsMutation, SetAssetTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetAssetTagsMutation, SetAssetTagsMutationVariables>(SetAssetTagsDocument, options);
      }
export type SetAssetTagsMutationHookResult = ReturnType<typeof useSetAssetTagsMutation>;
export type SetAssetTagsMutationResult = Apollo.MutationResult<SetAssetTagsMutation>;
export type SetAssetTagsMutationOptions = Apollo.BaseMutationOptions<SetAssetTagsMutation, SetAssetTagsMutationVariables>;
export const AddTagDocument = gql`
    mutation addTag($name: String!, $clientId: String!) {
  createOneTag(data: {name: $name, client: {connect: {id: $clientId}}}) {
    id
    name
    clientId
  }
}
    `;
export type AddTagMutationFn = Apollo.MutationFunction<AddTagMutation, AddTagMutationVariables>;

/**
 * __useAddTagMutation__
 *
 * To run a mutation, you first call `useAddTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTagMutation, { data, loading, error }] = useAddTagMutation({
 *   variables: {
 *      name: // value for 'name'
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useAddTagMutation(baseOptions?: Apollo.MutationHookOptions<AddTagMutation, AddTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTagMutation, AddTagMutationVariables>(AddTagDocument, options);
      }
export type AddTagMutationHookResult = ReturnType<typeof useAddTagMutation>;
export type AddTagMutationResult = Apollo.MutationResult<AddTagMutation>;
export type AddTagMutationOptions = Apollo.BaseMutationOptions<AddTagMutation, AddTagMutationVariables>;
export const GetApprovedAssetsForTagDocument = gql`
    query getApprovedAssetsForTag($id: String!) {
  igAssets(
    where: {AND: {tag: {some: {id: {equals: $id}}}}, status: {equals: APPROVED}}
  ) {
    id
  }
}
    `;

/**
 * __useGetApprovedAssetsForTagQuery__
 *
 * To run a query within a React component, call `useGetApprovedAssetsForTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApprovedAssetsForTagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApprovedAssetsForTagQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetApprovedAssetsForTagQuery(baseOptions: Apollo.QueryHookOptions<GetApprovedAssetsForTagQuery, GetApprovedAssetsForTagQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApprovedAssetsForTagQuery, GetApprovedAssetsForTagQueryVariables>(GetApprovedAssetsForTagDocument, options);
      }
export function useGetApprovedAssetsForTagLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApprovedAssetsForTagQuery, GetApprovedAssetsForTagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApprovedAssetsForTagQuery, GetApprovedAssetsForTagQueryVariables>(GetApprovedAssetsForTagDocument, options);
        }
export type GetApprovedAssetsForTagQueryHookResult = ReturnType<typeof useGetApprovedAssetsForTagQuery>;
export type GetApprovedAssetsForTagLazyQueryHookResult = ReturnType<typeof useGetApprovedAssetsForTagLazyQuery>;
export type GetApprovedAssetsForTagQueryResult = Apollo.QueryResult<GetApprovedAssetsForTagQuery, GetApprovedAssetsForTagQueryVariables>;
export const GetTagDocument = gql`
    query getTag($id: String!) {
  tag(where: {id: $id}) {
    id
    name
    archived
    archivedAt
  }
}
    `;

/**
 * __useGetTagQuery__
 *
 * To run a query within a React component, call `useGetTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTagQuery(baseOptions: Apollo.QueryHookOptions<GetTagQuery, GetTagQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTagQuery, GetTagQueryVariables>(GetTagDocument, options);
      }
export function useGetTagLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTagQuery, GetTagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTagQuery, GetTagQueryVariables>(GetTagDocument, options);
        }
export type GetTagQueryHookResult = ReturnType<typeof useGetTagQuery>;
export type GetTagLazyQueryHookResult = ReturnType<typeof useGetTagLazyQuery>;
export type GetTagQueryResult = Apollo.QueryResult<GetTagQuery, GetTagQueryVariables>;
export const GetTagsDocument = gql`
    query getTags {
  tags {
    id
    name
  }
}
    `;

/**
 * __useGetTagsQuery__
 *
 * To run a query within a React component, call `useGetTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTagsQuery(baseOptions?: Apollo.QueryHookOptions<GetTagsQuery, GetTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTagsQuery, GetTagsQueryVariables>(GetTagsDocument, options);
      }
export function useGetTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTagsQuery, GetTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTagsQuery, GetTagsQueryVariables>(GetTagsDocument, options);
        }
export type GetTagsQueryHookResult = ReturnType<typeof useGetTagsQuery>;
export type GetTagsLazyQueryHookResult = ReturnType<typeof useGetTagsLazyQuery>;
export type GetTagsQueryResult = Apollo.QueryResult<GetTagsQuery, GetTagsQueryVariables>;
export const RemoveTagDocument = gql`
    mutation removeTag($id: String!) {
  deleteOneTag(where: {id: $id}) {
    id
  }
}
    `;
export type RemoveTagMutationFn = Apollo.MutationFunction<RemoveTagMutation, RemoveTagMutationVariables>;

/**
 * __useRemoveTagMutation__
 *
 * To run a mutation, you first call `useRemoveTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTagMutation, { data, loading, error }] = useRemoveTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveTagMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTagMutation, RemoveTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveTagMutation, RemoveTagMutationVariables>(RemoveTagDocument, options);
      }
export type RemoveTagMutationHookResult = ReturnType<typeof useRemoveTagMutation>;
export type RemoveTagMutationResult = Apollo.MutationResult<RemoveTagMutation>;
export type RemoveTagMutationOptions = Apollo.BaseMutationOptions<RemoveTagMutation, RemoveTagMutationVariables>;
export const UpdateTagDocument = gql`
    mutation updateTag($id: String!, $name: String!) {
  updateOneTag(data: {name: {set: $name}}, where: {id: $id}) {
    id
  }
}
    `;
export type UpdateTagMutationFn = Apollo.MutationFunction<UpdateTagMutation, UpdateTagMutationVariables>;

/**
 * __useUpdateTagMutation__
 *
 * To run a mutation, you first call `useUpdateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTagMutation, { data, loading, error }] = useUpdateTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateTagMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTagMutation, UpdateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTagMutation, UpdateTagMutationVariables>(UpdateTagDocument, options);
      }
export type UpdateTagMutationHookResult = ReturnType<typeof useUpdateTagMutation>;
export type UpdateTagMutationResult = Apollo.MutationResult<UpdateTagMutation>;
export type UpdateTagMutationOptions = Apollo.BaseMutationOptions<UpdateTagMutation, UpdateTagMutationVariables>;
export const UpdateTagArchivedDocument = gql`
    mutation updateTagArchived($tagId: String!, $isArchived: Boolean!, $archivedAt: DateTime!) {
  updateOneTag(
    data: {archived: {set: $isArchived}, archivedAt: {set: $archivedAt}}
    where: {id: $tagId}
  ) {
    id
    archivedAt
    archived
  }
}
    `;
export type UpdateTagArchivedMutationFn = Apollo.MutationFunction<UpdateTagArchivedMutation, UpdateTagArchivedMutationVariables>;

/**
 * __useUpdateTagArchivedMutation__
 *
 * To run a mutation, you first call `useUpdateTagArchivedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTagArchivedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTagArchivedMutation, { data, loading, error }] = useUpdateTagArchivedMutation({
 *   variables: {
 *      tagId: // value for 'tagId'
 *      isArchived: // value for 'isArchived'
 *      archivedAt: // value for 'archivedAt'
 *   },
 * });
 */
export function useUpdateTagArchivedMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTagArchivedMutation, UpdateTagArchivedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTagArchivedMutation, UpdateTagArchivedMutationVariables>(UpdateTagArchivedDocument, options);
      }
export type UpdateTagArchivedMutationHookResult = ReturnType<typeof useUpdateTagArchivedMutation>;
export type UpdateTagArchivedMutationResult = Apollo.MutationResult<UpdateTagArchivedMutation>;
export type UpdateTagArchivedMutationOptions = Apollo.BaseMutationOptions<UpdateTagArchivedMutation, UpdateTagArchivedMutationVariables>;
export const AddAllowedEmailDocument = gql`
    mutation addAllowedEmail($email: String!) {
  createOneDevAllowedEmail(data: {email: $email}) {
    id
    email
  }
}
    `;
export type AddAllowedEmailMutationFn = Apollo.MutationFunction<AddAllowedEmailMutation, AddAllowedEmailMutationVariables>;

/**
 * __useAddAllowedEmailMutation__
 *
 * To run a mutation, you first call `useAddAllowedEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAllowedEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAllowedEmailMutation, { data, loading, error }] = useAddAllowedEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useAddAllowedEmailMutation(baseOptions?: Apollo.MutationHookOptions<AddAllowedEmailMutation, AddAllowedEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAllowedEmailMutation, AddAllowedEmailMutationVariables>(AddAllowedEmailDocument, options);
      }
export type AddAllowedEmailMutationHookResult = ReturnType<typeof useAddAllowedEmailMutation>;
export type AddAllowedEmailMutationResult = Apollo.MutationResult<AddAllowedEmailMutation>;
export type AddAllowedEmailMutationOptions = Apollo.BaseMutationOptions<AddAllowedEmailMutation, AddAllowedEmailMutationVariables>;
export const GetAllowedEmailsDocument = gql`
    query getAllowedEmails {
  devAllowedEmails {
    id
    email
  }
}
    `;

/**
 * __useGetAllowedEmailsQuery__
 *
 * To run a query within a React component, call `useGetAllowedEmailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllowedEmailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllowedEmailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllowedEmailsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllowedEmailsQuery, GetAllowedEmailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllowedEmailsQuery, GetAllowedEmailsQueryVariables>(GetAllowedEmailsDocument, options);
      }
export function useGetAllowedEmailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllowedEmailsQuery, GetAllowedEmailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllowedEmailsQuery, GetAllowedEmailsQueryVariables>(GetAllowedEmailsDocument, options);
        }
export type GetAllowedEmailsQueryHookResult = ReturnType<typeof useGetAllowedEmailsQuery>;
export type GetAllowedEmailsLazyQueryHookResult = ReturnType<typeof useGetAllowedEmailsLazyQuery>;
export type GetAllowedEmailsQueryResult = Apollo.QueryResult<GetAllowedEmailsQuery, GetAllowedEmailsQueryVariables>;
export const RemoveAllowedEmailDocument = gql`
    mutation removeAllowedEmail($email: String!) {
  deleteOneDevAllowedEmail(where: {email: $email}) {
    id
  }
}
    `;
export type RemoveAllowedEmailMutationFn = Apollo.MutationFunction<RemoveAllowedEmailMutation, RemoveAllowedEmailMutationVariables>;

/**
 * __useRemoveAllowedEmailMutation__
 *
 * To run a mutation, you first call `useRemoveAllowedEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAllowedEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAllowedEmailMutation, { data, loading, error }] = useRemoveAllowedEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useRemoveAllowedEmailMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAllowedEmailMutation, RemoveAllowedEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAllowedEmailMutation, RemoveAllowedEmailMutationVariables>(RemoveAllowedEmailDocument, options);
      }
export type RemoveAllowedEmailMutationHookResult = ReturnType<typeof useRemoveAllowedEmailMutation>;
export type RemoveAllowedEmailMutationResult = Apollo.MutationResult<RemoveAllowedEmailMutation>;
export type RemoveAllowedEmailMutationOptions = Apollo.BaseMutationOptions<RemoveAllowedEmailMutation, RemoveAllowedEmailMutationVariables>;